<template>
    <div>

        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <h2 style="font-size: 40px; font-weight: 700; line-height: 48px; " class="mb-0 mt-5 align-items-center">Client Management <i @click="openHelpModal(0)" class="fa fa-question-circle" style="cursor: pointer; margin-left: 20px;opacity: 0.8;font-size: 25px;"></i>
                </h2>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 pt-4">
                <p>On this page, you can add, edit, or remove your clients.<br />When a new client is added, the system
                    will email them directions for completing their profile, reporting preferences, and payment
                    settings.
                    <br /> Make sure to also add the client's campaigns under the campaign tab for each desired service.
                </p>
            </div>
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 pt-4">
               <div style="display:inline-block">
                <a href="#" @click="modals.helpguide = true" style="display:inline-flex"><i class="far fa-play-circle" style="font-size:21px;padding-right:5px"></i> <span>here for more information.</span></a>
               </div>
            </div> -->
        </div>
        <div class="pt-3 pb-3">&nbsp;</div>

        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <card>
                    <div class="row">
                        <div class="col-12">
                            <div class="row" style="align-items: baseline;">
                            <div class="col-lg-5 col-md-12 col-sm-12">
                                <div>
                                    <base-input>
                                        <el-input type="text" class="mb-3 search-input input__client__management" clearable
                                            prefix-icon="el-icon-search" placeholder="Search Client" v-model="searchQuery"
                                            aria-controls="datatables" @keyup.native.enter="searchKeyWord"
                                            @clear="searchKeyWord">
                                        </el-input>
                                    </base-input>
                                </div>
                            </div>  
                            <div class="col-lg-7 col-md-12 col-sm-12" style="display: flex; justify-content: flex-end; align-items: center; flex-wrap: wrap;">
                                <div style="padding-inline: 4px;">
                                    <el-dropdown ref="dropdown" @visible-change="handleVisibleChange">
                                        <span>
                                        <base-button class="m-0 ml-2" size="sm" style="height:40px">
                                            <i class="fa-solid fa-filter"></i> Filters
                                        </base-button>
                                        </span>

                                        <el-dropdown-menu slot="dropdown" style="width: 240px;"  :class="{ 'dropdown-hidden': !dropdownVisible }" @click.native.stop>
                                        <div class='ml-4 mr-4'>
                                            <el-collapse value="Card Status" style="border: none;" v-if="this.$store.getters.userData.manual_bill === 'F'">
                                            <el-collapse-item title="Card Status" name="Card Status">
                                                <div style="padding-left:8px;" >
                                                <el-checkbox v-model="filters.cardStatus.active">Active</el-checkbox>
                                                <el-checkbox v-model="filters.cardStatus.inactive">Not Setup</el-checkbox>
                                                <el-checkbox v-model="filters.cardStatus.failed">Failed</el-checkbox>
                                                </div>
                                            </el-collapse-item>
                                            </el-collapse>
                                            <el-collapse value="Campaign Status" style="border: none;">
                                            <el-collapse-item title="Campaign Status" name="Campaign Status">
                                                <div style="padding-left:8px;">
                                                <el-checkbox v-model="filters.campaignStatus.active">Active</el-checkbox>
                                                <el-checkbox v-model="filters.campaignStatus.inactive">Inactive</el-checkbox>
                                                </div>
                                            </el-collapse-item>
                                            </el-collapse>
                                        </div>
                                        <div class='d-flex justify-content-end mr-4 mt-4'>
                                            <base-button @click="applyFilters" :simple="true" size="sm">
                                            Save
                                            </base-button>
                                        </div>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                                <div style="padding-inline: 4px;">
                                    <base-button size="sm" style="height:40px" v-if="this.$global.settingMenuShow_create"
                                        @click="AddEditClient('')">
                                        <i class="fas fa-plus-circle"></i> Add Client
                                    </base-button>
                                </div>
                                <div style="padding-inline: 4px;">
                                    <base-button size="sm" style="height:40px"
                                        @click="exportDataClient">
                                        <i class="fas fa-cloud-download-alt pr-2"></i> Export Data
                                    </base-button>
                                </div>
                        </div>
                    </div>
                        </div>
                    </div>

                    <ValidationObserver ref="frmAddDownline"  v-slot="{ handleSubmit }">
                        <form autocomplete="off" >
                            <input autocomplete="false" name="hidden" type="text" style="display:none;">
                            <div  class="row collapse" id="showAddEditClient">
                                <div class="col-sm-12 col-md-12 col-lg-12 pt-2 pb-2">&nbsp;</div>
                                <div class="col-sm-4 col-md-4 col-lg-4 form-group has-label">
                                    <ValidationProvider 
                                    name="Client Name" 
                                    rules="required"
                                    v-slot="{ passed, failed, errors }">
                                        <base-input label="Client Name" type="text" placeholder="Input Client Name"
                                            addon-left-icon="fas fa-building" v-model="ClientCompanyName"
                                            :error="errors[0]"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider 
                                    name="Contact Name"
                                    rules="required"
                                    v-slot="{ passed, failed, errors }">
                                        <base-input label="Contact Name" type="text" placeholder="Input Contact Name"
                                            addon-left-icon="far fa-id-badge" v-model="ClientFullName"
                                            :error="errors[0]"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>
                                <div class="col-sm-4 col-md-4 col-lg-4">
                                    <ValidationProvider
                                     name="email" 
                                     rules="required|email"
                                     v-slot="{ passed, failed, errors }">
                                        <base-input label="Email" type="email" placeholder="Input Email"
                                            addon-left-icon="fas fa-envelope" v-model="ClientEmail" :lowercase="true"
                                            :error="errors[0]"
                                            max="70"
                                            :maxLength="70"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>

                                <div class="col-sm-6 col-md-6 col-lg-6">
                                    <!-- <base-input
                                label="Phone Number"
                                type="text"
                                placeholder="Input Client Phone"
                                addon-left-icon="fas fa-phone-alt"
                                v-model="ClientPhone"
                                class="phonenum"
                                >
                            </base-input> -->
                                    <label>Phone Number</label>

                                    <VuePhoneNumberInput :defaultCountryCode="clientPhoneNumber.countryCode"
                                        v-model="clientPhoneNumber.number" @update="onPhoneUpdate" />
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6 form-group has-label" v-if="ghlV2AgencyConnected && $global.idsys == $global.masteridsys">
                                    <label class="pr-2">
                                        Import Client From Your CRM
                                        <i @click="clearSelectSubAccount" class="fa-solid fa-circle-x ml-2" style="cursor: pointer;"></i>
                                    </label>
                                    <el-select
                                        class="select-primary"
                                        size="large"
                                        placeholder="Select Client"
                                        filterable
                                        default-first-option
                                        v-model="selects.ghlv2SubAccount"
                                        @visible-change="visible => onSelectGhlV2SubAccountVisible(visible, 'add')"
                                        ref="selectGhlV2SubAccountAdd">
                                        <el-option
                                            v-for="item in ghlV2ListSubAccounts"
                                            class="select-primary"
                                            :value="item.id"
                                            :label="item.name"
                                            :key="item.id">
                                        </el-option>
                                        <el-option v-if="paginationGhlV2SubAccount.isFetch && !paginationGhlV2SubAccount.isComplete" value="loading" label="Loading...." disabled>
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12 ">
                                    <base-checkbox value="T" v-model="disabledreceiveemail" class="pull-left">Disable
                                        all system emails to this client</base-checkbox>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12 ">
                                    <base-checkbox value="T" v-model="disabledaddcampaign" class="pull-left">Disable
                                        clients ability to add campaigns</base-checkbox>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12 ">
                                    <base-checkbox value="T" v-model="seteditor" class="pull-left">
                                        Set as Editor Google Spreadsheet
                                    </base-checkbox>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12 ">
                                    <el-checkbox size="medium"  @input="openPhoneConfirmationModal('checkboxes', 'checkboxes')" class="base__checkbox mt-2" name="enabledphonenumber"  
                                    :value="checkboxes.phoneenabled" inline>
                                        Enable Phone Number when Create Campaign
                                    </el-checkbox>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6 form-group has-label" v-if="false">
                                    <base-input label="Domain Name:" type="text" placeholder="yourdomain.com"
                                        addon-left-icon="fas fa-globe-americas" v-model="ClientDomain">
                                    </base-input>
                                </div>

                                <div class="mt-2">
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <span v-if="hasProducts" class="" style="font-size: 0.80143rem;">Product(s) :</span>
                                        <base-checkbox
                                            v-for="(sidebar, key) in customsidebarleadmenu"
                                            :key="sidebar.url"
                                            class="mr-3"
                                            v-model="selectedModulesCreate[key]"
                                            v-show="validateBetaFeature(key) && (sidebar.url != 'simplifiid' || $global.idsys == $global.masteridsys)"
                                        >
                                        {{ sidebar.name }}
                                        </base-checkbox>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <base-button size="sm" id="btnSave" name="btnSave"
                                        class="pull-right" style="height:40px" @click="ProcessAddEditClient('')">
                                        Save
                                    </base-button>
                                    <base-button size="sm" class="pull-right mr-4" style="height:40px"
                                        @click="CancelAddEditClient('')">
                                        Cancel
                                    </base-button>
                                </div>

                                <div class="col-sm-12 col-md-12 col-lg-12 pt-4 pb-4">&nbsp;</div>
                            </div>
                        </form>
                    </ValidationObserver>

                    <div class="row">
                        <div
                            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap tab-table">
                            <el-table @expand-change="onExpandClick" :data="queriedData" @sort-change="sortdynamic" :row-class-name="tableRowClassName"
                                ref="tableData" :default-sort="{prop: 'company_name', order: 'ascending'}">
                                <template #empty>
                                    <i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...
                                </template>
                                <el-table-column min-width="180" prop="company_name" sortable="custom"
                                    label="Client Name">
                                    <div slot-scope="props">
                                        {{props.row.company_name}}
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="180" prop="full_name" sortable="custom"
                                    label="Contact Name">
                                    <div slot-scope="props">
                                        {{props.row.name}}
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="180" prop="email" sortable="custom" label="E-mail">
                                    <div slot-scope="props">
                                        {{props.row.email}}
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="120" prop="phone" sortable="custom" label="Phone">
                                    <div slot-scope="props">
                                        {{props.row.phonenum}}
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="120" prop="created_at" sortable="custom" align="center"
                                    label="Created">
                                    <div slot-scope="props">
                                        {{props.row.created_at}}
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="140" align="center" label="Metrics">
                                    <div slot-scope="props">
                                        <el-popover trigger="hover" content="Card settings" effect="light"
                                            placement="top" v-if="props.row.manual_bill == 'F'">
                                            <base-button slot="reference" @click.native="handleCardSet(props.$index, props.row)"
                                                class="edit btn-link" type="warning" size="sm" icon>
                                                <i class="far fa-credit-card" :style="getCardStatus(props.row)" style="font-size: 16px;"></i>
                                            </base-button>
                                        </el-popover>
                                        <div class="icons-container">
                                            <el-popover trigger="hover" content="Active campaigns" effect="light"
                                                placement="top">
                                                <span slot="reference" class="tag__custom cmpActive">
                                                    {{ props.row.campaign_active }}
                                                </span>
                                                <!-- <i class="iconcampaign cmpActive">{{props.row.campaign_active}}</i> -->
                                            </el-popover>
                                            <el-popover trigger="hover" content="Inactive campaigns"
                                                placement="top">
                                                <span slot="reference" class="tag__custom cmpPauseStop">
                                                    {{ props.row.campaign_not_active }}
                                                </span>
                                                <!-- <i
                                                    class="iconcampaign cmpPauseStop">{{props.row.campaign_not_active}}</i> -->
                                            </el-popover>
                                        </div>
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="140" align="center" label="Actions">
                                    <div slot-scope="props">
                                        <el-popover content="View as agency / client" placement="top-start" width="80" trigger="hover">
                                            <span slot="reference">
                                                <span  class="action cursor-pointer" href="javascript:void(0);">
                                                    <i class="fas fas fa-eye" @click="handleSwitchUser(props.row)"></i>
                                                </span>
                                            </span>
                                        </el-popover>
                                        <el-popover trigger="hover" v-if="props.row.company_id !== null" effect="light"
                                            content="Configure Client Integration Settings" placement="top">
                                            <span slot="reference" size="sm" icon style="margin: 0 4px 0 10px">
                                                  <i class="fas fa-plug"
                                                  @click="handleIntegrationClick(props.$index, props.row)"></i>
                                            </span>
                                        </el-popover>
                                        <el-popover trigger="hover" content="Download Agreement File" placement="top" v-if="props.row.company_agreement_file">
                                            <a slot="reference" @click="handleDownloadAgreementFile(props.row)" rel="noopener noreferrer">
                                                <base-button class="edit btn-link" type="neutral" size="xs">
                                                    <i v-if="!downloadingAgreements[props.row.id]" class="fas fa-file-pdf" style="color: green"></i>
                                                    <i v-else class="fas fa-spinner fa-spin" style="color: gray"></i>
                                                </base-button>
                                            </a>
                                        </el-popover>
                                        <el-popover trigger="hover" content="Edit Client" placement="top">
                                            <base-button slot="reference" @click.native="rowClicked(props.row)" class="edit btn-link"
                                                type="neutral" size="sm" icon>
                                                <i class="fa-solid fa-pen-to-square" style="color:gray"></i>
                                            </base-button>
                                        </el-popover>
                                        <el-popover trigger="hover" content="Client Level Exclusion List" effect="light" :open-delay="300"
                                            placement="top" v-if="props.row.company_id !== null">
                                            <base-button slot="reference" @click.native="showWhitelist(props.$index, props.row)"
                                                class="edit btn-link" type="warning" size="sm" icon>
                                                <i class="fas fa-align-slash" style="color:gray"></i>
                                            </base-button>
                                        </el-popover>
                                        <el-popover trigger="hover" content="Default Client Financials" effect="light" :open-delay="300"
                                            placement="top">
                                            <base-button slot="reference" @click.native="handlePriceSet(props.$index, props.row)"
                                                class="edit btn-link" type="warning" size="sm" icon>
                                                <i class="fa-solid fa-dollar-sign" style="color:green"></i>
                                            </base-button>
                                        </el-popover>
                                        <el-popover trigger="hover" content="Remove Client"
                                            placement="top">
                                            <!-- <base-button
                                                       
                                                        class="remove btn-link"
                                                        type="danger"
                                                        size="sm"
                                                        icon
                                                        >
                                                    </base-button> -->
                                                      <span slot="reference">
                                                             <i  v-if="$global.settingMenuShow_delete"
                                                             @click="handleDelete(props.$index, props.row)"
                                                            class="fa-solid fa-circle-x"></i>
                                                      </span>
                                            </el-popover>
                                    </div>
                                </el-table-column>

                                <el-table-column min-width="100%" type="expand">
                                    <!-- START EDIT AREA -->
                                    <template slot-scope="scope">
                                        <ValidationObserver :ref="'frmuser' + scope.row.id" v-slot="{ handleSubmit }">
                                            <form :id="'frmuser' + scope.row"
                                                autocomplete="off">
                                                <input autocomplete="false" name="hidden2" type="text"
                                                    style="display:none;">
                                                <div class="row">
                                                    <div class="col-sm-4 col-md-4 col-lg-4 form-group has-label">
                                                        <ValidationProvider name="Client Name" rules="required"
                                                            v-slot="{ passed, failed, errors }">
                                                            <base-input label="Client Name" type="text"
                                                                placeholder="Input Client Name"
                                                                addon-left-icon="fas fa-building"
                                                                v-model="scope.row.company_name" :error="errors[0]"
                                                                :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                                            </base-input>
                                                        </ValidationProvider>
                                                    </div>
                                                    <div class="col-sm-4 col-md-4 col-lg-4">
                                                        <ValidationProvider name="Contact Name" rules="required"
                                                            v-slot="{ passed, failed, errors }">
                                                            <base-input label="Contact Name" type="text"
                                                                placeholder="Input Contact Name"
                                                                addon-left-icon="far fa-id-badge"
                                                                v-model="scope.row.name" :error="errors[0]"
                                                                :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                                            </base-input>
                                                        </ValidationProvider>
                                                    </div>
                                                    <div class="col-sm-4 col-md-4 col-lg-4">
                                                        <ValidationProvider name="email" rules="required|email"
                                                            v-slot="{ passed, failed, errors }">
                                                            <base-input label="Email" type="email"
                                                                placeholder="Input Email"
                                                                max="70"
                                                                :maxLength="70"
                                                                addon-left-icon="fas fa-envelope"
                                                                v-model="scope.row.email" :lowercase="true"
                                                                :error="errors[0]"
                                                                :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                                            </base-input>
                                                        </ValidationProvider>
                                                    </div>

                                                    <div class="col-sm-6 col-md-6 col-lg-6">
                                                        <!-- <base-input
                                                                    label="Phone Number"
                                                                    type="text"
                                                                    placeholder="Input Client Phone"
                                                                    addon-left-icon="fas fa-phone-alt"
                                                                    v-model="scope.row.phonenum"
                                                                    class="phonenum"
                                                                    aria-autocomplete="none"
                                                                    >
                                                                </base-input> -->
                                                        <label>Phone Number</label>

                                                        <VuePhoneNumberInput
                                                            :defaultCountryCode="clientRowPhoneNumber.countryCode"
                                                            v-model="clientRowPhoneNumber.number"
                                                            @update="onRowPhoneUpdate" />
                                                    </div>

                                                    <div class="col-sm-6 col-md-6 col-lg-6 form-group has-label"
                                                        v-if="false">
                                                        <base-input label="Domain Name:" type="text"
                                                            placeholder="yourdomain.com"
                                                            addon-left-icon="fas fa-globe-americas"
                                                            v-model="scope.row.domain">
                                                        </base-input>
                                                    </div>
                                                    <div class="col-sm-6 col-md-6 col-lg-6 form-group has-label password-icon-container">
                                                        <base-input label="Update Password:" :type="showPassword ? 'text' : 'password'"
                                                            placeholder="Type your new password"
                                                            addon-left-icon="fas fa-key"
                                                            v-model="scope.row.newpassword">
                                                        </base-input>
                                                         <button
                                                            type="button"
                                                            class="icon-password"
                                                            @click="togglePassword"
                                                            >
                                                            <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                                                        </button>
                                                    </div>
                                                    <div class="mt-2">
                                                        <div class="col-sm-12 col-md-12 col-lg-12">
                                                            <base-checkbox @change="clientreceiveemail(scope.row)"
                                                                :checked="scope.row.disabled_receive_email == 'T' ? true : false"
                                                                inline>Disable all system emails to this
                                                                client</base-checkbox>
                                                        </div>
                                                        <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                                            <base-checkbox @change="clientaddcampaign(scope.row)"
                                                                :checked="scope.row.disable_client_add_campaign == 'T' ? true : false"
                                                                inline>Disable clients ability to add
                                                                campaigns</base-checkbox>
                                                        </div>
                                                        <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                                            <base-checkbox @change="clientenableeditor(scope.row)"
                                                                :checked="scope.row.editor_spreadsheet == 'T' ? true : false"
                                                                inline>
                                                                    Set as Editor Google Spreadsheet
                                                            </base-checkbox>
                                                        </div>
                                                        <div class="col-sm-12 col-md-12 col-lg-12 pt-2">
                                                            <el-checkbox size="medium"  @input="openPhoneConfirmationModal('rowCheckboxes', 'scope.row')" class="base__checkbox mt-2" name="enabledphonenumber"  
                                                            :value="rowCheckboxes.phoneenabled" inline>
                                                                Enable Phone Number when Create Campaign
                                                            </el-checkbox>
                                                        </div>
                                                    </div>
                                                    <div class="mt-2">
                                                        <div class="col-sm-12 col-md-12 col-lg-12">
                                                            <span v-if="hasProducts" class="" style="font-size: 0.80143rem;">Product(s) :</span>
                                                            <base-checkbox
                                                                v-for="(sidebar, key) in customsidebarleadmenu"
                                                                :key="sidebar.url"
                                                                class="mr-3"
                                                                v-model="selectedModules[key]"
                                                                v-show="validateBetaFeature(key) && (sidebar.url != 'simplifiid' || $global.idsys == $global.masteridsys)"
                                                            >
                                                            {{ sidebar.name }}
                                                            </base-checkbox>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                                        <base-button v-if="$global.settingMenuShow_update"
                                                            :id="'btnSave' + scope.row.id" size="sm" class="pull-right"
                                                            style="height:40px" @click="ProcessAddEditClient(scope.row)">
                                                            Save
                                                        </base-button>
                                                        <base-button size="sm" class="pull-right mr-4"
                                                            style="height:40px" @click="CancelAddEditClient(scope.row)">
                                                            Cancel
                                                        </base-button>
                                                        <base-button size="sm" class="pull-right mr-4"
                                                            :id="'btnResend' + scope.row.id" style="height:40px"
                                                            @click="ResendInvitation(scope.row)">
                                                            Resend Invitation
                                                        </base-button>
                                                    </div>
                                                </div>
                                            </form>
                                        </ValidationObserver>
                                    </template>

                                    <!-- START EDIT AREA -->
                                </el-table-column>

                            </el-table>
                        </div>
                    </div>

                    <template slot="footer">
                        <div class="tab-footer pull-right">
                            <div class="pt-3">
                                <p class="card-category">
                                    Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }}
                                    entries
                                </p>
                            </div>
                            <base-pagination class="pagination-no-border pt-4" v-model="pagination.currentPage"
                                :per-page="pagination.perPage" :total="pagination.total" @input="changePage">
                            </base-pagination>
                        </div>
                    </template>

                </card>
            </div>
        </div>
        <!-- Modal Video Guide -->
        <modal :show.sync="modals.helpguide" headerClasses="justify-content-center" modalContentClasses="customhead">
            <h4 slot="header" class="title title-up">What is on Dashboard Menu?</h4>
            <p class="text-center">
                Watch the video below if you still have question please <a href="#">Contact Us</a>
            </p>
            <div>
                <!--<iframe width="970" height="415" src="https://www.youtube.com/embed/SCSDyqRP7cY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
            </div>
            <template slot="footer">
                <div class="container text-center pb-4">
                    <base-button @click.native="modals.helpguide = false">Ok I already understand</base-button>
                </div>
            </template>
        </modal>
        <!-- Modal Video Guide -->

        <!-- Modal Card Setup -->
        <modal id="modalSetCard" :show.sync="modals.cardsetup" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Credit Card Setup for <span
                    style="color:#d42e66">{{LeadspeekCompany}}</span></h4>
            <!-- IF HAVE FAILED PAYMENT -->
            <div class="col-sm-12 col-md-12 col-lg-12 text-center" v-if="clientPaymentFailed">
                <p>Your account has outstanding invoices for these campaigns:</p>
                <ul style="width:40%;text-align:left;margin:0 auto">
                    <li style="color:#000" v-for="(item, index) in failedCampaignNumber" :key="index">
                        Campaign #{{ item }} total amount : {{ displayMoney(failedInvoiceAmount[index]) }}
                    </li>
                    <li class="pt-2 pb-2" style="list-style:none;margin-left:-95px;color:#000">The total outstanding
                        amount is <strong>{{ failedInvoiceTotal() }}</strong></li>
                </ul>
                <p>Please update your credit card information or retry the charge with your existing card. Thank you.
                </p>
            </div>
            <!-- IF HAVE FAILED PAYMENT -->

            <div class="row justify-content-center client__management__card__credit">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <ValidationObserver ref="formCC">
                        <form>

                            <!--START ADD / UPDATE FOR CC -->
                            <div id="card-element" class="col-sm-12 col-md-12 col-lg-12 card-border">&nbsp;</div>
                            <div class="pt-2 pl-2" v-if="cardfailetoload" style="font-size:0.80143rem"><i
                                    class="fas fa-sync-alt pr-2" @click="refreshCCfield();"
                                    style="cursor:pointer"></i>Failed to load the Credit Card field. Please <a
                                    href="javascript:void(0);" @click="refreshCCfield();" style="font-weight:bold">click
                                    here</a> to refresh and try again.</div>
                            <div id="carderror" class="col-sm-12 col-md-12 col-lg-12 pt-2 hide" style="color:red">
                                <small>&nbsp;</small>
                            </div>

                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <ValidationProvider name="Card Holder Name" rules="required"
                                    v-slot="{ passed, failed, errors }">
                                    <base-input v-model="cardholdername" label="Card Holder Name" :error="errors[0]"
                                        :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                    </base-input>
                                </ValidationProvider>
                            </div>

                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <ValidationProvider name="Billing Address" rules="required"
                                    v-slot="{ passed, failed, errors }">
                                    <base-input v-model="billingaddress" label="Billing Address" :error="errors[0]"
                                        :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                    </base-input>
                                </ValidationProvider>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                                <div class="country-region-select-wrapper">
                                    <span style="color: #525f7f;font-size: 14px;" class="country-label">Country *</span>
                                    <country-select style="color: #525f7f;border-color: #cad1d7;"
                                        class="country-region-select" v-model="selects.country"
                                        :country="selects.country" topCountry="US" />
                                    <span v-if="showErrorMessage && !selects.country">Please select country</span>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12 mt-2">
                                <div v-if="selects.country" class="country-region-select-wrapper">
                                    <span style="color: #525f7f;font-size: 14px;"
                                        class="country-label">{{selects.country === "CA" ?"Province *": "State*"}}</span>
                                    <region-select style="color: #525f7f;border-color: #cad1d7;"
                                        class="country-region-select" v-model="selects.state" :country="selects.country"
                                        :region="selects.state" />
                                    <span v-if="showErrorMessage && !selects.state">Please select state</span>
                                </div>
                            </div>
                            <div class="row pt-2 mr-0 ml-0">
                                <div class="col-sm-6 col-md-6 col-lg-6">
                                    <ValidationProvider name="City" rules="required"
                                        v-slot="{ passed, failed, errors }">
                                        <base-input v-model="city" label="City" :error="errors[0]"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>
                                <!-- <div class="col-sm-4 col-md-4 col-lg-4">
                                                    <label>State</label>
                                                    <base-input>
                                                        <el-select
                                                        v-model="selects.state"
                                                        class="select-primary "
                                                        name="state"
                                                        inline
                                                        size="large"
                                                        filterable
                                                        default-first-option
                                                        >
                                                        <el-option
                                                            v-for="option in selects.statelist"
                                                            class="select-primary"
                                                            :label="option.state"
                                                            :value="option.state_code"
                                                            :key="option.state_code"
                                                        ></el-option>
                                                        </el-select>
                                                    </base-input>
                                                </div> -->
                                <div class="col-sm-6 col-md-6 col-lg-6">
                                    <ValidationProvider name="Zip" rules="required" v-slot="{ passed, failed, errors }">
                                        <base-input v-model="zipcode" label="Zip" :error="errors[0]"
                                            :class="[{ 'has-success': passed }, { 'has-danger': failed }]">
                                        </base-input>
                                    </ValidationProvider>
                                </div>
                            </div>
                            <!--START ADD / UDPATE FOR CC -->
                            <div class="pt-3 pb-3">&nbsp;</div>

                            <div class="col-sm-12 col-md-12 col-lg-12 ">
                                <card>
                                    <div slot="header">
                                        <h4 class="card-title">Your Current Card Information</h4>
                                    </div>
                                </card>
                            </div>


                            <div class="col-sm-12 col-md-12 col-lg-12 mr-0 ml-0">
                                <p class="text-title-wrapping" v-if="currCardHolder != ''">{{currCardHolder}}</p>
                                <p v-if="currCardlastdigit != ''">Card Number :
                                    &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                                    {{currCardlastdigit}}</p>
                                <p v-if="currCardType != ''">Card Type : {{currCardType}}</p>
                            </div>

                            <div class="pt-3 pb-3">&nbsp;</div>

                            <div class="col-sm-12 col-md-12 col-lg-12 ">
                                <base-checkbox v-model="agreeTerm" class="pull-left"
                                    :class="{'has-danger': agreeTermStat}">I attest that the client and credit card owner has agreed to the <a
                                        :href="'/service-billing-agreement/?src=client&host=' + termhost"
                                        target="_blank" style="color:#919aa3"
                                        :style="[agreeTermStat?{'color':'#ec250d'}:'']">Billing
                                        Terms and Service Agreement</a></base-checkbox>
                            </div>

                            <div class="col-sm-12 col-md-12 col-lg-12" v-if="!clientPaymentFailed">
                                <base-button @click="validateCC('');" id="btnupdcc" size="sm" class="pull-right"
                                    style="height:40px">
                                    Update
                                </base-button>
                            </div>
                            <div class="row pt-2" style="width:100%" v-if="clientPaymentFailed">

                                <div class="col-sm-6 col-md-6 col-lg-6 pl-4">
                                    <base-button @click="validateCC('existcard');" id="btnRetryExistCard" size="sm"
                                        class="pull-right" style="height:50px">
                                        Retry charge with existing card
                                    </base-button>
                                </div>
                                <div class="col-sm-6 col-md-6 col-lg-6 pr-0">
                                    <base-button @click="validateCC('updatecharge');" id="btnUpdateAndCharge" size="sm"
                                        class="pull-right" style="height:50px">
                                        save and charge amount due
                                    </base-button>
                                </div>
                            </div>

                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </modal>
        <!-- Modal Card Setup -->

        <!-- Card Update Modal -->
        <modal :show.sync="modals.cardupdate" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Card Information</h4>
            <p>
                Thank you! Your Credit Card Information Has been updated.
            </p>
            <template slot="footer">
                <div class="container text-center pb-4">
                    <base-button @click.native="closebtnupdatecard()">Ok</base-button>
                </div>
            </template>
        </modal>
        <!-- Card Update Modal -->

        <!-- Card retry charge Modal -->
        <modal :show.sync="modals.cardretrycharge" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">{{cardretrychargeTitle}}</h4>
            <p class="text-center" v-html="cardretrychargeTxt">

            </p>
            <template slot="footer">
                <div class="container text-center pb-4">
                    <base-button @click.native="closebtnupdatecard()">Ok</base-button>
                </div>
            </template>
        </modal>

        <!-- Modal Setting Markup -->
        <modal id="modalSetPrice" :show.sync="modals.pricesetup" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up text-title-wrapping">Set Campaign pricing for <span
                    style="color:#d42e66">{{LeadspeekCompany}}</span></h4>
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="row" style="padding-inline: 16px; margin-bottom: 24px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                        <div v-if="moduleAgency.local != undefined" @click="selectsAppModule.AppModuleSelect = 'LeadsPeek'" 
                        style="flex: 1; display: flex; justify-content: center;"
                        class="menu__prices"
                        :class="[selectsAppModule.AppModuleSelect === 'LeadsPeek' ? 'active__menu__prices' : '']">
                        {{ this.$global.globalModulNameLink.local.name }}
                        </div>
                        <div v-if="moduleAgency.locator != undefined" @click="selectsAppModule.AppModuleSelect = 'locator'" 
                        style="flex: 1; display: flex; justify-content: center;"
                        class="menu__prices"
                        :class="[selectsAppModule.AppModuleSelect === 'locator' ? 'active__menu__prices' : '']">
                            {{ this.$global.globalModulNameLink.locator.name }}
                        </div>
                        <div v-if="this.$global.globalModulNameLink.enhance.name != null && this.$global.globalModulNameLink.enhance.url != null && moduleAgency.enhance != undefined" 
                        @click="selectsAppModule.AppModuleSelect = 'enhance'" 
                        class="menu__prices"  
                        :class="[selectsAppModule.AppModuleSelect === 'enhance' ? 'active__menu__prices' : '']" 
                        style="flex: 1; display: flex; justify-content: center;">
                            {{ this.$global.globalModulNameLink.enhance.name }}
                        </div>
                        <div v-if="this.$global.globalModulNameLink.b2b.name != null && this.$global.globalModulNameLink.b2b.url != null && moduleAgency.b2b != undefined && validateBetaFeature('b2b_module')" 
                        @click="selectsAppModule.AppModuleSelect = 'b2b'" 
                        class="menu__prices"  
                        :class="[selectsAppModule.AppModuleSelect === 'b2b' ? 'active__menu__prices' : '']" 
                        style="flex: 1; display: flex; justify-content: center;">
                            {{ this.$global.globalModulNameLink.b2b.name }}
                        </div>
                        <div v-if="this.$global.globalModulNameLink.simplifi.name != null && this.$global.globalModulNameLink.simplifi.url != null && moduleAgency.simplifi != undefined && validateBetaFeature('simplifi_module') && this.$global.idsys == this.$global.masteridsys" 
                        @click="selectsAppModule.AppModuleSelect = 'simplifi'" 
                        class="menu__prices"  
                        :class="[selectsAppModule.AppModuleSelect === 'simplifi' ? 'active__menu__prices' : '']" 
                        style="flex: 1; display: flex; justify-content: center;">
                            {{ this.$global.globalModulNameLink.simplifi.name }}
                        </div>
                        <div style="width: 100%; border: 1px solid gray; height: 1px; margin-top: 16px;"></div>
                    </div>
                    <div v-if="selectsAppModule.AppModuleSelect != 'simplifi'" class="d-flex flex-column" style="margin-bottom:16px;">
                        <span class="client-payment-modal-form-label" style="color:#222a42">Billing Frequency</span>
                        <el-select class="select-primary" size="small" placeholder="Select Modules"
                            v-model="selectsPaymentTerm.PaymentTermSelect" @change="paymentTermChange()">
                            <el-option v-for="option in selectsPaymentTerm.PaymentTerm" class="select-primary"
                                :value="option.value" :label="option.label" :key="option.label">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>

            <div v-if="selectsAppModule.AppModuleSelect == 'LeadsPeek' && moduleAgency.local != undefined">
                <div class="client-payment-setup-form-wrapper">

                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Setup Fee
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LeadspeekPlatformFee"
                                    @keyup="set_fee('local','LeadspeekPlatformFee');"
                                    @blur="handleFormatCurrency('local','LeadspeekPlatformFee')"
                                    @keydown="restrictInput"  
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekPlatformFee }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Campaign Fee <span v-html="txtLeadService">per month</span>
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LeadspeekMinCostMonth"
                                    @keyup="set_fee('local','LeadspeekMinCostMonth');"
                                    @blur="handleFormatCurrency('local','LeadspeekMinCostMonth')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekMinCostMonth }}</span></span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6" v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                            <div class="client-payment-modal-form-label">
                                Cost per contact<span v-html="txtLeadOver" v-if="false">from the monthly charge</span>? (Basic)
                                <sup>
                                    <el-popover
                                        trigger="hover"
                                        :content="helpContentMap[1].desc"
                                        placement="top"
                                        popper-class="tooltip-content"
                                    >
                                    <span style="font-size: 12px;"><i class="fa fa-question-circle"></i></span>
                                    </el-popover>
                                </sup>
                                <!-- <sup>
                                    <span style="cursor: pointer; font-size: 12px;"><i @click="openHelpModal(1)" class="fa fa-question-circle"></i></span>
                                </sup> -->
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LeadspeekCostperlead"
                                    @keyup="set_fee('local','LeadspeekCostperlead');"
                                    @blur="handleFormatCurrency('local','LeadspeekCostperlead')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekCostPerLead }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Cost per contact<span v-html="txtLeadOver" v-if="false">from the monthly charge</span>? (Advanced)
                                <sup>
                                    <el-popover
                                        trigger="hover"
                                        :content="helpContentMap[2].desc"
                                        placement="top"
                                        popper-class="tooltip-content"
                                    >
                                    <span style="font-size: 12px;"><i class="fa fa-question-circle"></i></span>
                                    </el-popover>
                                </sup>
                                <!-- <sup>
                                    <span style="cursor: pointer; font-size: 12px;"><i @click="openHelpModal(2)" class="fa fa-question-circle"></i></span>
                                </sup> -->
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LeadspeekCostperleadAdvanced"
                                    @keyup="set_fee('local','LeadspeekCostperleadAdvanced');"
                                    @blur="handleFormatCurrency('local','LeadspeekCostperleadAdvanced')"
                                    @keydown="restrictInput"  
                                    @copy.prevent @cut.prevent @paste.prevent>
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your advanced price for cost per contact $<span>{{ m_LeadspeekCostPerLeadAdvanced }}</span></span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                <el-checkbox v-model="LeadspeekEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('local')">Enable Minimum Contact Per Day</el-checkbox>
                            </div>
                            <div class="client-payment-modal-form-label">
                                How many contacts per day does the client want to receive?
                            </div>
                            <div>
                                <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                    class="campaign-cost-input" v-model="LeadspeekLeadsPerday"
                                    @keyup="set_fee('local','LeadspeekLeadsPerday');"
                                    @input="event => onInput(event, 'LeadspeekLeadsPerday')"
                                    @blur="handleFormatCurrency('local','LeadspeekLeadsPerday')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div v-if="selectsAppModule.AppModuleSelect == 'locator' && moduleAgency.locator != undefined">
                <div class="client-payment-setup-form-wrapper">

                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Setup Fee
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LocatorPlatformFee"
                                    @keyup="set_fee('locator','LocatorPlatformFee');"
                                    @blur="handleFormatCurrency('locator','LocatorPlatformFee')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekLocatorPlatformFee }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Campaign Fee <span v-html="txtLeadService">per month</span>
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LocatorMinCostMonth"
                                    @keyup="set_fee('locator','LocatorMinCostMonth');"
                                    @blur="handleFormatCurrency('locator','LocatorMinCostMonth')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekLocatorMinCostMonth }}</span></span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6" v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                            <div class="client-payment-modal-form-label">
                                Cost per contact<span v-html="txtLeadOver" v-if="false">from the
                                    monthly charge</span>?
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="LocatorCostperlead"
                                    @keyup="set_fee('locator','LocatorCostperlead');"
                                    @blur="handleFormatCurrency('locator','LocatorCostperlead')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekLocatorCostPerLead }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                <el-checkbox v-model="LocatorEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('locator')">Enable Minimum Contact Per Day</el-checkbox>
                            </div>
                            <div class="client-payment-modal-form-label">
                                How many contacts per day does the client want to receive?
                            </div>
                            <div>
                                <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                    class="campaign-cost-input" v-model="LocatorLeadsPerday"
                                    @keyup="set_fee('locator','LocatorLeadsPerday');"
                                    @input="event => onInput(event, 'LocatorLeadsPerday')"
                                    @blur="handleFormatCurrency('locator','LocatorLeadsPerday')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <div v-if="selectsAppModule.AppModuleSelect == 'enhance' && moduleAgency.enhance != undefined">
                <div class="client-payment-setup-form-wrapper">

                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Setup Fee
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input"  v-model="EnhancePlatformFee"    
                                    @keyup="set_fee('enhance','EnhancePlatformFee');"
                                    @blur="handleFormatCurrency('enhance','EnhancePlatformFee')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekEnhancePlatformFee }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6"  >
                            <div class="client-payment-modal-form-label">
                                Campaign Fee <span v-html="txtLeadService">per month</span>
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="EnhanceMinCostMonth"
                                    @keyup="set_fee('enhance','EnhanceMinCostMonth');"
                                    @blur="handleFormatCurrency('enhance','EnhanceMinCostMonth')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekEnhanceMinCostMonth }}</span></span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6" 
                            v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                            <div class="client-payment-modal-form-label">
                                Cost per contact<span v-html="txtLeadOver" v-if="false">from the
                                    monthly charge</span>?
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="EnhanceCostperlead"
                                    @keyup="set_fee('enhance','EnhanceCostperlead');"
                                    @blur="handleFormatCurrency('enhance','EnhanceCostperlead')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekEnhanceCostPerLead }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                <el-checkbox v-model="EnhanceEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('enhance')">Enable Minimum Contact Per Day</el-checkbox>
                            </div>
                            <div class="client-payment-modal-form-label">
                                How many contacts per day does the client want to receive?
                            </div>
                            <div>
                                <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                    class="campaign-cost-input" v-model="EnhanceLeadsPerday"
                                    @keyup="set_fee('enhance','EnhanceLeadsPerday');"
                                    @input="event => onInput(event, 'EnhanceLeadsPerday')"
                                    @blur="handleFormatCurrency('enhance','EnhanceLeadsPerday')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                            </div>
                            <span v-if="errMinLeadDay" style="color:#942434; font-size:12px;font-weight: 400;line-height: 12px;margin-top: 4px;display: block;">*contacts Per Day Minimum {{ clientMinLeadDayEnhance }}</span>
                        </div>
                    </div>

                </div>

            </div>
            
            <div v-if="selectsAppModule.AppModuleSelect == 'b2b' && moduleAgency.b2b != undefined && validateBetaFeature('b2b_module')">
                <div class="client-payment-setup-form-wrapper">

                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="client-payment-modal-form-label">
                                Setup Fee
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input"  v-model="B2bPlatformFee"    
                                    @keyup="set_fee('b2b','B2bPlatformFee');"
                                    @blur="handleFormatCurrency('b2b','B2bPlatformFee')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for One Time Creative/Set Up Fee is $<span>{{ m_LeadspeekB2BPlatformFee }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6"  >
                            <div class="client-payment-modal-form-label">
                                Campaign Fee <span v-html="txtLeadService">per month</span>
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="B2bMinCostMonth"
                                    @keyup="set_fee('b2b','B2bMinCostMonth');"
                                    @blur="handleFormatCurrency('b2b','B2bMinCostMonth')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for charging your client for Platform Fee is $<span>{{ m_LeadspeekB2BMinCostMonth }}</span></span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6" 
                            v-if="selectsPaymentTerm.PaymentTermSelect != 'One Time'">
                            <div class="client-payment-modal-form-label">
                                Cost per contact<span v-html="txtLeadOver" v-if="false">from the
                                    monthly charge</span>?
                            </div>
                            <div>
                                <base-input label="" type="text" placeholder="0" addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="B2bCostperlead"
                                    @keyup="set_fee('b2b','B2bCostperlead');"
                                    @blur="handleFormatCurrency('b2b','B2bCostperlead')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                                <div class="client-payment-modal-form-helper-text"><span>Your base price for cost per contact $<span>{{ m_LeadspeekB2BCostPerLead }}</span></span></div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="checkboxEnableMinimumLeadsPerDay" hidden>
                                <el-checkbox v-model="B2bEnableMinimumLeadsPerDay" @change="changeEnableMinimumLeadsPerDay('b2b')">Enable Minimum Contact Per Day</el-checkbox>
                            </div>
                            <div class="client-payment-modal-form-label">
                                How many contacts per day does the client want to receive?
                            </div>
                            <div>
                                <base-input style="text-align: left;" label="" type="text" placeholder="0"
                                    class="campaign-cost-input" v-model="B2bLeadsPerday"
                                    @keyup="set_fee('b2b','B2bLeadsPerday');"
                                    @input="event => onInput(event, 'B2bLeadsPerday')"
                                    @blur="handleFormatCurrency('b2b','B2bLeadsPerday')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent
                                    >
                                </base-input>
                            </div>
                            <span v-if="errMinLeadDay" style="color:#942434; font-size:12px;font-weight: 400;line-height: 12px;margin-top: 4px;display: block;">*Leads Per Day Minimum {{ clientMinLeadDayEnhance }}</span>
                        </div>
                    </div>

                </div>
            </div>

            <div v-if="selectsAppModule.AppModuleSelect == 'simplifi' && moduleAgency.simplifi != undefined && validateBetaFeature('simplifi_module') && this.$global.idsys == this.$global.masteridsys">
                <div class="client-payment-setup-form-wrapper">
                    <div class="row">
                        <div class="col-sm-12 col-md-4 col-lg-4">
                            <div class="client-payment-modal-form-label">
                                Max Bid
                            </div>
                            <div>
                                <base-input 
                                    label="" 
                                    type="text" 
                                    placeholder="0" 
                                    addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input"
                                    :class="{'error-input-price-simplifi': simplifiErrorInput.maxBid}" 
                                    v-model="SimplifiMaxBid"    
                                    @keyup="set_fee('simplifi','SimplifiMaxBid');"
                                    @blur="handleFormatCurrency('simplifi','SimplifiMaxBid')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent>
                                    <template #addonRight>
                                        <span class="input-group-text cpm-remove-border">CPM</span>
                                    </template>
                                </base-input>
                                <span v-if="simplifiErrorInput.maxBid" v-html="simplifiErrorInput.maxBid" class="error-message-price-simplifi"></span>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-4 col-lg-4">
                            <div class="client-payment-modal-form-label">
                                Daily Budget
                            </div>
                            <div>
                                <base-input 
                                    label="" 
                                    type="text" 
                                    placeholder="0" 
                                    addon-left-icon="fas fa-dollar-sign"
                                    class="campaign-cost-input" v-model="SimplifiDailyBudget"
                                    :class="{'error-input-price-simplifi': simplifiErrorInput.dailyBudget}" 
                                    @keyup="set_fee('simplifi','SimplifiDailyBudget');"
                                    @blur="handleFormatCurrency('simplifi','SimplifiDailyBudget')"
                                    @keydown="restrictInput"
                                    @copy.prevent @cut.prevent @paste.prevent>
                                </base-input>
                                <span v-if="simplifiErrorInput.dailyBudget" v-html="simplifiErrorInput.dailyBudget" class="error-message-price-simplifi"></span>
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-4 col-lg-4">
                            <div class="client-payment-modal-form-label">
                                Agency Profit Margin
                            </div>
                            <div>
                                <el-select class="select-primary" style="width: 100%;" size="large" placeholder="Select Modules" v-model="SimplifiAgencyMarkup" @change="set_fee('simplifi','SimplifiAgencyMarkup');">
                                    <el-option v-for="markup in agencyMarkup.list" :value="markup.value" :label="markup.text" :key="markup.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template slot="footer">
                <div class="d-flex justify-content-center w-100 pb-4">
                    <base-button @click.native="save_default_price()">Ok, Set It Up!</base-button>
                </div>
            </template>
        </modal>
        <!-- Modal Setting Markup -->

        <!-- Modal integration settings -->
        <modal :show.sync="modals.integrations" id="addIntegrations"
            footerClasses="border-top">
            <h3 slot="header" class="title title-up text-title-wrapping">Integration Settings for {{ selectedRowData.company_name }}</h3>
            
            <div>
                <div v-if="integrationStatus.loading">
                    <i class="fas fa-spinner fa-spin" style="font-size: 24px;"></i>
                </div>
                <div v-else-if="integrationStatus.error" class="error-banner">Oops! Something went wrong. Please refresh the page and try again.</div>
                <div v-else class="integratios-list-wrapper d-flex align-items-center gap-4 flex-wrap">
                    <div v-for="item in integrations" :key="item.slug"
                        class="integrations__modal-item-wrapper d-flex align-items-center justify-content-center shadow-sm border"
                        :class="{ '--active bg-blue text-secondary': item.slug === selectedIntegration }"
                        @click="handleIntegrationItemClick(item)">
                        <div class="integrations__modal-item">
                            <img
                                v-if="item.custom_img"
                                class="logo-wrap-client-management"
                                :src="item.custom_img"
                                alt="brand-logo"
                            />
                            <i v-else :class="item.custom_icon || item.icon" style="font-size: 36px;"></i>
                            <span class="integrarion-brand-name" style="text-align: center;">{{ item.custom_name || item.name }}</span>
                        </div>
                    </div>
                </div>
                <div class="mt-4">
                    <div v-if="isIntegrationItemsFetch" class="row" v-loading="true" id="loading"></div>
                    <div v-else>
                        <div v-if="selectedIntegration === 'gohighlevel'" class="''">
                            <el-checkbox v-model="enabledconntector.gohighlevel">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="d-flex" style="flex-direction: column; gap: 12px; margin-top: 25px" v-if="referralCodeActive != ''">
                               <span style="display: flex; align-items: center;gap: 8px">
                                <el-button
                                    size="medium"
                                    icon="el-icon-unlock"
                                    @click="redirectToLink(`https://www.gohighlevel.com/?fp_ref=${referralCodeActive}`)"
                                    circle
                                 
                                    ></el-button> <span>If you do not have a {{ nameActiveIntegration }} account, <a style="color: inherit !important;font-size: inherit;font-weight: bold;" :href="`https://www.gohighlevel.com/?fp_ref=${referralCodeActive}`" target="_blank">Click Here</a> to create one</span>
                                </span>
                            </div>
                            <div class="has-label" style="margin-top: 20px; margin-bottom: 35px;">
                                <el-tabs type="border-card" v-model="integrationVersion.gohighlevel">
                                    <el-tab-pane name="2">
                                        <span slot="label">Full Integration</span>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div style="margin-left: 4px;">
                                                    <p v-if="ghlV2Connected">You Have Connected Contact Sync For This Client</p>
                                                    <p v-else>You Have Not Yet Connected Contact Sync For This Client</p>
                                                </div>
                                                <div :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { marginTop: '10px' } : {}">
                                                    <base-button id="btnConnectDisconnectGhlv2" :disabled="isLoadingConnectDisconnectGhlv2" @click="connectDisconnectGhlv2">
                                                        {{ btnConnectDisconnectGhlv2Text }}
                                                        <i v-if="isLoadingConnectDisconnectGhlv2" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                                                    </base-button>
                                                </div>
                                            </div>
                                            <div class="col-md-6 divider-ghl2" v-if="ghlV2AgencyConnected && this.$global.idsys == this.$global.masteridsys">
                                                <div style="margin-left: 4px;">
                                                    <p v-if="ghlV2CreatedIframe">You Have Created a Single Sign On Link For This Client</p>
                                                    <p v-else>You Have Not Yet Created a Single Sign On Link For This Client</p>
                                                </div>
                                                <div style="display: flex; justify-content: space-between; align-items: center; gap: 16px;">
                                                    <div :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { width: '100%' } : {}">
                                                        <base-button :style="!ghlV2CreatedIframe && ghlV2AgencyConnected && $global.idsys == $global.masteridsys ? { width: '100%' } : {}" id="btnCreateDeleteIframeGhlv2Text" @click="createDeleteIframeGhlv2" :disabled="isLoadingCreateDeleteIframeGhlV2">
                                                            {{ btnCreateDeleteIframeGhlv2Text }}
                                                            <i v-if="isLoadingCreateDeleteIframeGhlV2" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                                                        </base-button>
                                                    </div>
                                                    <div style="width: 100%;" class="form-group has-label" v-if="!ghlV2CreatedIframe && ghlV2AgencyConnected && this.$global.idsys == this.$global.masteridsys">
                                                        <el-select
                                                            style="width: 100%; margin-top: 10px;"
                                                            class="select-primary"
                                                            size="large"
                                                            placeholder="Select Client"
                                                            filterable
                                                            default-first-option
                                                            v-model="selects.ghlv2SubAccount"
                                                            @visible-change="visible => onSelectGhlV2SubAccountVisible(visible, 'edit')"
                                                            ref="selectGhlV2SubAccountEdit">
                                                            <el-option
                                                                v-for="item in ghlV2ListSubAccounts"
                                                                class="select-primary"
                                                                :value="item.id"
                                                                :label="item.name"
                                                                :key="item.id">
                                                            </el-option>
                                                            <el-option v-if="paginationGhlV2SubAccount.isFetch && !paginationGhlV2SubAccount.isComplete" value="loading" label="Loading...." disabled>
                                                            </el-option>
                                                        </el-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </el-tab-pane>
                                    <el-tab-pane name="1">
                                        <span slot="label">API Only</span>
                                        <label class="mb-0">Enter your API Key</label>
                                        <el-input type="text" clearable label="Enter your API Key" placeholder="AssAW02A02ksjsklah"
                                            class="flex-grow-1 mb-0" v-model="userApiKey.gohighlevel" aria-controls="datatables">
                                        </el-input>                    
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                            <template>
                                <CheckboxCustomFields
                                    :slug="'Gohighlevel'"
                                    :isLoadingCustomFieldsBySlug="isLoadingCustomFieldsBySlug"
                                    :isErrorCustomFieldsBySlug="isErrorCustomFieldsBySlug"
                                    :handleDefaultCustomFields="handleDefaultCustomFields"
                                    :customFieldsBySlug="customFieldsBySlug['gohighlevel']"
                                    :listValueFieldsIntegration="listValueFieldsIntegrationGohighlevel"
                                    :listValueFieldsIntegrationB2b="listValueFieldsIntegrationGohighlevelb2b"
                                    :listValueFieldsIntegrationAdvance="listValueFieldsIntegrationGohighleveladvance"
                                    :handleCheckItemCustomFields="handleCheckItemCustomFields"
                                    :isHideB2b="isHideB2b"
                                    :isHideAdvance="isHideAdvance"
                                    :handleCheckAllCustomFields="handleCheckAllCustomFields"
                                    :isCheckAllIntegrationGeneral="isCheckAllIntegrationGeneral"
                                    :isCheckAllIntegrationB2b="isCheckAllIntegrationB2b"
                                    :isCheckAllIntegrationAdvance="isCheckAllIntegrationAdvance"
                                />
                            </template>
                            <!-- <el-divider content-position="left">Custom Fields</el-divider>
                            <div class="checkbox-field-integration">
                                <div v-for="(item, index) in customFieldsBySlug['gohighlevel']" :key="index">
                                    <el-checkbox :label="item" v-model="listValueFieldsIntegrationGohighlevel">{{item}}</el-checkbox>
                                </div>
                            </div> -->
                        </div>
                        <div v-if="selectedIntegration === 'sendgrid'" class="''">
                            <el-checkbox v-model="enabledconntector.sendgrid">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label">
                                <label class="mt-1">Enter your API Key</label>
                                <el-input type="text" clearable label="Enter your API Key" placeholder="GJYEzzse345673htj"
                                    class="flex-grow-1 mb-0" v-model="userApiKey.sendgrid" aria-controls="datatables">
                                </el-input>
    
                            </div>
    
    
                        </div>
                        <div v-if="selectedIntegration === 'kartra'" class="''">
                            <el-checkbox v-model="enabledconntector.kartra">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label">
                                <label class="mt-1">Enter your API Key</label>
                                <el-input type="text" clearable label="Enter your API Key" placeholder="GJYEzzse345673htj"
                                    class="flex-grow-1 mb-0" v-model="userApiKey.kartra" aria-controls="datatables">
                                </el-input>
    
                            </div>
                            <div class="has-label">
                                <label class="mb-0">Enter your API Password</label>
                                <el-input type="text" clearable label="Enter your API Password"
                                    placeholder="GJYEzzse345673htj" class="flex-grow-1 mb-0" v-model="kartraApiPassword"
                                    aria-controls="datatables">
                                </el-input>
    
                            </div>
                            <!-- <div class="has-label">
                                <label class="mb-0">Enter your App ID</label>
                                <el-input type="text" clearable label="Enter your App ID"
                                     placeholder="GJYEzzse345673htj" class="flex-grow-1 mb-0" v-model="kartraAppId" aria-controls="datatables">
                                </el-input>
    
                            </div> -->
    
    
                            <p class="mt-4 d-block"><strong>Note:</strong> When you click Save, this app will create the
                                below custom fields in your Kartra account. These fields are Required for this connection to
                                work properly.
                                As per Kartra's policy, once a custom field is deleted, it cannot be recreated. Therefore,
                                <span class="text-underline">Do NOT</span> delete or rename the below custom fields in your
                                Kartra account. <strong style="cursor: pointer;" v-if="!showKartraCustomFields"
                                    @click="showKartraCustomFields = !showKartraCustomFields">show more</strong>
                            </p>
    
                            <ul v-show="showKartraCustomFields" class="text-dark">
                                <li class="text-dark">secondphone</li>
                                <li class="text-dark">secondemail</li>
                                <li class="text-dark">keyword</li>
                                <li class="text-dark">secondaddress</li>
                            </ul>
                        </div>
                        <div v-if="selectedIntegration === 'zapier'" class="''">
                            <el-checkbox v-model="enabledconntector.zapier">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label">
                                <label class="mt-1">Enter your Webhook URL</label>
                                <div style="display: flex; flex-direction: column; gap: 8px;">
                                    <div v-for="(url, index) in userApiKey.zapier" :key="index" class="webhook-url-wrapper">
                                        <el-input 
                                            type="text" 
                                            clearable 
                                            label="Enter your Webhook URL"
                                            placeholder="https://hooks.app.com/hooks/catch/....." 
                                            class="flex-grow-1 mb-0"  
                                            v-model="userApiKey.zapier[index]"  
                                            aria-controls="datatables" 
                                            @keyup.native="addWebhookUrlKeyupEnter($event, 'zapier')" 
                                            :ref="'webhookInput-' + index">
                                        </el-input>
                                        <span v-if="index == 0" class="add-webhook-url" @click="addWebhookUrl('zapier')">
                                            <i class="fa-solid fa-plus"></i>
                                        </span>
                                        <span v-if="index != 0 && userApiKey.zapier.length > 1" class="add-webhook-url" @click="removeWebhookUrl(index, 'zapier')">
                                            <i class="fa-solid fa-minus"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex mt-4">
                                <el-checkbox  v-model="enabledconntector.sendTestZapier" class="mt-2 mr-3">Send Test Data</el-checkbox>
                                   <div class="d-flex align-items-center">
                                    <el-button
                                        class="mr-2 mb-1"
                                        :icon="'el-icon-view'"
                                        @click="onViewExampleData"
                                        style="width: 10px; height: 10px; padding: 0; background-color: transparent; color: var(--text-primary-color); border: none;"></el-button>
                                        <el-button type="text" @click="onViewExampleData" style="margin-left: 0px;">View Example Data</el-button>
                                    </div>
                            </div>
                            <p class="m-0"><small>* check and click save to send dummy data to your webhook</small></p>
                            <p class="m-0 pl-2"><strong>Need help setting up your webhook?</strong> Check out the documentation:</p>
                            <p class="m-0 pl-2"><a href="https://api.slack.com/messaging/webhooks" target="_blank">Slack</a> | <a href="https://developers.make.com/custom-apps-documentation/app-structure/modules/instant-trigger" target="_blank">Make</a> | <a href="https://help.zapier.com/hc/en-us/articles/8496083355661-How-to-get-started-with-Webhooks-by-Zapier" target="_blank">Zapier</a> | <a href="https://www.pabbly.com/beginners-guide-to-webhook-integration-with-pabbly-connect/" target="_blank">Pabbly</a> | <a href="https://www.zoho.com/developer/help/extensions/automation/webhooks.html" target="_blank">ZoHo</a> | <a href="https://developers.hubspot.com/docs/guides/api/app-management/webhooks" target="_blank">HubSpot</a></p>
                        </div>
                        <div v-if="selectedIntegration === 'mailboxpower'" class="''">
                            <el-checkbox v-model="enabledconntector.mailboxpower">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label">
                                <label class="mt-1">Enter your API Key</label>
                                <el-input type="text" clearable label="Enter your API Key" placeholder="AssAW02A02ksjsklah"
                                    class="flex-grow-1 mb-0" v-model="userApiKey.mailboxpower" aria-controls="datatables">
                                </el-input>
    
                            </div>
                            <div class="d-flex" style="flex-direction: column; gap: 12px; margin-top: 25px" v-if="referralCodeActive != ''">
                               <span style="display: flex; align-items: center;gap: 8px">
                                <el-button
                                    size="medium"
                                    icon="el-icon-unlock"
                                    @click="redirectToLink(`https://app.mailboxpower.com/join/agency?invite=${referralCodeActive}`)"
                                    circle
                                 
                                    ></el-button> <span>If you do not have a {{ nameActiveIntegration }} account, <a style="color: inherit !important;font-size: inherit;font-weight: bold;" :href="`https://app.mailboxpower.com/join/agency?invite=${referralCodeActive}`" target="_blank">Click Here</a> to create one</span>
                                </span>
                                <span style="display: flex; align-items: center;gap: 8px">
                                <el-button
                                    size="medium"
                                    icon="el-icon-s-promotion"
                                    @click="redirectToLink(`https://app.mailboxpower.com/demo/${referralCodeActive}`)"
                                    circle
                                    ></el-button> 
                                <a style="color: inherit !important;font-size: inherit;font-weight: inherit" class="d-block" :href="`https://app.mailboxpower.com/demo/${referralCodeActive}`" target="_blank">Learn More about the Integration</a>
                            </span>
                            </div>
                            
    
    
                        </div>
                        <div v-if="selectedIntegration === 'clickfunnels'" style="display: flex; flex-direction: column; gap: 8px;">
                            <el-checkbox v-model="enabledconntector.clickfunnels">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label">
                                <label class="mb-0">Enter your API Key</label>
                                <el-input type="text" clearable label="Enter your API Key" placeholder="Xg7Pq-K9vTzJ_OLmAB3cYRDx5WNF24sMEUhCo6J0VaI"
                                class="flex-grow-1 mb-0" v-model="userApiKey.clickfunnels" aria-controls="datatables">
                            </el-input>
                            </div>
                            <div class="has-label">
                                <label class="mb-0">Subdomain</label>
                                <el-input v-model="clickfunnels.subdomain" type="text" clearable label="Enter your subdomain"
                                    placeholder="richstone" class="flex-grow-1 mb-0"
                                    aria-controls="datatables">
                                    <template :slot="windowWidth > 576 && 'prepend'">https://</template>
                                    <template :slot="windowWidth > 576 && 'append'">.myclickfunnels.com</template>
                                </el-input>
                                <small v-if="windowWidth < 576" class="wrap-text">Example: https://{{ clickfunnels.subdomain ? clickfunnels.subdomain : 'yoursubdomain' }}.myclickfunnels.com</small>
                            </div>
                            <div class="has-label">
                                <label class="mb-0">Workspace ID</label>
                                <el-input v-model="clickfunnels.workspaceId" type="text" clearable label="Enter your workspaces"
                                    placeholder="jWMWXZ" class="flex-grow-1 mb-0"
                                    aria-controls="datatables">
                                    <template :slot="windowWidth > 768 && 'prepend'">https://{{ clickfunnels.subdomain }}.myclickfunnels.com/account/workspaces/</template>
                                </el-input>
                                <small v-if="windowWidth < 768" class="wrap-text">Example: https://{{ clickfunnels.subdomain ? clickfunnels.subdomain : 'yoursubdomain' }}.myclickfunnels.com/account/workspaces/workspaceid</small>
                            </div>
    
                            <template>
                                <CheckboxCustomFields
                                    :slug="'Clickfunnels'"
                                    :isLoadingCustomFieldsBySlug="isLoadingCustomFieldsBySlug"
                                    :isErrorCustomFieldsBySlug="isErrorCustomFieldsBySlug"
                                    :handleDefaultCustomFields="handleDefaultCustomFields"
                                    :customFieldsBySlug="customFieldsBySlug['clickfunnels']"
                                    :listValueFieldsIntegration="listValueFieldsIntegrationClickfunnels"
                                    :listValueFieldsIntegrationB2b="listValueFieldsIntegrationClickfunnelsb2b"
                                    :handleCheckItemCustomFields="handleCheckItemCustomFields"
                                    :isHideB2b="isHideB2b"
                                    :isHideAdvance="isHideAdvance"
                                    :handleCheckAllCustomFields="handleCheckAllCustomFields"
                                    :isCheckAllIntegrationGeneral="isCheckAllIntegrationGeneral"
                                    :isCheckAllIntegrationB2b="isCheckAllIntegrationB2b"
                                    :isCheckAllIntegrationAdvance="isCheckAllIntegrationAdvance"
                                />
                            </template>
                        </div>
                        <div v-if="selectedIntegration === 'agencyzoom'" class="''">
                            <el-checkbox v-model="enabledconntector.agencyzoom">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label">
                                <label class="mt-1">Enter your Webhook URL</label>
                                <div style="display: flex; flex-direction: column; gap: 8px;">
                                    <div v-for="(url, index) in userApiKey.agencyzoom" :key="index" class="webhook-url-wrapper">
                                        <el-input 
                                            type="text" 
                                            clearable 
                                            label="Enter your Webhook URL" 
                                            placeholder="https://app.agencyzoom.com/v1/api/lead/webhook/....." 
                                            class="flex-grow-1 mb-0"  
                                            v-model="userApiKey.agencyzoom[index]" 
                                            aria-controls="datatables" 
                                            @keyup.native="addWebhookUrlKeyupEnter($event, 'agencyzoom')" 
                                            :ref="'zoomAgencywebhookInput-' + index">
                                        </el-input>
                                        <span v-if="index == 0" class="add-webhook-url" @click="addWebhookUrl('agencyzoom')">
                                            <i class="fa-solid fa-plus"></i>
                                        </span>
                                        <span v-if="index != 0 && userApiKey.agencyzoom.length > 1" class="add-webhook-url" @click="removeWebhookUrl(index, 'agencyzoom')">
                                            <i class="fa-solid fa-minus"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <el-checkbox v-model="enabledconntector.sendTestAgencyZoom" class="mt-2">Send Test Data</el-checkbox>
                            <p class="m-0"><small>* check and click save to send dummy data to your webhook</small></p>
                        </div>
                        <div v-if="selectedIntegration === 'sendjim'" class="''">
                            <el-checkbox v-model="enabledconntector.sendjim">Enable {{ nameActiveIntegration }}</el-checkbox>
                            <div class="has-label" style="margin-top: 10px; margin-bottom: 20px;">
                                <p v-if="sendjimConnected">You have connected SendJim for this client.</p>
                                <p v-else>You have not yet connected SendJim for this client.</p>
                            </div>
                            <div>
                                <base-button id="btnConnectDisconnectSendjim" :disabled="isLoadingConnectDisconnectSendjim" @click="connectDisconnectSendjim">
                                    {{ btnConnectDisconnectSendjimText }}
                                    <i v-if="isLoadingConnectDisconnectSendjim" class="fas fa-spinner fa-spin ml-2" style="font-size: 20px;"></i>
                                </base-button>
                            </div>
                            <el-divider content-position="left">Connect using OAuth2</el-divider>
                            <div class="has-label" style="margin-bottom: 16px;">
                                <label class="mb-0">OAuth Redirect URL</label>
                                <el-input :value="sendjimCallbackUrl" readonly class="flex-grow-1 mb-0">
                                    <el-button slot="append" icon="el-icon-document-copy" @click="copyToClipboard(sendjimCallbackUrl)"></el-button>
                                </el-input>
                                <small>Use the URL above as your OAuth callback/redirect URL in SendJim.</small>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="has-label">
                                        <label class="mb-0">Client ID <span style="color: var(--danger);">*</span></label>
                                        <el-input v-model="userApiKey.sendjim" type="text" clearable placeholder="Enter your SendJim Client ID" class="flex-grow-1 mb-0" aria-controls="datatables"></el-input>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="has-label">
                                        <label class="mb-0">Client Secret <span style="color: var(--danger);">*</span></label>
                                        <el-input v-model="sendjim.clientSecret" type="password" show-password clearable placeholder="Enter your SendJim Client Secret" class="flex-grow-1 mb-0" aria-controls="datatables"></el-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template slot="footer">
                <div style="display: flex;justify-content: space-between;" class="integrations-modal-footer-wrapper">
                    <div style="width: 600px;font-size: 12px;">
                            Note: Some of the links on this site are affiliate links, meaning we may earn a commission if you sign up or make a purchase through them. This helps support our work at no additional cost to you.
                        </div>
                    <div class="d-flex align-items-center justify-content-end">
                        <base-button @click.native="modals.integrations = false">Cancel</base-button>
                        <base-button id="btnSaveIntegration"
                            @click.native="saveIntegrationSettingslocal">Save</base-button>
                    </div>
                </div>
            </template>
        </modal>

        <!-- Modal integration settings -->
        <!-- WhiteList DB upload -->
        <modal :show.sync="modals.whitelist" id="clientWhitelist" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">Client Wide Exclusion List</h4>
            <div>
                <!--UPLOAD-->
                <form enctype="multipart/form-data">
                    <!--<h5>Drag & Drop your suppression List (file type should be .csv). Download <a href="#">example file</a></h5>-->
                    <div class="dropbox">
                        <input type="file" :name="uploadFieldName" :disabled="isSaving"
                            @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                            accept=".csv" class="input-file">
                        <p v-if="isInitial">
                            Drag your file here to upload<br />or click to browse<br />
                            <!--<base-button type="info" round icon  @click="show_helpguide('suppression')">
                                <i class="fas fa-question"></i>
                            </base-button>-->
                        </p>
                        <p v-if="isSaving">
                            Please Wait, your file being upload ...
                        </p>
                        <p v-if="isSuccess">
                            Your Suppression file has been Submitted, Thank you!
                        </p>
                        <p v-if="isFailed">
                            Whoops that did not work, please check your file for errors and try again
                        </p>
                    </div>
                </form>
            </div>
            <div v-if="supressionProgress.length > 0">
                <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                    <div v-for="(value) in supressionProgress" :key="value.id">
                        <div style="display: flex; width: 100%; gap: 8px;">
                            <img src="/img/csv-logo.png" alt="csv-logo" style="height: 60px;" />
                            <div style="width: 100%;">
                                <p style="color: #000000; font-weight: 600; margin-bottom: 0px;">{{ value.filename }}</p>
                                <el-progress :percentage="value.percentage == null ? 0 : value.percentage"></el-progress>
                                <p style="margin-bottom: 0px; opacity: 0.8;">{{ value.current_row }} of {{ value.total_row }} rows</p>
                            </div>
                        </div>
                        <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                    </div>
            </div>
            <div class="pt-2 mt-3">
                You have the ability to restrict your current database from being identified as a new contact. 
                                You can Exclude them by uploading a list of MD5 encrypted email addresses, 
                                or by uploading a list of email addresses and we will encrypt them for you. 
                                Do not include any other information in the file aside from the email address. 
                                You may upload lists of up to 10,000 records at a time. <a
                                 href='https://app.exactmatchmarketing.com/samplefile/suppressionlist.csv' target='_blank'>Click here</a> to download a Sample File
                <div class="text-center" v-if="optoutfileexist">Your current exclusion list: <a
                        :href="optoutpath + '/tools%2Foptout%2Fclientoptoutlist_' + whiteListClientID + '.csv'"
                        target="_blank">download here</a></div>
            </div>
            <div v-if="supressionDone.length > 0">
                <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                <div v-for="(value) in supressionDone" :key="value.id">
                    <div style="display: flex; width: 100%; gap: 8px;">
                        <img src="/img/csv-logo.png" alt="csv-logo" style="height: 60px;" />
                        <div style="width: 100%;">
                            <p style="color: #000000; font-weight: 600; margin-bottom: 0px;">{{ value.filename }}</p>
                            <el-progress :percentage="value.percentage" status="success"></el-progress>
                            <p style="margin-bottom: 0px; opacity: 0.8;">{{ value.current_row }} of {{ value.total_row }} rows</p>
                        </div>
                    </div>
                    <div style="height: 1px; background-color: #ddd; margin: 16px 0;"></div>
                </div>
            </div>
            <a class="mt-2 d-inline-block" @click="purgeSuppressionList('client')" style="cursor: pointer;"><i
                    class="fas fa-trash"></i> Purge Existing Records</a>
            <template slot="footer">
                <div class="pb-4 d-flex justify-content-center w-100">
                    <base-button @click.native="modals.whitelist = false">Cancel</base-button>
                </div>
            </template>
        </modal>
        <!-- WhiteList DB upload -->

        <!-- help modal start -->
        <modal :show.sync="modals.help" headerClasses="">
            <div slot="header" class="d-flex flex-column gap-4">
                <h4  class="title title-up">{{activeHelpItem.title}}</h4> 
            </div>
            <div v-if="modals.help" v-html="activeHelpItem.embedVideoCode"></div>
            <p v-if="activeHelpIndex == 0" class="text-dark mt-4" style="font-size: 14px;">
                In this section you have full management of your clients.
                <br>The first thing you'll notice is the ability to add a client.
                <br>When you add a client it will send an invite to them so they may continue onboarding themselves, agree to the terms and conditions and add their credit card. When adding a client you have the ability to activate the products that are visible to them, if any, as well as disable their ability to add campaigns, or disable all system emails to the client. We do not recommend you ever disable all system emails to the client unless you get the terms of service electronically signed separately to their onboarding.
                <br>The terms of service can be found for each client by clicking on the credit card icon for that client and scrolling to the bottom and clicking on the link for the terms of service. 
                <strong 
                    v-if="!showMoreHelp"
                    style="cursor: pointer;" 
                    @click="showMoreHelp = !showMoreHelp">
                    show more
                </strong>
                <span v-if="showMoreHelp">
                    <br>Our attorneys have provided privacy policies, terms of service, and a service contract that protects both the agency and the platform.
                    <br>You will also see that you can filter your clients to see if their credit card is set up or failed and if they have active or inactive campaigns.
                    <br>When looking at the client's dashboard you will see their basic information first as well as the date they were created. The gray credit card shows that it has never been set up. Green means that they have completed their onboarding and red means that their card has failed and it needs to be updated. If a payment fails all of their campaigns will be paused and when they log into their dashboard it will redirect them to the credit card settings so they can update their card. As the agency, you could also click on the card and update it from the dashboard side on behalf of the client.
                    <br>Next you'll see a green bubble that will give the count for how many active campaigns and a gray bubble that will give the count for paused or stopped campaigns.
                    <br>Next you will see an icon that looks like a power plug. This is to manage the integrations and plugins for this client. Here you will set up the specific API keys or web hooks for the clients specific integrations. The integration or plugin will not display for the client's campaigns unless it is first enabled here at the client level. The client also can enable their own plugins and integrations in their own dashboard settings. The next button is a simple edit button where you can edit the clients permission levels, manually update their password if needed, or click the resend invitation button to have the system automatically create a randomized password and send it to them to login.
                    <br>The next button is the client level exclusion list. Here you can upload up to 10,000 records at a time and this will exclude them from ever being captured in any of the campaigns. This is especially important for large clients who already have databases with existing and past customers. You can upload a list of email addresses already encrypted into an MD5 hash, or upload a list of raw email addresses and we will encrypt it on our side.
                    <br>The next button is where you can customize the pricing for that individual client. If you make adjustments here it will adjust any newly created campaigns, but it will not adjust any campaigns that were already created for that client.
                    <br>The final button is for you to remove a client from your dashboard. 
                    <strong 
                        v-if="showMoreHelp"
                        style="cursor: pointer;" 
                        @click="showMoreHelp = !showMoreHelp"> 
                        show less
                    </strong>
                </span>
            </p>
            <p v-else class="text-dark mt-4" style="font-size: 14px;" v-html="activeHelpItem.desc"></p>
        </modal>
          <!-- Help modal end -->
    </div>
</template>
<script>
import { extend } from "vee-validate";
import { required, email} from "vee-validate/dist/rules";
import { DatePicker, Table, TableColumn, Select, Option,Checkbox, Dropdown, DropdownMenu, DropdownItem,CollapseItem,Collapse,Button, Progress, Divider, MessageBox, Loading, Tabs, TabPane, Timeline, TimelineItem } from 'element-ui';
import { BasePagination,Modal, SkeletonCheckbox } from 'src/components';
import Fuse from 'fuse.js';
import swal from 'sweetalert2';
import moment from 'moment';
import { mapActions } from "vuex";
import VuePhoneNumberInput from '@/components/VuePhoneNumberInput';
import axios from 'axios';
import { formatCurrencyUSD } from '@/util/formatCurrencyUSD'
import { downloadFileInBackground, downloadFileInBackgroundPdf } from '../../../../helpers/downloadFile'
import { emailPattern } from '../../../../util/validation'
import { decryptData } from '../../../../helpers/crypto'
import CheckboxCustomFields from '../../../../components/CheckboxCustomFields.vue'
import { DOCUMENTS } from "../../../../shared/constants";

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

extend("email", email);
extend("required", required);

var _elements;
var _cardElement;
var _stripe;
var _CardValidate;
var _tokenid = '';
var _sppubkey = '';
var _this;

export default {
    components: {
        Modal,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Checkbox.name]: Checkbox,
        BasePagination,
        VuePhoneNumberInput,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
        [Progress.name]: Progress,
        [Divider.name]: Divider,
        SkeletonCheckbox,
        CheckboxCustomFields,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
        [Timeline.name]: Timeline,
        [TimelineItem.name]: TimelineItem,
    },
    data() {
        return {
            showPassword : false ,
            showMoreHelp:false,
            dropdownVisible: false,
            clientMinLeadDayEnhance: '',
            errMinLeadDay: false, 
            basicExampleDataUrl: 'https://sitesettings-api-docs.vercel.app/agency/informations/send-test',
            filters:{
                cardStatus:{
                    show:false,
                    active:false,
                    failed:false,
                    inactive:false
                },
                campaignStatus:{
                    show:false,
                    active:false,
                    inactive:false,
                }
            },
            termhost:'',
            showKartraCustomFields:'',
            integrations: [
                {
                    name: 'Twilio SendGrid',
                    description: 'Deliver Exceptional Email Experiences with SendGrid',
                    icon: 'fa-solid fa-cloud-arrow-up',
                    active: '3',
                    slug: 'sendgrid',
                    refcode: ''
                },
                {
                    name: 'Lead Connector',
                    description: 'Get Better Clicks & Engagement - Enhance Your Email Campaigns.',
                    icon: 'fa-light fa-cube',
                    active: '4',
                    slug: 'gohighlevel',
                    refcode: ''
                },
                {
                    name: 'Kartra',
                    description: 'This is Kartra intergration .',
                    icon: 'fa-solid fa-k',
                    active: '5',
                    slug: 'kartra',
                    refcode: ''
                },
                {
                    name: 'Zapier/Webhooks',
                    description: 'This is Zapier intergration .',
                    icon: 'fa-solid fa-link',
                    active: '6',
                    slug: 'zapier',
                    refcode: ''
                },
                {
                    name: 'MailBoxPower',
                    description: 'Get Better Clicks & Engagement - Enhance Your Email Campaigns.',
                    icon: 'fa-regular fa-envelope-open',
                    active: '7',
                    slug: 'mailboxpower',
                    refcode: 'C8GWKU'
                },
                {
                    name: 'ClickFunnels',
                    description: 'Build High-Converting Sales Funnels - Turn Visitors into Customers Easily.',
                    icon: 'fas fa-mouse-pointer',
                    active: '8',
                    slug: 'clickfunnels',
                    refcode: ''
                },
                {
                    name: 'Zoom Agency',
                    description: 'This is Zoom Integration intergration .',
                    icon: 'fa-solid fa-diagram-project',
                    active: '9',
                    slug: 'agencyzoom',
                    refcode: ''
                },
                {
                    name: 'SendJim',
                    description: 'Direct Mail Marketing.',
                    icon: 'fa-solid fa-diagram-project',
                    active: '10',
                    slug: 'sendjim',
                    refcode: ''
                },
                // {
                //     name: 'Webhook',
                //     description: 'Webhook Integration.',
                //     img: 'fa-solid fa-link',
                //     active: '7',
                //     slug: 'webhook'
                // },
            ],
            nameActiveIntegration: 'Sendgrid',
            referralCodeActive: '',
            /** FOR SUPRESSION UPLOAD FILE */
            uploadedFiles: [],
            uploadError: null,
            currentStatus: null,
            uploadFieldName: 'clientoptoutfile',
            /** FOR SUPRESSION UPLOAD FILE */
            selectedIntegration: 'sendgrid',
            selectedModule: 'LeadsPeek',
             tableDataOri:[],
             tableData: [],
             fuseSearch: null,
             searchedData: [],
             searchQuery: '',
             pagination: {
                perPage: 10,
                currentPage: 1,
                //perPageOptions: [5, 10, 25, 50],
                total: 0,
                from: 0,
                to: 0,
            },

            currCardHolder: '',
            currCardlastdigit: '',
            currCardType: '',

            cardholdername: '',
            billingaddress: '',
            city: '',
            zipcode: '',
            selects: {
                state: '',
                country: '',
                statelist: [],
                ghlv2SubAccount: ''
            },
            paginationGhlV2SubAccount: {
                currentPage: 1,
                isComplete: false,
                isFetch: false,
            },
            agreeTerm:false,
            showErrorMessage:false,
            cardfailetoload:false,
            agreeTermStat:false,
            btncardupdate: false,

            modals: {
                helpguide: false,
                pricesetup: false,
                cardsetup: false,
                cardupdate: false,
                integrations: false,
                whitelist: false,
                cardretrycharge: false,
                help:false,
            },
            cardretrychargeTitle: '',
            cardretrychargeTxt: '',
            helpContentMap: [
                {   
                    title:'Clients',
                    embedVideoCode:'<iframe src="https://drive.google.com/file/d/1oTshTuYqnQg-LYUNYrpcU0UNiEI1S_5g/preview" width="100%" height="480" allow="autoplay"></iframe>',
                    desc:'In this section you can add and edit your system administrators. We do not charge for administrators so you may add as many as you need for your business.<br>Make sure that every administrator and client has a unique email address, as email addresses are used for access permissions.<br>If you set someone as a default admin, they will receive new campaign creation notices as well as have this email address added as an editor by default to all the Google sheets that are created. You may have unlimited default admins.<br>The customer care selection is singular. You can only have one customer care admin in the system as this is used as a token in the email templates.<br>The third checkbox is if an admin wants to receive notifications of failed billing.<br>An admin can be set as one two or three check boxes. They are not exclusive.'
                },
                { 
                    title: 'Site ID Basic Information',
                    desc: "Site ID campaigns can use either Basic information or Advanced information, similar to Enhance ID. You must set the retail price for each of these data options independently of each other.",
                    embedVideoCode: '<iframe src="https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/basicdata.jpeg" width="100%" height=180></iframe>'
                },
                {
                    title: 'Site ID Advanced Information',
                    desc: "Site ID campaigns can use either Basic information or Advanced information, similar to Enhance ID. You must set the retail price for each of these data options independently of each other.",
                    embedVideoCode: '<iframe src="https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/advancedata.jpeg" width="100%" height=230></iframe>'
                }
            ],
            activeHelpItem:  { 
                title:'Clients',
                embedVideoCode:'<iframe src="https://drive.google.com/file/d/1oTshTuYqnQg-LYUNYrpcU0UNiEI1S_5g/preview" width="100%" height="480" allow="autoplay"></iframe>',
                desc:'In this section you can add and edit your system administrators. We do not charge for administrators so you may add as many as you need for your business.<br>Make sure that every administrator and client has a unique email address, as email addresses are used for access permissions.<br>If you set someone as a default admin, they will receive new campaign creation notices as well as have this email address added as an editor by default to all the Google sheets that are created. You may have unlimited default admins.<br>The customer care selection is singular. You can only have one customer care admin in the system as this is used as a token in the email templates.<br>The third checkbox is if an admin wants to receive notifications of failed billing.<br>An admin can be set as one two or three check boxes. They are not exclusive.'
            },
            activeHelpIndex: 0,
            companyID:'',
            selectedRowIndex: 0,
            selectedRowData: {},
            ClientCompanyName: '',
            ClientFullName: '',
            ClientEmail: '',
            clientPhoneNumber:{
                number:'',
                countryCode:'US',
                countryCallingCode:'+1'
            },
            clientRowPhoneNumber:{
                number:'',
                countryCode:'US',
                countryCallingCode:'+1'
            },
            ClientPhone: '',
            ClientActiveID: '',
            ClientDomain:'',
            LeadspeekCompany: '',

            LeadspeekPlatformFee: '0',
            LeadspeekCostperlead: '0',
            LeadspeekCostperleadAdvanced: '0',
            LeadspeekMinCostMonth: '0',
            LeadspeekLeadsPerday: '10',
            LeadspeekEnableMinimumLeadsPerDay: false,

            LocatorPlatformFee: '0',
            LocatorCostperlead: '0',
            LocatorMinCostMonth: '0',
            LocatorLeadsPerday: '10',
            LocatorEnableMinimumLeadsPerDay: false,

            EnhancePlatformFee: '0',
            EnhanceCostperlead: '0',
            EnhanceMinCostMonth: '0',
            EnhanceLeadsPerday: '10',
            EnhanceEnableMinimumLeadsPerDay: false,
            
            B2bPlatformFee: '0',
            B2bCostperlead: '0',
            B2bMinCostMonth: '0',
            B2bLeadsPerday: '10',
            B2bEnableMinimumLeadsPerDay: false,

            SimplifiMaxBid: '0',
            SimplifiDailyBudget: '0',
            SimplifiAgencyMarkup: '0',
            simplifiPriceRule: {
                maxBid: {
                    default: 12,
                    minimum: 8
                },
                dailyBudget: {
                    minimum: 5
                },
            },
            simplifiErrorInput: {
                maxBid: "",
                dailyBudget: ""
            },
            agencyMarkup: {
                list : [
                    {
                        value : 0,
                        text : '0%',
                    },
                    {
                        value : 5,
                        text : '5%',
                    },
                    {
                        value : 10,
                        text : '10%',
                    },
                    {
                        value : 15,
                        text : '15%',
                    },
                    {
                        value : 20,
                        text : '20%',
                    },
                    {
                        value : 25,
                        text : '25%',
                    },
                    {
                        value : 30,
                        text : '30%',
                    },
                    {
                        value : 40,
                        text : '40%',
                    },
                    {
                        value : 50,
                        text : '50%',
                    },
                ]
            },


            LeadspeekInputReadOnly: false,
            prevDefaultRetailPrice: null,
            activeClientID: '',

            userData: '',
            m_LeadspeekCostPerLead:0,
            m_LeadspeekCostPerLeadAdvanced:0,
            m_LeadspeekLocatorCostPerLead:0,
            m_LeadspeekEnhanceCostPerLead:0,
            m_LeadspeekB2BCostPerLead:0,
            m_LeadspeekPlatformFee: 0,
            m_LeadspeekMinCostMonth: 0,
            m_LeadspeekLocatorPlatformFee: 0,
            m_LeadspeekLocatorMinCostMonth: 0,
            m_LeadspeekEnhancePlatformFee: 0,
            m_LeadspeekEnhanceMinCostMonth: 0,
            m_LeadspeekB2BPlatformFee: 0,
            m_LeadspeekB2BMinCostMonth: 0,
            rootCostAgency : {
                local : {
                    'Weekly' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                    },
                    'Monthly' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                    },
                    'OneTime' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                    }
                },

                locator : {
                    'Weekly' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    },
                    'Monthly' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    },
                    'OneTime' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                    }
                },

                enhance : {
                    'Weekly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    },
                    'Monthly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    },
                    'OneTime' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                    }
                },

                b2b : {
                    'Weekly' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    },
                    'Monthly' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    },
                    'OneTime' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    },
                    'Prepaid' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                    }
                },

                locatorlead: {
                    FirstName_LastName: '0',
                    FirstName_LastName_MailingAddress: '0',
                    FirstName_LastName_MailingAddress_Phone: '0',
                }
            },

            lead_FirstName_LastName : '0',
            lead_FirstName_LastName_MailingAddress: '0',
            lead_FirstName_LastName_MailingAddress_Phone: '0',

            costagency : {
                local : {
                    'Weekly' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'Monthly' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'OneTime' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '10',
                    },
                    'Prepaid' : {
                        LeadspeekPlatformFee: '0',
                        LeadspeekCostperlead: '0',
                        LeadspeekCostperleadAdvanced: '0',
                        LeadspeekMinCostMonth: '0',
                        LeadspeekLeadsPerday: '50',
                    }
                },

                locator : {
                    'Weekly' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                        LocatorLeadsPerday: '10',
                    },
                    'Monthly' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                        LocatorLeadsPerday: '10',
                    },
                    'OneTime' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                        LocatorLeadsPerday: '10',
                    },
                    'Prepaid' : {
                        LocatorPlatformFee: '0',
                        LocatorCostperlead: '0',
                        LocatorMinCostMonth: '0',
                        LocatorLeadsPerday: '10',
                    }
                },

                enhance : {
                    'Weekly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '10',
                    },
                    'Monthly' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '10',
                    },
                    'OneTime' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '10',
                    },
                    'Prepaid' : {
                        EnhancePlatformFee: '0',
                        EnhanceCostperlead: '0',
                        EnhanceMinCostMonth: '0',
                        EnhanceLeadsPerday: '10',
                    }
                },

                b2b : {
                    'Weekly' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                        B2bLeadsPerday: '10',
                    },
                    'Monthly' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                        B2bLeadsPerday: '10',
                    },
                    'OneTime' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                        B2bLeadsPerday: '10',
                    },
                    'Prepaid' : {
                        B2bPlatformFee: '0',
                        B2bCostperlead: '0',
                        B2bMinCostMonth: '0',
                        B2bLeadsPerday: '10',
                    }
                },

                locatorlead: {
                    FirstName_LastName: '0',
                    FirstName_LastName_MailingAddress: '0',
                    FirstName_LastName_MailingAddress_Phone: '0',
                }
            },

            activeClientCompanyID: '',
            activeClientCompanyIndex: '',

            txtLeadService: 'per week',
            txtLeadIncluded: 'in that weekly charge',
            txtLeadOver: 'from the weekly charge',

            selectsPaymentTerm: {
                PaymentTermSelect: 'Weekly',
                PaymentTerm: [
                    // { value: 'One Time', label: 'One Time'},
                    // { value: 'Weekly', label: 'Weekly'},
                    // { value: 'Monthly', label: 'Monthly'},
                ],
            },
            selectsAppModule: {
                AppModuleSelect: 'LeadsPeek',
                AppModule: [
                    { value: 'LeadsPeek', label: 'LeadsPeek' },
                ],
                LeadsLimitSelect: 'Day',
                LeadsLimit: [
                    { value: 'Day', label: 'Day'},
                ],
            },

            selectsPTAds: {
                    PTAdsSelect: 'By Fix Amount',
                    PTAds: [
                        { value: 'By Fix Amount', label: 'By Fix Amount' },
                        { value: 'By Percentage', label: 'By Percentage' },
                        
                    ],
            },

            disabledreceiveemail: false,
            openFiletrs: false,
            disabledaddcampaign:false,
            seteditor:false,
            enablephonenumber:false,
            checkboxes: {
                phoneenabled: false,
            },
            rowCheckboxes: {
                phoneenabled: false,
            },
            integrationDetails:{},
            userApiKey: {
                sendgrid: '',
                gohighlevel: '',
                kartra: '',
                zapier:[''],
                mailboxpower: '',
                clickfunnels: '',
                agencyzoom: [''],
                sendjim: '',
            },

            ghlV2Connected: false,
            btnConnectDisconnectGhlv2Text: 'Activate Contact Sync',
            isLoadingConnectDisconnectGhlv2: false,

            ghlV2ListSubAccounts: [],
            ghlV2AgencyConnected: false,
            ghlV2CreatedIframe: false,
            btnCreateDeleteIframeGhlv2Text: 'Create SSO Link',
            isLoadingCreateDeleteIframeGhlV2: false,

            kartraApiPassword:'',
            kartraAppId:'',
            integrationVersion: {
                gohighlevel: "1",
                sendjim: "4",
            },
            // SendJim OAuth-only state
            sendjimConnected: false,
            btnConnectDisconnectSendjimText: 'Connect SendJim',
            isLoadingConnectDisconnectSendjim: false,
            sendjimAuthType: 'oauth2',
            enabledconntector: {
                sendgrid: false,
                gohighlevel: false,
                kartra: false,
                zapier:false,
                sendTestZapier: false,
                mailboxpower: false,
                clickfunnels: false,
                agencyzoom: false,
                sendTestAgencyZoom: false,
                sendjim: false,
            },
            sendjim: {
                clientSecret: '',
            },
            clickfunnels: {
                subdomain: '',
                workspaceId: '',
            },
            currentRowIndex:0,
            whiteListClientID: '',
            optoutfileexist: false,
            optoutpath: process.env.VUE_APP_CDN,
            clientPaymentFailed: false,
            currSortBy: '',
            currOrderBy: '',
            failedCampaignNumber: [],
            failedInvoiceAmount: [],
            failedTotalOutstanding:0,

            supressionProgress: [],
            supressionDone: [],
            supressionInterval: '',
            windowWidth: window.innerWidth,
            customsidebarleadmenu:[],
            selectedModules:{},
            selectedModulesCreate:{},
            expandedRow: null,
            isProcessingExpandRow: false,
            moduleAgency: {},
            prevSelectedModules: [],
            localActiveCampaignId: [],
            locatorActiveCampaignId: [],
            enhanceActiveCampaignId: [],
            b2bActiveCampaignId: [],
            simplifiActiveCampaignId: [],
            customFieldsBySlug: {},
            isLoadingCustomFieldsBySlug: false,
            isErrorCustomFieldsBySlug: false,
            isHideB2b: false,
            isHideAdvance: false,
            listValueFieldsIntegrationClickfunnels: [],
            listValueFieldsIntegrationClickfunnelsb2b: [],
            // listValueFieldsIntegrationGohighlevel: [],
            prevListValueFieldsIntegrationClickfunnels: [],
            prevListValueFieldsIntegrationClickfunnelsb2b: [],
            listValueFieldsIntegrationGohighlevel: [],
            listValueFieldsIntegrationGohighlevelb2b: [],
            listValueFieldsIntegrationGohighleveladvance: [],
            prevListValueFieldsIntegrationGohighlevel: [],
            prevListValueFieldsIntegrationGohighlevelb2b: [],
            prevListValueFieldsIntegrationGohighleveladvance: [],
            // SendJim custom fields selections
            listValueFieldsIntegrationSendjim: [],
            listValueFieldsIntegrationSendjimb2b: [],
            listValueFieldsIntegrationSendjimadvance: [],
            prevListValueFieldsIntegrationSendjim: [],
            prevListValueFieldsIntegrationSendjimb2b: [],
            prevListValueFieldsIntegrationSendjimadvance: [],
            isIntegrationItemsFetch: false,
            integrationStatus: {
                loading: false,
                error: false,
            },
            isCheckAllIntegrationGeneral: false,
            isCheckAllIntegrationB2b: false,
            isCheckAllIntegrationAdvance: false,
            downloadingAgreements: {}, // Track downloading state per row by row.id
        }
    },

    computed: {
        sendjimCallbackUrl() {
            return `${process.env.VUE_APP_DATASERVER_URL}/sendjim/oauth/callback/view`;
        },
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        },
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
        let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice().sort((a, b) => {
                // Move items with payment_status == 'failed' to the top
                if (a.payment_status === 'failed' && b.payment_status !== 'failed') {
                  return -1;
                } else if (a.payment_status !== 'failed' && b.payment_status === 'failed') {
                  return 1;
                }
            
                // Move items with customer_payment_id == '' or customer_card_id == '' next
                if ((a.customer_payment_id === '' || a.customer_card_id === '') && (b.customer_payment_id !== '' && b.customer_card_id !== '')) {
                  return -1;
                } else if ((a.customer_payment_id !== '' && a.customer_card_id !== '') && (b.customer_payment_id === '' || b.customer_card_id === '')) {
                  return 1;
                }
            
                // Keep the rest of the items in their original order
                return 0;
            });
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.tableData.length;
        },      
        initializeSelectedModules() {
            const initialselectedModulesCreate = {};
            const DefaultModules = this.$global.agencyDefaultModules ? this.$global.agencyDefaultModules: '';
            if (DefaultModules != '') {     
                DefaultModules.forEach(module => { 
                    if (module.type) {
                        initialselectedModulesCreate[module.type] = this.$global.agencyDefaultModules ? module.status : true;
                    }
                });
            }
            return initialselectedModulesCreate;
        },
        hasProducts() {
        const modules = this.$global.agencyfilteredmodules;
        return modules && Object.keys(modules).length > 0;
     }
    },

    methods: {
        async handleSwitchUser(row) {
            // swal confirm dialog
            const result = await swal.fire({
                title: 'Switch as this user.',
                text: `Are you sure want to switch to this user?`,
                icon: '',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-fill mr-3',
                    cancelButton: 'btn btn-danger btn-fill'
                },
                confirmButtonText: 'Yes, switch user',
                buttonsStyling: false
            });
            if (!result.value) return;
            // swal confirm dialog

            // hit api for switchUser
            try {
                const response = await this.$store.dispatch('switchUserData', { usrID: row.id });
                console.log(response);
                if (response == 'success') {
                    if (row.profile_setup_completed == 'T' && row.status_acc == '' && row.user_type == 'client') {
                        const usrData = this.$store.getters.userData; 
                        if (usrData.leadlocalurl && usrData.leadlocalurl != '') {
                            window.document.location = `/${usrData.leadlocalurl}/dashboard`;
                        } else if (usrData.leadlocatorurl && usrData.leadlocatorurl != '') {
                            window.document.location = `/${usrData.leadlocatorurl}/dashboard`;
                        } else if (usrData.leadenhanceurl && usrData.leadenhanceurl != '') {
                            window.document.location = `/${usrData.leadenhanceurl}/dashboard`;
                        } else if (usrData.leadb2burl && usrData.leadb2burl != '') {
                            window.document.location = `/${usrData.leadb2burl}/dashboard`;
                        } else if (usrData.leadsimplifiurl && usrData.leadsimplifiurl != '') {
                            window.document.location = `/${usrData.leadsimplifiurl}/dashboard`;
                        } else {
                            window.document.location = "/user/profile-setup";
                        } 
                    } else {
                        window.document.location = "/user/profile-setup";
                    }
                }
            } catch (error) {
                console.error(error);
            }
            // hit api for switchUser
        },
        // A more robust copy-to-clipboard method with a fallback
        copyToClipboard(text) {
            // Modern async API
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text)
                    .then(() => {
                        this.$notify({
                            type: 'success',
                            message: 'Copied to clipboard',
                            icon: 'far fa-copy'
                        });
                    })
                    .catch(err => {
                        console.error('Failed to copy with modern API:', err);
                        this.$notify({
                            type: 'danger',
                            message: 'Copy failed',
                            icon: 'fas fa-bug'
                        });
                    });
            } else {
                // Fallback for older browsers or insecure contexts
                const textArea = document.createElement("textarea");
                textArea.value = text;

                // Make the textarea out of sight
                textArea.style.position = "fixed";
                textArea.style.top = "0";
                textArea.style.left = "0";
                textArea.style.opacity = "0";

                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    const successful = document.execCommand('copy');
                    if (successful) {
                        this.$notify({
                            type: 'success',
                            message: 'Copied to clipboard',
                            icon: 'far fa-copy'
                        });
                    } else {
                        this.$notify({
                            type: 'danger',
                            message: 'Copy failed',
                            icon: 'fas fa-bug'
                        });
                    }
                } catch (err) {
                    console.error('Fallback copy failed:', err);
                    this.$notify({
                        type: 'danger',
                        message: 'Copy failed',
                        icon: 'fas fa-bug'
                    });
                }

                document.body.removeChild(textArea);
            }
        },
        onViewExampleData() {
            window.open(this.basicExampleDataUrl, "_blank");
        },
        togglePassword() {
            this.showPassword = !this.showPassword
        },
        ...mapActions(["saveIntegrationSettings", "getUserIntegrationDetails", 'userLogSaved']),
        getMinimumValueSimplifi() {
            this
            .$store
            .dispatch('getMinimumValueSimplifi', {
                idsys: this.$global.idsys
            })
            .then(response => {
                // console.log('getMinimumValuesSimplifi', { response });
                this.simplifiPriceRule.maxBid.minimum = response.data.maxBid.minimum;
                this.simplifiPriceRule.dailyBudget.minimum = response.data.dailyBudget.minimum;
            })
            .catch(error => {
                this.$notify({ type: 'danger', message: 'Something Went Wrong At Get Minimum Values Simplifi', icon: 'fas fa-bug' });
            })
        },
        handleScrollGhlV2SubAccount(event) {
            const dropdown = event.target;
            const tolerant = 2;
            const isFetch = this.paginationGhlV2SubAccount.isFetch;
            const isComplete = this.paginationGhlV2SubAccount.isComplete;
            const totalSubAccounts = this.ghlV2ListSubAccounts.length;
            // console.log({
            //     'function': 'handleScrollGhlV2SubAccount',
            //     'dropdown.scrollTop': dropdown.scrollTop,
            //     'dropdown.clientHeight': dropdown.clientHeight,
            //     'dropdown.scrollTop + dropdown.clientHeight' : dropdown.scrollTop + dropdown.clientHeight,
            //     'dropdown.scrollHeight': dropdown.scrollHeight,
            //     'tolerant': tolerant,
            //     'this.paginationGhlV2SubAccount.isFetch': this.paginationGhlV2SubAccount.isFetch,
            //     'this.paginationGhlV2SubAccount.isComplete': this.paginationGhlV2SubAccount.isComplete
            // })

            if (
                (Math.ceil(dropdown.scrollTop + dropdown.clientHeight) >= dropdown.scrollHeight - tolerant) && // jika scroll sampai bawah
                (!isFetch) && // kondisi harus dalam keadaan tidak fetch list sub account
                (!isComplete) && // pastikan belum semua list sub account diambil
                (totalSubAccounts > 0) // pastikan sebelumnya ada list sub account nya
            ) {
                // console.log('before function ghlv2GetListSubAccounts');
                this.ghlv2GetListSubAccounts();
            }
        },
        onSelectGhlV2SubAccountVisible(visible, type) {
            if (visible) {
                this.$nextTick(() => {
                    let dropdown = "";
                    if(type == 'add') {
                        dropdown = this.$refs.selectGhlV2SubAccountAdd.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
                    } else {
                        dropdown = this.$refs.selectGhlV2SubAccountEdit.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
                    }

                    if (dropdown) {
                        dropdown.addEventListener('scroll', this.handleScrollGhlV2SubAccount);
                    } else {
                        console.error('Dropdown not found');
                    }
                });
            }
        },
        clearSelectSubAccount() {
            this.selects.ghlv2SubAccount = '';
        },
        async handleDownloadAgreementFile(row){
            this.$set(this.downloadingAgreements, row.id, true);
            if (row.company_agreement_file === 'download') {
                const payload = {
                    user_id: row.id,
                    document_type: DOCUMENTS.DEFAULT_CLIENT,
                }
                await this.$store.dispatch('downloadAgreementFile', payload)
                .then(response => {
                    if (response.file_uuid) {
                        const url = process.env.VUE_APP_DATASERVER_URL  + '/download-agreement?agreement_id=' + response.file_uuid
                        downloadFileInBackgroundPdf(url)
                        this.GetClientList(this.currSortBy, this.currOrderBy)
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'danger',
                        message: 'Failed to download agreement file. Please try again later.',
                        icon: 'fas fa-exclamation-triangle'
                    });
                });
            }else {
                downloadFileInBackgroundPdf(row.company_agreement_file)
            }
            this.$set(this.downloadingAgreements, row.id, false);
        },
        ghlv2ResetListSubAccounts() {
            this.paginationGhlV2SubAccount.currentPage = 1;
            this.paginationGhlV2SubAccount.isComplete = false;
            this.paginationGhlV2SubAccount.isFetch = false;
            this.ghlV2ListSubAccounts = [];
        },
        ghlv2GetListSubAccounts() {
            if(this.$global.idsys != this.$global.masteridsys) {
                return;
            }

            this.paginationGhlV2SubAccount.isFetch = true;
            this.selects.ghlv2SubAccount = '';
            this
            .$store
            .dispatch('ghlv2GetListSubAccounts', {
                company_id: this.$store.getters.userData.company_id, // company_id agency
                page: this.paginationGhlV2SubAccount.currentPage, // page sekarang 
            })
            .then(response => {
                // console.log(response);
                this.ghlV2AgencyConnected = response.ghlV2AgencyConnected;
                this.paginationGhlV2SubAccount.isFetch = false;
                this.paginationGhlV2SubAccount.isComplete = (response.listSubAccounts.length == 0);

                if(response.listSubAccounts.length > 0) {
                    this.ghlV2ListSubAccounts = [ ...this.ghlV2ListSubAccounts, ...response.listSubAccounts ]
                    this.paginationGhlV2SubAccount.currentPage = Number(response.page) + 1;
                }
                
                // console.log({
                //     'this.ghlV2AgencyConnected': this.ghlV2AgencyConnected,
                //     'this.ghlV2ListSubAccounts': this.ghlV2ListSubAccounts,
                // })
            })
            .catch(error => {
                console.log(error);
                
                this.paginationGhlV2SubAccount.isFetch = false;
                
                const message = typeof(error.response.data.message) ? error.response.data.message : 'Something Went Wrong';
                this.$notify({
                    type: 'danger',
                    icon: 'fas fa-bug',
                    message: message
                });
            })
        },
        createDeleteIframeGhlv2() {
            if(!this.ghlV2CreatedIframe) { // create iframe
                this.createIframeGhlv2Client();
            } else { // delete iframe
                this.deleteIframeGhlv2Client();
            }
        },
        createIframeGhlv2Client() {
            if(!this.selects.ghlv2SubAccount) {
                this.$notify({
                    type: 'danger',
                    message: 'Please select sub accounts',
                    icon: 'fas fa-bug'
                });
                return;
            }

            MessageBox.prompt('Enter the text that you want to display as your single sign on custom menu link. (30 Characters Max)', 'Enter Your Custom Menu Link Text.', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                inputPattern: /^$|^[a-zA-Z0-9\s]{1,30}$/,
                inputErrorMessage: 'Only letters, numbers, and spaces, max 30 characters',
                inputPlaceholder: '[Client-Name]',
                inputValue: this.selectedRowData.company_name,
                customClass: 'message-general-ghl'
            })
            .then(({ value }) => {
                this.isLoadingCreateDeleteIframeGhlV2 = true;
                this
                .$store
                .dispatch('createIframeGhlv2Client', {
                    company_id: this.selectedRowData.company_id,
                    company_parent: this.$store.getters.userData.company_id,
                    custom_menu_name: value,
                    user_ip: this.$store.getters.userData.ip_login,
                    location_id: this.selects.ghlv2SubAccount,
                })
                .then(response => {
                    // console.log(response);
                    this.isLoadingCreateDeleteIframeGhlV2 = false;
                    this.btnCreateDeleteIframeGhlv2Text = 'Remove SSO Link';
                    this.ghlV2CreatedIframe = true;
                    // this.modals.integrations = false;

                    this.ghlv2ResetListSubAccounts();
                    this.ghlv2GetListSubAccounts();
                    
                    this.$notify({
                        type: 'success',
                        icon: 'fas fa-save',
                        message: 'create sso link successfully'
                    });
                })
                .catch(error => {
                    console.error(error);
                    this.isLoadingCreateDeleteIframeGhlV2 = false;
                    const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'Something Wrong';
                    this.$notify({
                        type: 'danger',
                        icon: 'fas fa-bug',
                        message: message
                    });
                })
            });

        },
        deleteIframeGhlv2Client() {
            MessageBox.confirm('Are you sure you want to remove SSO link?', 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                type: 'warning',
            })
            .then(result => {
                this.isLoadingCreateDeleteIframeGhlV2 = true;
                this
                .$store
                .dispatch('deleteIframeGhlv2Client', {
                    company_id: this.selectedRowData.company_id,
                    company_parent: this.$store.getters.userData.company_id,
                    user_ip: this.$store.getters.userData.ip_login,
                })
                .then(response => {
                    this.isLoadingCreateDeleteIframeGhlV2 = false;
                    this.btnCreateDeleteIframeGhlv2Text = 'Create SSO Link';
                    this.ghlV2CreatedIframe = false;
                    // this.modals.integrations = false;

                    this.ghlv2ResetListSubAccounts();
                    this.ghlv2GetListSubAccounts();

                    this.$notify({
                        type: 'success',
                        icon: 'fas fa-save',
                        message: 'Custom Menu Link Successfully Removed '
                    });
                })
                .catch(error => {
                    this.isLoadingCreateDeleteIframeGhlV2 = false;
                    const message = typeof(error.response.data.message) != 'undefined' ? error.response.data.message : 'Something Wrong';
                    this.$notify({
                        type: 'danger',
                        icon: 'fas fa-bug',
                        message: message
                    });
                });
            })
        },
        openHelpModal(index) {
            this.activeHelpIndex = index;
            this.activeHelpItem = this.helpContentMap[index]
            this.modals.help = true;
        },
        changeEnableMinimumLeadsPerDay(type) {
            if(type == 'local')
                this.costagency.local.EnableMinimumLeadsPerday = this.LeadspeekEnableMinimumLeadsPerDay;
            else if(type == 'locator')
                this.costagency.locator.EnableMinimumLeadsPerday = this.LocatorEnableMinimumLeadsPerDay;
            else if(type == 'enhance')
                this.costagency.enhance.EnableMinimumLeadsPerday = this.EnhanceEnableMinimumLeadsPerDay;
            else if(type == 'b2b')
                this.costagency.b2b.EnableMinimumLeadsPerday = this.B2bEnableMinimumLeadsPerDay;
        },
        connectDisconnectGhlv2() {
            if(!this.ghlV2Connected) { // connect
                this.generateGHLv2AuthUrl();
            } else { // disconnect
                MessageBox.confirm('Are You Sure Deactivate Contact Sync For This Client', 'Warning', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                })
                .then(() => {
                    this.disconnectGhlv2();
                })
                .catch(() => {
                    return;
                });
            }
        },
                // SendJim OAuth-only logic
        connectDisconnectSendjim() {
            if(!this.sendjimConnected) { // connect
                this.generateSendJimAuthUrl();
            } else { // disconnect
                MessageBox.confirm('Are you sure you want to disconnect SendJim?', 'Warning', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                })
                .then(() => {
                    this.disconnectSendJim();
                })
                .catch(() => {
                    return;
                });
            }
        },

        disconnectSendJim() {
            this.btnConnectDisconnectSendjimText = "Disconnecting...";
            $('#btnConnectDisconnectSendjim').attr('disabled',true);
            this.$store
                .dispatch('disconnectSendJim', {
                    company_id: this.selectedRowData.company_id,
                    user_ip: this.$store.getters.userData.ip_login,
                })
                .then(response => {
                    this.sendjimConnected = false;
                    this.btnConnectDisconnectSendjimText = "Connect SendJim";
                    $('#btnConnectDisconnectSendjim').attr('disabled',false);
                    this.$notify({ type: "success", message: "Disconnect SendJim Successfully", icon: "fas fa-save" });
                })
                .catch(error => {
                    $('#btnConnectDisconnectSendjim').attr('disabled',false);
                    this.$notify({ type: "primary", message: error.response.data.message, icon: "fas fa-bug" });
                });
        },
        disconnectGhlv2() {
            this.btnConnectDisconnectGhlv2Text = "Deactivate Contact Sync...";
            $('#btnConnectDisconnectGhlv2').attr('disabled',true);   
            
            this.$store
                .dispatch('disconnectGhlv2', {
                    company_id: this.selectedRowData.company_id,
                    user_ip: this.$store.getters.userData.ip_login,
                })
                .then(response => {
                    this.ghlV2Connected = false;
                    this.btnConnectDisconnectGhlv2Text = "Activate Contact Sync"
                    $('#btnConnectDisconnectGhlv2').attr('disabled',false);

                    this.$notify({
                        type: "success",
                        message: "Deactivate Contact Sync Successfully",
                        icon: "fas fa-save"
                    });
                    // this.modals.integrations = false;
                })
                .catch(error => {
                    $('#btnConnectDisconnectGhlv2').attr('disabled',false);

                    this.$notify({
                        type: "primary",
                        message: error.response.data.message,
                        icon: "fas fa-bug"
                    });
                    // this.modals.integrations = false;
                });
        },
        generateGHLv2AuthUrl() {
            MessageBox.confirm('Confirm your updates. Unchecked fields will now stop sending this data to your CRM and checked fields will now create this custom field in your CRM, and start sending this data.', 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                type: 'warning',
            })
            .then(() => {
                const slug = this.selectedIntegration;
                const { filteredListGeneral, filteredListB2b, filteredListAdvance } = this.handleFilterListCustomFields('Gohighlevel');

                this.isLoadingConnectDisconnectGhlv2 = true;
                this.$store
                    .dispatch('generateGHLv2AuthUrl', {
                        company_id: this.selectedRowData.company_id,
                        enable_sendgrid: this.enabledconntector[slug] ? 1 : 0,
                        subdomain_url: window.location.href,
                        custom_fields_general: filteredListGeneral,
                        custom_fields_b2b: filteredListB2b,
                        custom_fields_advance: filteredListAdvance,
                        user_ip: this.$store.getters.userData.ip_login,
                    })
                    .then(response => {
                        const result = typeof(response.result) != 'undefined' ? response.result : '';
                        const url = typeof(response.url) != 'undefined' ? response.url : '';
                        // console.log({result, url});
                        
                        if(result == 'success' && url != '') {
                            window.location.href = url;
                        }
                    })
                    .catch(error => {
                        this.isLoadingConnectDisconnectGhlv2 = false;
                        console.log(error);
                    })
            })
            .catch(() => {
                return;
            });
        },
        generateSendJimAuthUrl() {
            if(!this.userApiKey.sendjim || this.userApiKey.sendjim.trim() === '') {
                this.$notify({
                    type: 'danger',
                    message: 'Please enter your SendJim Client ID first',
                    icon: 'fas fa-bug'
                });
                return;
            }
            if(!this.sendjim.clientSecret || this.sendjim.clientSecret.trim() === '') {
                this.$notify({
                    type: 'danger',
                    message: 'Please enter your SendJim Client Secret first',
                    icon: 'fas fa-bug'
                });
                return;
            }
            // Save credentials first to ensure backend has Client Secret
            // this.saveIntegrationSettingslocal();
            this.isLoadingConnectDisconnectSendjim = true;
            this.$store
                .dispatch('generateSendJimAuthUrl', {
                    company_id: this.selectedRowData.company_id,
                    subdomain_url: window.location.href,
                    user_ip: this.$store.getters.userData.ip_login,
                    client_id: this.userApiKey.sendjim,
                })
                .then(response => {
                    const result = typeof(response.result) != 'undefined' ? response.result : '';
                    const url = typeof(response.url) != 'undefined' ? response.url : '';
                    if(result == 'success' && url != '') {
                        console.log({result, url});
                        window.location.href = url;
                    }
                    this.isLoadingConnectDisconnectSendjim = false;
                })
                .catch(error => {
                    this.isLoadingConnectDisconnectSendjim = false;
                    console.log(error);
                })
        },
        validateBetaFeature(type) {
            if(['b2b','b2b_module'].includes(type)) {
                if(!this.$global.betaFeature.b2b_module.is_beta || this.$global.betaFeature.b2b_module.apply_to_all_agency || this.$global.isBeta) {
                    return true;
                } else {
                    return false;
                }
            } else if(['simplifi','simplifi_module'].includes(type)) {
                if(!this.$global.betaFeature.simplifi_module.is_beta || this.$global.betaFeature.simplifi_module.apply_to_all_agency || this.$global.isBeta) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        },
        redirectToLink(link){
            window.open(link, '_blank')
        },
        validateMinLead(field) {
            if(this.clientMinLeadDayEnhance != '') {
                /* ENHANCE */
                if (field == 'EnhanceLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Weekly' && (Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.enhance.Weekly.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'EnhanceLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Monthly' && (Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.enhance.Monthly.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'EnhanceLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'One Time' && (Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.enhance.OneTime.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'EnhanceLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && (Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.enhance.Prepaid.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                }
                /* ENHANCE */

                /* B2B */
                if (field == 'B2bLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Weekly' && (Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.b2b.Weekly.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'B2bLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Monthly' && (Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.b2b.Monthly.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'B2bLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'One Time' && (Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.b2b.OneTime.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                }else if (field == 'B2bLeadsPerday' && this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid' && (Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance))) {
                    this.errMinLeadDay = false;
                    this.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                    this.costagency.b2b.Prepaid.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                }
                /* B2B */
            }
        },
        handleVisibleChange(visible) {            
            this.dropdownVisible = visible;
        },
        addWebhookUrl(type) {
            if (type == 'zapier') {
                this.userApiKey.zapier.push('');
            } else if (type == 'agencyzoom') {
                this.userApiKey.agencyzoom.push('');
            }
        },
        addWebhookUrlKeyupEnter(event, type){
            if (event.key === "Enter") {
                this.addWebhookUrl(type);
            }
        },
        removeWebhookUrl(index, type) {
            if (type == 'zapier') {
                if (this.userApiKey.zapier.length > 1) {
                    this.userApiKey.zapier.splice(index, 1);
                }
            } else if (type == 'agencyzoom') {
                if (this.userApiKey.agencyzoom.length > 1) {
                    this.userApiKey.agencyzoom.splice(index, 1);
                }
            }
        },
        applyFilters(event){
            event.stopPropagation(); // Prevent click propagation
            this.GetClientList(this.currSortBy, this.currOrderBy)
            this.dropdownVisible = false;
        },
        checkStatusFileUpload() {

            clearInterval(this.supressionInterval);

            /** START CHECK IF THERE IS ANYTHING NOT DONE */

            this.$store.dispatch('jobProgress', {
                companyId: this.whiteListClientID,
                campaignType: 'client',
            })
            .then(response => {
                this.supressionProgress = response.data.jobProgress;
                this.supressionDone = response.data.jobDone;
                
                if(this.supressionProgress.length > 0) {
                    this.supressionTimeout = setTimeout(() => {
                        this.supressionInterval = setInterval(() => {
                            this.$store.dispatch('jobProgress', {
                                companyId: this.whiteListClientID,
                                campaignType: 'client',
                            })
                            .then(response => {
                                this.supressionProgress = response.data.jobProgress;
                                this.supressionDone = response.data.jobDone;
                                
                                if(this.supressionProgress.length == 0) {
                                    clearTimeout(this.supressionTimeout);
                                    clearInterval(this.supressionInterval);
                                }
                            })
                            .catch(error => {
                                console.error(error);
                            })
                        }, 2000);
                    }, 2000);
                } else {
                    clearTimeout(this.supressionTimeout);
                    clearInterval(this.supressionInterval); 
                }
            })
            .catch(error => {
                console.error(error);
            })
            /** START CHECK IF THERE IS ANYTHING NOT DONE */
        },
        changePage(event){
            //console.log(this.pagination,event)
            this.GetClientList(this.currSortBy,this.currOrderBy)
        },
        refreshCCfield() {
            if (this.$global.sppubkey != "") {
                _sppubkey = this.$global.sppubkey;
                this.initstripelib();
                //this.cardfailetoload = false;
            }else{
                this.$store.dispatch('getGeneralSetting', {
                    companyID: this.user.company_root_id,
                    settingname: 'rootstripe',
                }).then(response => {
                    _sppubkey = response.data;
                    this.initstripelib();
                    //this.cardfailetoload = false;
                },error => {
                    this.$notify({
                    type: 'primary',
                    message: 'Please try to refresh the page',
                    icon: 'fas fa-bug'
                    })
                    this.cardfailetoload = true;    

                });
            }
        },
        onPhoneUpdate(payload){
           this.clientPhoneNumber.countryCode = payload.countryCode
           this.clientPhoneNumber.countryCallingCode = payload.countryCallingCode
        },
        onRowPhoneUpdate(payload){
           this.clientRowPhoneNumber.countryCode = payload.countryCode
           this.clientRowPhoneNumber.countryCallingCode = payload.countryCallingCode
        },
        async handleIntegrationClick(index, row) {
            this.selectedRowIndex = index;
            this.selectedRowData = row;

            try {
                this.integrationDetails = await this.getUserIntegrationDetails({ companyID: this.selectedRowData.company_id, slug: 'all' })
                var _integrationDetails = this.integrationDetails;
                
                this.userApiKey.gohighlevel = "";
                this.userApiKey.sendgrid = "";
                this.userApiKey.kartra = "";
                this.userApiKey.zapier = [''];
                this.userApiKey.mailboxpower = "";
                this.userApiKey.clickfunnels = "";
                this.userApiKey.agencyzoom = [''];
                this.userApiKey.sendjim = "";
                this.kartraAppId = "";
                this.kartraApiPassword = "";
                this.enabledconntector.sendgrid = false;
                this.enabledconntector.gohighlevel = false;
                this.enabledconntector.kartra = false;
                this.enabledconntector.zapier = false;
                this.enabledconntector.sendTestZapier = false;
                this.enabledconntector.mailboxpower = false;
                this.enabledconntector.clickfunnels = false;
                this.enabledconntector.sendTestAgencyZoom = false;
                this.enabledconntector.sendjim = false;
                this.clickfunnels.subdomain = "";
                this.clickfunnels.workspaceId = "";
                this.integrationVersion.gohighlevel = "2";

                this.ghlV2Connected = false;
                this.btnConnectDisconnectGhlv2Text = 'Activate Contact Sync';

                this.ghlV2CreatedIframe = false;
                this.btnCreateDeleteIframeGhlv2Text = 'Create SSO Link';
                if(typeof(_integrationDetails.ghlV2CreatedIframe) != 'undefined') {
                    this.ghlV2CreatedIframe = _integrationDetails.ghlV2CreatedIframe;
                    if(this.ghlV2CreatedIframe === true) {
                        this.btnCreateDeleteIframeGhlv2Text = 'Remove SSO Link';
                    } else {
                        this.btnCreateDeleteIframeGhlv2Text = 'Create SSO Link';
                    }
                }

                // reset SendJim state
                this.sendjimConnected = false;
                this.btnConnectDisconnectSendjimText = 'Connect SendJim';

                // if (_integrationDetails.refcode && Array.isArray(_integrationDetails.refcode)) {
                //     _integrationDetails.refcode.forEach(item => {
                //         const matchSlug = this.integrations.find(itemFind => itemFind.slug === item.slug);
                //         if (matchSlug) {
                //             let parsedData = JSON.parse(`[${item.referralcode}]`);
                //             if (Array.isArray(parsedData)) {
                //                 parsedData.forEach(item => {
                //                     if (item.rootid == this.$global.idsys) {
                //                         console.log(item.refcode);
                //                         matchSlug.refcode = item.refcode;
                //                     }
                                    
                //                 });
                //             }
                //         }
                        
                //     });
                // }

                if (_integrationDetails.data && Array.isArray(_integrationDetails.data)) {
                    _integrationDetails.data.forEach(item => {
                        var _slug = item.integration_slug;
                        this.enabledconntector[_slug] = item.enable_sendgrid === 1;
                        this.userApiKey[_slug] = item.api_key ? item.api_key : '';
                        if(item.integration_slug === 'kartra'){
                            this.kartraApiPassword = item.password
                            // this.kartraAppId = item.app_id
                        }
                        if(item.integration_slug === 'sendjim'){
                            this.sendjim.clientSecret = item.password || '';
                        }

                        if(item.integration_slug === 'clickfunnels'){
                            this.clickfunnels.subdomain = item.subdomain;
                            this.clickfunnels.workspaceId = item.workspace_id;
                        }

                        if(item.integration_slug == 'gohighlevel') {
                            if(typeof(item.version) != 'undefined' && (item.version == "1" || item.version == "2")) {
                                this.integrationVersion.gohighlevel = item.version;
                            }
                            if(typeof(item.ghlV2Connected) != 'undefined') {
                                this.ghlV2Connected = item.ghlV2Connected;
                                if(this.ghlV2Connected === true) {
                                    this.btnConnectDisconnectGhlv2Text = 'Deactivate Contact Sync';
                                } else {
                                    this.btnConnectDisconnectGhlv2Text = 'Activate Contact Sync';
                                }
                            }
                        }
                        if(item.integration_slug == 'sendjim') {
                            // connected from backend flag or fallback to tokens presence
                            const connectedFlag = (typeof(item.connected) != 'undefined') ? item.connected : null;
                            const tokens = (typeof(item.tokens) != 'undefined' && item.tokens) ? item.tokens : '';
                            const apiKey = (typeof(item.api_key) != 'undefined' && item.api_key) ? item.api_key : '';
                            this.sendjimConnected = (connectedFlag !== null) ? !!connectedFlag : !!(tokens && tokens.toString().trim() != '');
                            if(this.sendjimConnected === true) {
                                this.btnConnectDisconnectSendjimText = 'Disconnect SendJim';
                            } else {
                                this.btnConnectDisconnectSendjimText = 'Connect SendJim';
                            }
                            // no client-level quicksend config anymore
                        }
                    });
                } else {
                    console.error("Integration details not found or not in the expected format.");
                }
            } catch (error) {
                console.error("Error fetching integration details:", error);
            }

            await this.handleDefaultCustomFields(_integrationDetails);

            $('#btnSaveIntegration').attr('disabled',false);
            $('#btnSaveIntegration').html('Save');

            this.modals.integrations = true;

            // no quicksend template list at client level
        },
        async handleIntegrationItemClick(item){
            if(this.selectedIntegration == item.slug){
                return;
            }

            this.selectedIntegration = item.slug;
            this.nameActiveIntegration = item.custom_name || item.name;
            
            // fetch ulang data nya setiap pindah integration agar selalu uptodate
            if(this.selectedRowData){
                this.isIntegrationItemsFetch = true;
                await this.handleIntegrationClick(this.selectedRowIndex, this.selectedRowData);
                this.isIntegrationItemsFetch = false;
            }
            // fetch ulang data nya setiap pindah integration agar selalu uptodate

            const refCode = item.refcode;
            if(refCode){
                const parsedData = JSON.parse(`[${refCode}]`);
                const findRefCode = parsedData.filter(item => item.rootid == this.$global.idsys).map(item => item.refcode)
                this.referralCodeActive = findRefCode;
            }

            const capitalizedModule = item.slug.charAt(0).toUpperCase() + item.slug.slice(1);

            this.handleDefaultCheckAllCustomFields('General', capitalizedModule)
            this.handleDefaultCheckAllCustomFields('B2b', capitalizedModule)
            this.handleDefaultCheckAllCustomFields('Advance', capitalizedModule)
        },
        getCustomIntegrations(){
            this.integrationStatus.loading = true;
            this.integrationStatus.error = false;

            const userData = this.$store.getters.userData;
            const payload = {
                company_id: userData.company_id,
            }

            this.$store.dispatch('getCustomIntegrations', payload).then(response => {
                this.integrations = response.data;
                this.integrationStatus.loading = false;
            }).catch(error => {
                console.log(error);
                this.integrationStatus.loading = false;
                this.integrationStatus.error = true;
            })
        },
        async handleDefaultCustomFields(integrations){
            this.isLoadingCustomFieldsBySlug = true;
            this.isErrorCustomFieldsBySlug = false;

            await this.$store.dispatch('getListCustomFields').then(response => {
                this.isLoadingCustomFieldsBySlug = false;
                const data = response.data;
                const customFieldsBySlug = {};

                data.forEach(item => {
                    const slug = item.slug;

                    // Reset value
                    this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}`] = [];
                    this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}b2b`] = [];
                    this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}advance`] = [];
                    // Reset value

                    customFieldsBySlug[slug] = item.custom_fields;
                    const customFieldsGeneral = customFieldsBySlug[slug] ? (customFieldsBySlug[slug] || []).filter(field => field.type === 'general').map(field => field.name) : customFieldsBySlug[slug]
                    const customFieldsB2b = customFieldsBySlug[slug] ? (customFieldsBySlug[slug] || []).filter(field => field.type === 'b2b').map(field => field.name) : customFieldsBySlug[slug]
                    const customFieldsAdvance = customFieldsBySlug[slug] ? (customFieldsBySlug[slug] || []).filter(field => field.type === 'advance').map(field => field.name) : customFieldsBySlug[slug]

                    if(integrations.data == '' || integrations.data.length == 0){
                        this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}`] = customFieldsGeneral;
                        this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}b2b`] = customFieldsB2b;
                        this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}advance`] = customFieldsAdvance;
                    }
                })
                this.customFieldsBySlug = customFieldsBySlug;

                if(integrations.data == '' || integrations.data.length == 0){
                    return;
                } else {
                    integrations.data.forEach(item => {
                        const slug = item.integration_slug;
                        const customFieldsGeneral = this.customFieldsBySlug[slug] ? (this.customFieldsBySlug[slug] || []).filter(field => field.type === 'general').map(field => field.name) : this.customFieldsBySlug[slug];
                        const customFieldsB2b = this.customFieldsBySlug[slug] ? (this.customFieldsBySlug[slug] || []).filter(field => field.type === 'b2b').map(field => field.name) : this.customFieldsBySlug[slug];
                        const customFieldsAdvance = this.customFieldsBySlug[slug] ? (this.customFieldsBySlug[slug] || []).filter(field => field.type === 'advance').map(field => field.name) : this.customFieldsBySlug[slug];

                        if(item.custom_fields){
                            const listDisabledCustomFields = (this.customFieldsBySlug[slug] || []).filter(field => field.disabled && field.type === 'general').map(field => field.name)
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}`] = [...(listDisabledCustomFields || []), ...(item.custom_fields || [])]
                        } else {
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}`] = [...(customFieldsGeneral || [])]
                        }

                        if (item.custom_fields_b2b){
                            const listDisabledCustomFields = (this.customFieldsBySlug[slug] || []).filter(field => field.disabled && field.type === 'b2b').map(field => field.name);
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}b2b`] = [...(listDisabledCustomFields || []), ...(item.custom_fields_b2b || [])]
                        } else {
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}b2b`] = [...(customFieldsB2b || [])]
                        }
                        
                        if (item.custom_fields_advance){
                            const listDisabledCustomFields = (this.customFieldsBySlug[slug] || []).filter(field => field.disabled && field.type === 'advance').map(field => field.name);
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}advance`] = [...(listDisabledCustomFields || []), ...(item.custom_fields_advance || [])]
                        } else {
                            this[`listValueFieldsIntegration${slug.charAt(0).toUpperCase() + slug.slice(1)}advance`] = [...(customFieldsAdvance || [])]
                        }
                    })
                }

                this.handleCustomFieldsEmpty(integrations, 'Clickfunnels')
                this.handleCustomFieldsEmpty(integrations, 'Gohighlevel')
                this.handleCustomFieldsEmpty(integrations, 'Sendjim')

                // FOR LOGS
                this.handleDefaultLogsCustomFields('Clickfunnels')
                this.handleDefaultLogsCustomFields('Gohighlevel')
                this.handleDefaultLogsCustomFields('Sendjim')
                // FOR LOGS

            }).catch(error => {
                console.log(error);
                
                this.isErrorCustomFieldsBySlug = true;
                this.isLoadingCustomFieldsBySlug = false;
            })
        },
        async saveIntegrationSettingslocal() {
            var _slug = this.selectedIntegration;

            // const handleFilterListCustomFields = (name) => {
            //     const listDisabledCustomFields = this.customFieldsBySlug[name.toLowerCase()].filter(item => item.disabled).map(item => item.name)
            //     const filteredListGeneral = this[`listValueFieldsIntegration${name}`].filter(item => !listDisabledCustomFields.includes(item));
            //     const filteredListB2b = this[`listValueFieldsIntegration${name}b2b`].filter(item => !listDisabledCustomFields.includes(item));

            //     return { filteredListGeneral, filteredListB2b }
            // }
            
            $('#btnSaveIntegration').attr('disabled',true);
            $('#btnSaveIntegration').html('Saving...');   

            let data = {
                integration_slug: this.selectedIntegration,
                company_id: this.selectedRowData.company_id,
                api_key: this.userApiKey[_slug],
                enable_sendgrid: this.enabledconntector[_slug] ? 1 : 0,
                enable_default_campaign: 0,
            }

            if (!this.validateConfiguration(data)) {
                $('#btnSaveIntegration').attr('disabled',false);
                $('#btnSaveIntegration').html('Save');  
                return;
            }
            
            if(_slug === 'kartra'){
                data.password = this.kartraApiPassword
                // data.app_id = this.kartraAppId
            }
            if(_slug === 'sendjim'){
                if(!this.userApiKey.sendjim || this.userApiKey.sendjim.trim() === ''){
                    $('#btnSaveIntegration').attr('disabled',false);
                    $('#btnSaveIntegration').html('Save');  
                    return this.$notify({ type: 'danger', message: 'Client ID is required', icon: 'fas fa-bug' });
                }
                if(!this.sendjim.clientSecret || this.sendjim.clientSecret.trim() === ''){
                    $('#btnSaveIntegration').attr('disabled',false);
                    $('#btnSaveIntegration').html('Save');  
                    return this.$notify({ type: 'danger', message: 'Client Secret is required', icon: 'fas fa-bug' });
                }
                if (this.sendjimQuickSendEnabled && (!Array.isArray(this.sendjimQuickSendTemplates) || this.sendjimQuickSendTemplates.length === 0)){
                    $('#btnSaveIntegration').attr('disabled',false);
                    $('#btnSaveIntegration').html('Save');
                    return this.$notify({ type: 'danger', message: 'Please select at least one Quick Send template', icon: 'fas fa-bug' });
                }
                data.password = this.sendjim.clientSecret;
            }
            if(_slug === 'gohighlevel'){
                try {
                    await MessageBox.confirm('Confirm your updates. Unchecked fields will now stop sending this data to your CRM and checked fields will now create this custom field in your CRM, and start sending this data.', 'Warning', {
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    });

                } catch (error) {
                    $('#btnSaveIntegration').attr('disabled',false);
                    $('#btnSaveIntegration').html('Save');  
                    return;
                }
                
                const { filteredListGeneral, filteredListB2b, filteredListAdvance } = this.handleFilterListCustomFields('Gohighlevel');

                data.version = this.integrationVersion.gohighlevel;
                data.custom_fields = filteredListGeneral;
                data.custom_fields_b2b = filteredListB2b;
                data.custom_fields_advance = filteredListAdvance;
            }
            if(_slug === 'zapier'){
                data.send_test_zapier = this.enabledconntector.sendTestZapier
                const validWebhookUrls = this.userApiKey.zapier.filter(item => !item || item.trim() != "");
                data.api_key = validWebhookUrls
            }
            if(_slug === 'clickfunnels'){
                if (this.validateClickFunnelsFields(_slug)) {
                    return;
                }
                
                try {
                    await MessageBox.confirm('Confirm your updates. Unchecked fields will now stop sending this data to your CRM and checked fields will now create this custom field in your CRM, and start sending this data.', 'Warning', {
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    });

                } catch (error) {
                    $('#btnSaveIntegration').attr('disabled',false);
                    $('#btnSaveIntegration').html('Save');  
                    return;
                }

                data.subdomain = this.clickfunnels.subdomain;
                data.workspace_id = this.clickfunnels.workspaceId;
                
                const { filteredListGeneral, filteredListB2b, filteredListAdvance } = this.handleFilterListCustomFields('Clickfunnels')
            
                data.custom_fields = filteredListGeneral;
                data.custom_fields_b2b = filteredListB2b;
                data.custom_fields_advance = filteredListAdvance;
            }
            if(_slug === 'agencyzoom'){
                data.send_test_agency_zoom = this.enabledconntector.sendTestAgencyZoom
                const validWebhookUrls = this.userApiKey.agencyzoom.filter(item => !item || item.trim() != "");
                data.api_key = validWebhookUrls
            }

            const response = await this.saveIntegrationSettings({ data })

            // FOR LOGS
            if(response.result == 'success'){
                const userData = this.$store.getters.userData;
                
                if(_slug === 'clickfunnels' || _slug === 'gohighlevel'){
                    const capitalizeFirstSlug = _slug.charAt(0).toUpperCase() + _slug.slice(1);
                    let desc = `Company Id: ${this.selectedRowData.company_id} | Integration Type: ${_slug} | `;

                    const appendDescription = (field, prevValue, newValue) => {
                        desc += `${field} : Update values from ${prevValue || 'Empty'} to: ${newValue || 'Empty'} | `;
                    };
                    const joinArray = (arr) => (arr && arr.length > 0 ? arr.join(', ') : 'Empty');

                    const isChangedCustomFields = this.hasChangedArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}`], data.custom_fields)
                    const isChangedCustomFieldsB2b = this.hasChangedArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}b2b`], data.custom_fields_b2b)
                    const isChangedCustomFieldsAdvance = this.hasChangedArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}advance`], data.custom_fields_advance)

                    if(isChangedCustomFields){
                        appendDescription(
                            "Custom Fields",
                            joinArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}`]),
                            joinArray(data.custom_fields)
                        );
                        desc += `The user has confirmed and agreed to this action.`;
                    } else {
                        desc += `Custom Fields : No changes, value remains ${joinArray(data.custom_fields)}`;
                    }

                    if(isChangedCustomFieldsB2b){
                        appendDescription(
                            " | Custom Fields B2B",
                            joinArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}b2b`]),
                            joinArray(data.custom_fields_b2b)
                        );
                        desc += `The user has confirmed and agreed to this action.`;
                    } else {
                        desc += ` | Custom Fields B2B : No changes, value remains ${joinArray(data.custom_fields_b2b)}`;
                    }

                    if(isChangedCustomFieldsAdvance){
                        appendDescription(
                            " | Custom Fields Enhance Advance",
                            joinArray(this[`prevListValueFieldsIntegration${capitalizeFirstSlug}advance`]),
                            joinArray(data.custom_fields_advance)
                        );
                        desc += `The user has confirmed and agreed to this action.`;
                    } else {
                        desc += ` | Custom Fields Advance : No changes, value remains ${joinArray(data.custom_fields_advance)}`;
                    }

                    // const payload = {
                    //     userID: userData.id,
                    //     action: "Custom Fields",
                    //     desc,
                    //     userIP: this.$store.getters.userData.ip_login,
                    // }
                    // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
                    // if(userViewMode){
                    //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
                    //     payload.userID = userRoot.id;
                    // }
                    // this.userLogSaved({ data: payload });
                    this.$store.dispatch('onSaveUserLogs', {
                        desc: desc,
                        action: "Custom Fields",
                        target_id: userData.id,
                    })

                }

                // fetch ulang data nya setiap pindah integration agar selalu uptodate
                if(this.selectedRowData){
                    await this.handleIntegrationClick(this.selectedRowIndex, this.selectedRowData);
                }
                // fetch ulang data nya setiap pindah integration agar selalu uptodate
            }
            // FOR LOGS

            $('#btnSaveIntegration').attr('disabled',false);
            $('#btnSaveIntegration').html('Save');  
            // this.modals.integrations = false;
        },
        displayMoney(val) {
          return this.$global.formatMoney(parseFloat(val));
        },
        failedInvoiceTotal() {
            // Calculate the total of the array items
            this.failedTotalOutstanding = this.failedInvoiceAmount.reduce((acc, val) => acc + parseFloat(val), 0);
            return this.$global.formatMoney(this.failedTotalOutstanding);
        },
        /** FOR UPLOAD FILE */
        reset() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL;
            this.uploadedFiles = [];
            this.uploadError = null;
            this.uploadFieldName = 'clientoptoutfile';
            $('input[type="file"]').val(null);
        },
        save(formData) {
            // upload data to the server
            this.currentStatus = STATUS_SAVING;

           //console.log(formData);

           const config = {
                headers: {
                    'content-type': 'multipart/form-data',
                    'Access-Control-Allow-Origin' : '*',
                }
           };

            axios.post(process.env.VUE_APP_APISERVER_URL + '/api/tools/optout-client/upload', formData, config)
            .then(response => {
                //console.log(response.data);
                if(response.data.result == 'success') {
                    this.currentStatus = STATUS_SUCCESS;
                    this.reset();
                }else{
                    this.currentStatus = STATUS_FAILED;
                    this.reset();
                }
            })
            .catch(error => {
                //console.log(error);
                this.currentStatus = STATUS_FAILED;
                this.reset();
                //reject(error)
            })

            setTimeout(() => {
                this.checkStatusFileUpload()
            }, 2000)

            /* UPLOAD FILE */
            // try 
            // {
            //     const response = await axios.post(process.env.VUE_APP_APISERVER_URL + '/api/tools/optout-client/upload', formData, config)
                
            //     if (response.data.result == 'success') {
            //         this.currentStatus = STATUS_SUCCESS;
            //         this.checkStatusFileUpload();
            //         setTimeout(() => {
            //             this.reset();
            //         }, 2000);
            //     } else {
            //         this.currentStatus = STATUS_FAILED;
            //         setTimeout(() => {
            //             this.reset();
            //         }, 2000);
            //     }
            // } 
            // catch(error) 
            // {
            //     console.error(error);
            //     this.currentStatus = STATUS_FAILED;
            //     setTimeout(() => {
            //         this.reset();
            //     }, 2000);
            // }
            /* UPLOAD FILE */
        },
        purgeSuppressionList(action){
            swal.fire({
                title: 'Record Purge Confirmation',
                text: "Are you sure you want to purge existing records?",
                showCancelButton: true,
                confirmButtonColor: 'blue',
                cancelButtonColor: 'red',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then((result) => {
                if (result.isConfirmed) {
                    // Perform the deletion
                    this.$store.dispatch('purgeSuppressionList', {
                        paramID: this.whiteListClientID,
                        campaignType: action,
                    }).then(response => {
                        this.supressionDone = [];
                        if (response.result === 'success') {
                            swal.fire({
                                icon: 'success',
                                title: response.title,
                                text: response.msg,
                                confirmButtonText: 'OK'
                            });
                        } else {
                            swal.fire({
                                icon: 'error',
                                title: response.title,
                                text: response.msg,
                                confirmButtonText: 'OK'
                            });
                        }
                    }).catch(error => {
                        swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'There was an error processing your request.',
                            confirmButtonText: 'OK'
                        });
                    });
                }
            });
        },
        filesChange(fieldName, fileList) {
            // handle file changes
            const formData = new FormData();

            if (!fileList.length) return;
            const file = fileList[0];
            const validCSV = /\.(csv)$/i.test(file.name);

            if (!validCSV) {
                this.$notify({
                    type: 'danger',
                    message: 'Invalid file format. This upload only supports CSV files.',
                    icon: 'fas fa-bug'
                })

                return;
            }

            // append the files to FormData
            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                const fileMapping = fileList[x];
                const cleanFileName = fileMapping.name
                    .replace(/\s+/g, "_")
                    .replace(/[^a-zA-Z0-9_.-]/g, "")
                    .toLowerCase();

                const newFile = new File([fileMapping], cleanFileName, { type: fileMapping.type });

                formData.append(fieldName, newFile, cleanFileName);
            });
            
            formData.append("ClientCompanyID",this.whiteListClientID);
            formData.append("campaigntype","client");
            // save it
            this.save(formData);
        },
        showWhitelist(index,row) {
            //console.log(row);
            if (row.optoutfile !== null) {
                this.optoutfileexist = false;
            }
            this.whiteListClientID = row.company_id;
            this.modals.whitelist = true;

            this.checkStatusFileUpload();
        },
        getCardStatus(row) {
            const styleObject = {};
            if (row.customer_payment_id == '' || row.customer_card_id == '') {
                styleObject.color = 'gray';
            }else{
                styleObject.color = 'green';
                if (row.payment_status == "failed") {
                    styleObject.color = 'red';
                }
            }
            return styleObject;
        },
        closebtnupdatecard() {
            window.location.reload();
        },
        clientreceiveemail(row) {
            if (row.disabled_receive_email == 'T') {
                row.disabled_receive_email = 'F';
            }else{
                row.disabled_receive_email = 'T';
            }
        },
        clientaddcampaign(row) {
            if (row.disable_client_add_campaign == 'T') {
                row.disable_client_add_campaign = 'F';
            }else{
                row.disable_client_add_campaign = 'T';
            }
        },
        clientenableeditor(row) {
            if (row.editor_spreadsheet == 'T') {
                row.editor_spreadsheet = 'F';
            }else{
                row.editor_spreadsheet = 'T';
            }
        },
        clientenablephonenumber(row) {
            if (row.enabled_phone_number == 'T') {
                row.enabled_phone_number = 'F';
            }else{
                row.enabled_phone_number = 'T';
            }
        },
        validateMinimumInput(event,type) {
            const handlers = {
                keyup: {
                    maxBid: () => {
                    	this.simplifiErrorInput.maxBid = (Number(this.SimplifiMaxBid) < Number(this.simplifiPriceRule.maxBid.minimum)) ?
                                                         (`*Max Bid Minimum $${this.simplifiPriceRule.maxBid.minimum}`) :
                                                         (``) ;
                    },
                    dailyBudget: () => {
                        this.simplifiErrorInput.dailyBudget = (Number(this.SimplifiDailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) ?
                                                              (`*Daily Budget Minimum $${this.simplifiPriceRule.dailyBudget.minimum}`) :
                                                              (``) ;
                    }
                },
                blur: {
                    maxBid: () => {
                        this.simplifiErrorInput.maxBid = "";
                        this.SimplifiMaxBid = (Number(this.SimplifiMaxBid) < Number(this.simplifiPriceRule.maxBid.minimum)) ?
                                              (this.simplifiPriceRule.maxBid.minimum) :
                                              (this.SimplifiMaxBid) ;
                    },
                    dailyBudget: () => {
                        this.simplifiErrorInput.dailyBudget = "";
                        this.SimplifiDailyBudget = (Number(this.SimplifiDailyBudget) < Number(this.simplifiPriceRule.dailyBudget.minimum)) ?
                                                   (this.simplifiPriceRule.dailyBudget.minimum) :
                                                   (this.SimplifiDailyBudget) ;
                    }
                }
            }

            if (handlers[event] && handlers[event][type]) {
                handlers[event][type]();
            }
        },
        set_fee(type,typevalue) {
            if (type == 'local') {

                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    if (typevalue == 'LeadspeekPlatformFee') {
                        this.costagency.local.Weekly.LeadspeekPlatformFee = this.LeadspeekPlatformFee;
                    }else if (typevalue == 'LeadspeekCostperlead') {
                        this.costagency.local.Weekly.LeadspeekCostperlead = this.LeadspeekCostperlead;
                    }else if (typevalue == 'LeadspeekCostperleadAdvanced') {
                        this.costagency.local.Weekly.LeadspeekCostperleadAdvanced = this.LeadspeekCostperleadAdvanced;
                    }else if (typevalue == 'LeadspeekMinCostMonth') {
                        this.costagency.local.Weekly.LeadspeekMinCostMonth = this.LeadspeekMinCostMonth;
                    }else if (typevalue == 'LeadspeekLeadsPerday') {
                        this.costagency.local.Weekly.LeadspeekLeadsPerday = this.LeadspeekLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                    if (typevalue == 'LeadspeekPlatformFee') {
                        this.costagency.local.Monthly.LeadspeekPlatformFee = this.LeadspeekPlatformFee;
                    }else if (typevalue == 'LeadspeekCostperlead') {
                        this.costagency.local.Monthly.LeadspeekCostperlead = this.LeadspeekCostperlead;
                    }else if (typevalue == 'LeadspeekCostperleadAdvanced') {
                        this.costagency.local.Monthly.LeadspeekCostperleadAdvanced = this.LeadspeekCostperleadAdvanced;
                    }else if (typevalue == 'LeadspeekMinCostMonth') {
                        this.costagency.local.Monthly.LeadspeekMinCostMonth = this.LeadspeekMinCostMonth;
                    }else if (typevalue == 'LeadspeekLeadsPerday') {
                        this.costagency.local.Monthly.LeadspeekLeadsPerday = this.LeadspeekLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                    if (typevalue == 'LeadspeekPlatformFee') {
                        this.costagency.local.OneTime.LeadspeekPlatformFee = this.LeadspeekPlatformFee;
                    }else if (typevalue == 'LeadspeekCostperlead') {
                        this.costagency.local.OneTime.LeadspeekCostperlead = this.LeadspeekCostperlead;
                    }else if (typevalue == 'LeadspeekCostperleadAdvanced') {
                        this.costagency.local.OneTime.LeadspeekCostperleadAdvanced = this.LeadspeekCostperleadAdvanced;
                    }else if (typevalue == 'LeadspeekMinCostMonth') {
                        this.costagency.local.OneTime.LeadspeekMinCostMonth = this.LeadspeekMinCostMonth;
                    }else if (typevalue == 'LeadspeekLeadsPerday') {
                        this.costagency.local.OneTime.LeadspeekLeadsPerday = this.LeadspeekLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    if (typevalue == 'LeadspeekPlatformFee') {
                        this.costagency.local.Prepaid.LeadspeekPlatformFee = this.LeadspeekPlatformFee;
                    }else if (typevalue == 'LeadspeekCostperlead') {
                        this.costagency.local.Prepaid.LeadspeekCostperlead = this.LeadspeekCostperlead;
                    }else if (typevalue == 'LeadspeekCostperleadAdvanced') {
                        this.costagency.local.Prepaid.LeadspeekCostperleadAdvanced = this.LeadspeekCostperleadAdvanced;
                    }else if (typevalue == 'LeadspeekMinCostMonth') {
                        this.costagency.local.Prepaid.LeadspeekMinCostMonth = this.LeadspeekMinCostMonth;
                    }else if (typevalue == 'LeadspeekLeadsPerday') {
                        this.costagency.local.Prepaid.LeadspeekLeadsPerday = this.LeadspeekLeadsPerday;
                    }
                }

            }else if (type == 'locator') {

                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    if (typevalue == 'LocatorPlatformFee') {
                        this.costagency.locator.Weekly.LocatorPlatformFee = this.LocatorPlatformFee;
                    }else if (typevalue == 'LocatorCostperlead') {
                        this.costagency.locator.Weekly.LocatorCostperlead = this.LocatorCostperlead;
                    }else if (typevalue == 'LocatorMinCostMonth') {
                        this.costagency.locator.Weekly.LocatorMinCostMonth = this.LocatorMinCostMonth;
                    }else if (typevalue == 'LocatorLeadsPerday') {
                        this.costagency.locator.Weekly.LocatorLeadsPerday = this.LocatorLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                    if (typevalue == 'LocatorPlatformFee') {
                        this.costagency.locator.Monthly.LocatorPlatformFee = this.LocatorPlatformFee;
                    }else if (typevalue == 'LocatorCostperlead') {
                        this.costagency.locator.Monthly.LocatorCostperlead = this.LocatorCostperlead;
                    }else if (typevalue == 'LocatorMinCostMonth') {
                        this.costagency.locator.Monthly.LocatorMinCostMonth = this.LocatorMinCostMonth;
                    }else if (typevalue == 'LocatorLeadsPerday') {
                        this.costagency.locator.Monthly.LocatorLeadsPerday = this.LocatorLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                    if (typevalue == 'LocatorPlatformFee') {
                        this.costagency.locator.OneTime.LocatorPlatformFee = this.LocatorPlatformFee;
                    }else if (typevalue == 'LocatorCostperlead') {
                        this.costagency.locator.OneTime.LocatorCostperlead = this.LocatorCostperlead;
                    }else if (typevalue == 'LocatorMinCostMonth') {
                        this.costagency.locator.OneTime.LocatorMinCostMonth = this.LocatorMinCostMonth;
                    }else if (typevalue == 'LocatorLeadsPerday') {
                        this.costagency.locator.OneTime.LocatorLeadsPerday = this.LocatorLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    if (typevalue == 'LocatorPlatformFee') {
                        this.costagency.locator.Prepaid.LocatorPlatformFee = this.LocatorPlatformFee;
                    }else if (typevalue == 'LocatorCostperlead') {
                        this.costagency.locator.Prepaid.LocatorCostperlead = this.LocatorCostperlead;
                    }else if (typevalue == 'LocatorMinCostMonth') {
                        this.costagency.locator.Prepaid.LocatorMinCostMonth = this.LocatorMinCostMonth;
                    }else if (typevalue == 'LocatorLeadsPerday') {
                        this.costagency.locator.Prepaid.LocatorLeadsPerday = this.LocatorLeadsPerday;
                    }
                }

            }else if (type == 'locatorlead') {
                if (typevalue == 'FirstName_LastName') {
                    this.costagency.locatorlead.FirstName_LastName = this.lead_FirstName_LastName;
                }else if (typevalue == 'FirstName_LastName_MailingAddress') {
                    this.costagency.locatorlead.FirstName_LastName_MailingAddress = this.lead_FirstName_LastName_MailingAddress;
                }else if (typevalue == 'FirstName_LastName_MailingAddress_Phone') {
                    this.costagency.locatorlead.FirstName_LastName_MailingAddress_Phone = this.lead_FirstName_LastName_MailingAddress_Phone;
                    this.costagency.locator.Weekly.LocatorCostperlead = this.lead_FirstName_LastName_MailingAddress_Phone;
                    this.costagency.locator.Monthly.LocatorCostperlead = this.lead_FirstName_LastName_MailingAddress_Phone;
                    this.costagency.locator.OneTime.LocatorCostperlead = this.lead_FirstName_LastName_MailingAddress_Phone;
                    this.costagency.locator.Prepaid.LocatorCostperlead = this.lead_FirstName_LastName_MailingAddress_Phone;
                }
            }else if (type == 'enhance') {

                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    if (typevalue == 'EnhancePlatformFee') {
                        this.costagency.enhance.Weekly.EnhancePlatformFee = this.EnhancePlatformFee;
                    }else if (typevalue == 'EnhanceCostperlead') {
                        this.costagency.enhance.Weekly.EnhanceCostperlead = this.EnhanceCostperlead;
                    }else if (typevalue == 'EnhanceMinCostMonth') {
                        this.costagency.enhance.Weekly.EnhanceMinCostMonth = this.EnhanceMinCostMonth;
                    }else if (typevalue == 'EnhanceLeadsPerday') {
                        if(Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.enhance.Weekly.EnhanceLeadsPerday = this.EnhanceLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                    if (typevalue == 'EnhancePlatformFee') {
                        this.costagency.enhance.Monthly.EnhancePlatformFee = this.EnhancePlatformFee;
                    }else if (typevalue == 'EnhanceCostperlead') {
                        this.costagency.enhance.Monthly.EnhanceCostperlead = this.EnhanceCostperlead;
                    }else if (typevalue == 'EnhanceMinCostMonth') {
                        this.costagency.enhance.Monthly.EnhanceMinCostMonth = this.EnhanceMinCostMonth;
                    }else if (typevalue == 'EnhanceLeadsPerday') {
                        if(Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.enhance.Monthly.EnhanceLeadsPerday = this.EnhanceLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                    if (typevalue == 'EnhancePlatformFee') {
                        this.costagency.enhance.OneTime.EnhancePlatformFee = this.EnhancePlatformFee;
                    }else if (typevalue == 'EnhanceCostperlead') {
                        this.costagency.enhance.OneTime.EnhanceCostperlead = this.EnhanceCostperlead;
                    }else if (typevalue == 'EnhanceMinCostMonth') {
                        this.costagency.enhance.OneTime.EnhanceMinCostMonth = this.EnhanceMinCostMonth;
                    }else if (typevalue == 'EnhanceLeadsPerday') {
                        if(Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.enhance.OneTime.EnhanceLeadsPerday = this.EnhanceLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    if (typevalue == 'EnhancePlatformFee') {
                        this.costagency.enhance.Prepaid.EnhancePlatformFee = this.EnhancePlatformFee;
                    }else if (typevalue == 'EnhanceCostperlead') {
                        this.costagency.enhance.Prepaid.EnhanceCostperlead = this.EnhanceCostperlead;
                    }else if (typevalue == 'EnhanceMinCostMonth') {
                        this.costagency.enhance.Prepaid.EnhanceMinCostMonth = this.EnhanceMinCostMonth;
                    }else if (typevalue == 'EnhanceLeadsPerday') {
                        if(Number(this.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.enhance.Prepaid.EnhanceLeadsPerday = this.EnhanceLeadsPerday;
                    }
                }

            }else if (type == 'b2b') {

                if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                    if (typevalue == 'B2bPlatformFee') {
                        this.costagency.b2b.Weekly.B2bPlatformFee = this.B2bPlatformFee;
                    }else if (typevalue == 'B2bCostperlead') {
                        this.costagency.b2b.Weekly.B2bCostperlead = this.B2bCostperlead;
                    }else if (typevalue == 'B2bMinCostMonth') {
                        this.costagency.b2b.Weekly.B2bMinCostMonth = this.B2bMinCostMonth;
                    }else if (typevalue == 'B2bLeadsPerday') {
                        if(Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.b2b.Weekly.B2bLeadsPerday = this.B2bLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                    if (typevalue == 'B2bPlatformFee') {
                        this.costagency.b2b.Monthly.B2bPlatformFee = this.B2bPlatformFee;
                    }else if (typevalue == 'B2bCostperlead') {
                        this.costagency.b2b.Monthly.B2bCostperlead = this.B2bCostperlead;
                    }else if (typevalue == 'B2bMinCostMonth') {
                        this.costagency.b2b.Monthly.B2bMinCostMonth = this.B2bMinCostMonth;
                    }else if (typevalue == 'B2bLeadsPerday') {
                        if(Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.b2b.Monthly.B2bLeadsPerday = this.B2bLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                    if (typevalue == 'B2bPlatformFee') {
                        this.costagency.b2b.OneTime.B2bPlatformFee = this.B2bPlatformFee;
                    }else if (typevalue == 'B2bCostperlead') {
                        this.costagency.b2b.OneTime.B2bCostperlead = this.B2bCostperlead;
                    }else if (typevalue == 'B2bMinCostMonth') {
                        this.costagency.b2b.OneTime.B2bMinCostMonth = this.B2bMinCostMonth;
                    }else if (typevalue == 'B2bLeadsPerday') {
                        if(Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.b2b.OneTime.B2bLeadsPerday = this.B2bLeadsPerday;
                    }
                }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                    if (typevalue == 'B2bPlatformFee') {
                        this.costagency.b2b.Prepaid.B2bPlatformFee = this.B2bPlatformFee;
                    }else if (typevalue == 'B2bCostperlead') {
                        this.costagency.b2b.Prepaid.B2bCostperlead = this.B2bCostperlead;
                    }else if (typevalue == 'B2bMinCostMonth') {
                        this.costagency.b2b.Prepaid.B2bMinCostMonth = this.B2bMinCostMonth;
                    }else if (typevalue == 'B2bLeadsPerday') {
                        if(Number(this.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.errMinLeadDay = true;
                        } else {
                            this.errMinLeadDay = false;
                        }
                        this.costagency.b2b.Prepaid.B2bLeadsPerday = this.B2bLeadsPerday;
                    }
                }

            }else if (type == 'simplifi') {
                if (typevalue == 'SimplifiMaxBid') {
                    this.costagency.simplifi.Prepaid.SimplifiMaxBid = this.SimplifiMaxBid;
                    this.validateMinimumInput('keyup', 'maxBid');
                } else if (typevalue == 'SimplifiDailyBudget') {
                    this.costagency.simplifi.Prepaid.SimplifiDailyBudget = this.SimplifiDailyBudget;
                    this.validateMinimumInput('keyup', 'dailyBudget');
                } else if (typevalue == 'SimplifiAgencyMarkup') {
                    this.costagency.simplifi.Prepaid.SimplifiAgencyMarkup = this.SimplifiAgencyMarkup;
                }
            }
        
        },
        paymentTermStatus() {
            if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                this.txtLeadService = 'weekly';
                this.txtLeadIncluded = 'in that weekly charge';
                this.txtLeadOver ='from the weekly charge';

                /** SET VALUE */
                this.LeadspeekPlatformFee = this.costagency.local.Weekly.LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.costagency.local.Weekly.LeadspeekCostperlead;
                this.LeadspeekCostperleadAdvanced = this.costagency.local.Weekly.LeadspeekCostperleadAdvanced;
                this.LeadspeekMinCostMonth = this.costagency.local.Weekly.LeadspeekMinCostMonth;
                this.LeadspeekLeadsPerday = this.costagency.local.Weekly.LeadspeekLeadsPerday;

                this.LocatorPlatformFee  = this.costagency.locator.Weekly.LocatorPlatformFee;
                this.LocatorCostperlead = this.costagency.locator.Weekly.LocatorCostperlead;
                this.LocatorMinCostMonth = this.costagency.locator.Weekly.LocatorMinCostMonth;
                this.LocatorLeadsPerday = this.costagency.locator.Weekly.LocatorLeadsPerday;

                this.EnhancePlatformFee  = this.costagency.enhance.Weekly.EnhancePlatformFee;
                this.EnhanceCostperlead = this.costagency.enhance.Weekly.EnhanceCostperlead;
                this.EnhanceMinCostMonth = this.costagency.enhance.Weekly.EnhanceMinCostMonth;
                this.EnhanceLeadsPerday = this.costagency.enhance.Weekly.EnhanceLeadsPerday;
                
                this.B2bPlatformFee  = this.costagency.b2b.Weekly.B2bPlatformFee;
                this.B2bCostperlead = this.costagency.b2b.Weekly.B2bCostperlead;
                this.B2bMinCostMonth = this.costagency.b2b.Weekly.B2bMinCostMonth;
                this.B2bLeadsPerday = this.costagency.b2b.Weekly.B2bLeadsPerday;

                this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekCostperlead:0;
                this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekCostperleadAdvanced:0;
                this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorCostperlead:0;
                this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhanceCostperlead:0;
                this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bCostperlead:0;

                this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekPlatformFee:0;
                this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekMinCostMonth:0;
                this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorPlatformFee:0;
                this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorMinCostMonth:0;
                this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhancePlatformFee:0;
                this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhanceMinCostMonth:0;
                this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bPlatformFee:0;
                this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bMinCostMonth:0;
                /** SET VALUE */
            }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                this.txtLeadService = 'monthly';
                this.txtLeadIncluded = 'in that monthly charge';
                this.txtLeadOver ='from the monthly charge';

                /** SET VALUE */
                this.LeadspeekPlatformFee = this.costagency.local.Monthly.LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.costagency.local.Monthly.LeadspeekCostperlead;
                this.LeadspeekCostperleadAdvanced = this.costagency.local.Monthly.LeadspeekCostperleadAdvanced;
                this.LeadspeekMinCostMonth = this.costagency.local.Monthly.LeadspeekMinCostMonth;
                this.LeadspeekLeadsPerday = this.costagency.local.Monthly.LeadspeekLeadsPerday;
                
                this.LocatorPlatformFee  = this.costagency.locator.Monthly.LocatorPlatformFee;
                this.LocatorCostperlead = this.costagency.locator.Monthly.LocatorCostperlead;
                this.LocatorMinCostMonth = this.costagency.locator.Monthly.LocatorMinCostMonth;
                this.LocatorLeadsPerday = this.costagency.locator.Monthly.LocatorLeadsPerday;
                
                this.EnhancePlatformFee  = this.costagency.enhance.Monthly.EnhancePlatformFee;
                this.EnhanceCostperlead = this.costagency.enhance.Monthly.EnhanceCostperlead;
                this.EnhanceMinCostMonth = this.costagency.enhance.Monthly.EnhanceMinCostMonth;
                this.EnhanceLeadsPerday = this.costagency.enhance.Monthly.EnhanceLeadsPerday;

                this.B2bPlatformFee  = this.costagency.b2b.Monthly.B2bPlatformFee;
                this.B2bCostperlead = this.costagency.b2b.Monthly.B2bCostperlead;
                this.B2bMinCostMonth = this.costagency.b2b.Monthly.B2bMinCostMonth;
                this.B2bLeadsPerday = this.costagency.b2b.Monthly.B2bLeadsPerday;

                this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekCostperlead:0;
                this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekCostperleadAdvanced:0;
                this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorCostperlead:0;
                this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhanceCostperlead:0;
                this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bCostperlead:0;

                this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekPlatformFee:0;
                this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekMinCostMonth:0;
                this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorPlatformFee:0;
                this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorMinCostMonth:0;
                this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhancePlatformFee:0;
                this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhanceMinCostMonth:0;
                this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bPlatformFee:0;
                this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bMinCostMonth:0;
                /** SET VALUE */
            }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                this.txtLeadService = '';
                this.txtLeadIncluded = '';
                this.txtLeadOver ='';

                /** SET VALUE */
                this.LeadspeekPlatformFee = this.costagency.local.OneTime.LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.costagency.local.OneTime.LeadspeekCostperlead;
                this.LeadspeekCostperleadAdvanced = this.costagency.local.OneTime.LeadspeekCostperleadAdvanced;
                this.LeadspeekMinCostMonth = this.costagency.local.OneTime.LeadspeekMinCostMonth;
                this.LeadspeekLeadsPerday = this.costagency.local.OneTime.LeadspeekLeadsPerday;
                
                this.LocatorPlatformFee  = this.costagency.locator.OneTime.LocatorPlatformFee;
                this.LocatorCostperlead = this.costagency.locator.OneTime.LocatorCostperlead;
                this.LocatorMinCostMonth = this.costagency.locator.OneTime.LocatorMinCostMonth
                this.LocatorLeadsPerday = this.costagency.locator.OneTime.LocatorLeadsPerday;
                
                this.EnhancePlatformFee  = this.costagency.enhance.OneTime.EnhancePlatformFee;
                this.EnhanceCostperlead = this.costagency.enhance.OneTime.EnhanceCostperlead;
                this.EnhanceMinCostMonth = this.costagency.enhance.OneTime.EnhanceMinCostMonth
                this.EnhanceLeadsPerday = this.costagency.enhance.OneTime.EnhanceLeadsPerday;

                this.B2bPlatformFee  = this.costagency.b2b.OneTime.B2bPlatformFee;
                this.B2bCostperlead = this.costagency.b2b.OneTime.B2bCostperlead;
                this.B2bMinCostMonth = this.costagency.b2b.OneTime.B2bMinCostMonth;
                this.B2bLeadsPerday = this.costagency.b2b.OneTime.B2bLeadsPerday;

                this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekCostperlead:0;
                this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekCostperleadAdvanced:0;
                this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorCostperlead:0;
                this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhanceCostperlead:0;
                this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bCostperlead:0;

                this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekPlatformFee:0;
                this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekMinCostMonth:0;
                this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorPlatformFee:0;
                this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorMinCostMonth:0;
                this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhancePlatformFee:0;
                this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhanceMinCostMonth:0;
                this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bPlatformFee:0;
                this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bMinCostMonth:0;
                /** SET VALUE */

            }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {
                this.txtLeadService = 'monthly';
                this.txtLeadIncluded = 'in that monthly charge';
                this.txtLeadOver ='from the monthly charge';

                if (typeof(this.costagency.local.Prepaid) == 'undefined') {
                    this.$set(this.costagency.local,'Prepaid',{
                    LeadspeekPlatformFee: '0',
                    LeadspeekCostperlead: '0',
                    LeadspeekCostperleadAdvanced: '0',
                    LeadspeekMinCostMonth: '0',
                    LeadspeekLeadsPerday: '50',
                    });
                }

                if (typeof(this.costagency.locator.Prepaid) == 'undefined') {
                    this.$set(this.costagency.locator,'Prepaid',{
                    LocatorPlatformFee: '0',
                    LocatorCostperlead: '0',
                    LocatorMinCostMonth: '0',
                    LocatorLeadsPerday: '10',
                    });
                }

                if (typeof(this.costagency.enhance.Prepaid) == 'undefined') {
                    this.$set(this.costagency.enhance,'Prepaid',{
                    EnhancePlatformFee: '0',
                    EnhanceCostperlead: '0',
                    EnhanceMinCostMonth: '0',
                    EnhanceLeadsPerday: '10',
                    });
                }

                if (typeof(this.costagency.b2b.Prepaid) == 'undefined') {
                    this.$set(this.costagency.b2b,'Prepaid',{
                    B2bPlatformFee: '0',
                    B2bCostperlead: '0',
                    B2bMinCostMonth: '0',
                    B2bLeadsPerday: '10',
                    });
                }
                
                /** SET VALUE */
                this.LeadspeekPlatformFee = this.costagency.local.Prepaid.LeadspeekPlatformFee;
                this.LeadspeekCostperlead = this.costagency.local.Prepaid.LeadspeekCostperlead;
                this.LeadspeekCostperleadAdvanced = this.costagency.local.Prepaid.LeadspeekCostperleadAdvanced;
                this.LeadspeekMinCostMonth = this.costagency.local.Prepaid.LeadspeekMinCostMonth;
                this.LeadspeekLeadsPerday = this.costagency.local.Prepaid.LeadspeekLeadsPerday;
                
                this.LocatorPlatformFee  = this.costagency.locator.Prepaid.LocatorPlatformFee;
                this.LocatorCostperlead = this.costagency.locator.Prepaid.LocatorCostperlead;
                this.LocatorMinCostMonth = this.costagency.locator.Prepaid.LocatorMinCostMonth
                this.LocatorLeadsPerday = this.costagency.locator.Prepaid.LocatorLeadsPerday;
                
                this.EnhancePlatformFee  = this.costagency.enhance.Prepaid.EnhancePlatformFee;
                this.EnhanceCostperlead = this.costagency.enhance.Prepaid.EnhanceCostperlead;
                this.EnhanceMinCostMonth = this.costagency.enhance.Prepaid.EnhanceMinCostMonth
                this.EnhanceLeadsPerday = this.costagency.enhance.Prepaid.EnhanceLeadsPerday;

                this.B2bPlatformFee  = this.costagency.b2b.Prepaid.B2bPlatformFee;
                this.B2bCostperlead = this.costagency.b2b.Prepaid.B2bCostperlead;
                this.B2bMinCostMonth = this.costagency.b2b.Prepaid.B2bMinCostMonth;
                this.B2bLeadsPerday = this.costagency.b2b.Prepaid.B2bLeadsPerday;
                
                this.m_LeadspeekCostPerLead =  (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekCostperlead:0; 
                this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekCostperleadAdvanced:0;
                this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorCostperlead:0;
                this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhanceCostperlead:0;
                this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bCostperlead:0;

                this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekPlatformFee:0;
                this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekMinCostMonth:0;
                this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorPlatformFee:0;
                this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorMinCostMonth:0;
                this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhancePlatformFee:0;
                this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhanceMinCostMonth:0;
                this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bPlatformFee:0;
                this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bMinCostMonth:0;
                /** SET VALUE */

            }
            const updateLogs = {
                ...this.prevDefaultRetailPrice,
                setupFeeLocal: this.LeadspeekPlatformFee,
                campaignFeeLocal: this.LeadspeekMinCostMonth,
                costPerLeadLocal: this.LeadspeekCostperlead,
                costPerLeadAdvancedLocal: this.LeadspeekCostperleadAdvanced,
                leadPerDayLocal: this.LeadspeekLeadsPerday,

                setupFeeLocator: this.LocatorPlatformFee,
                campaignFeeLocator: this.LocatorMinCostMonth,
                costPerLeadLocator: this.LocatorCostperlead,
                leadPerDayLocator: this.LocatorLeadsPerday,

                setupFeeEnhance: this.EnhancePlatformFee,
                campaignFeeEnhance: this.EnhanceMinCostMonth,
                costPerLeadEnhance: this.EnhanceCostperlead,
                leadPerDayEnhance: this.EnhanceLeadsPerday,

                setupFeeB2B: this.B2bPlatformFee,
                campaignFeeB2B: this.B2bMinCostMonth,
                costPerLeadB2B: this.B2bCostperlead,
                leadPerDayB2B: this.B2bLeadsPerday,
            }
            this.$set(this, 'prevDefaultRetailPrice', updateLogs);

        },
        paymentTermChange() {
            this.paymentTermStatus();

            this.$store.dispatch('updateGeneralSetting', {
                companyID: this.activeClientCompanyID,
                actionType: 'paymenttermDefault',
                paymenttermDefault: this.selectsPaymentTerm.PaymentTermSelect,
            }).then(response => {
                if (response.result == "success") {
                    this.tableData[this.activeClientCompanyIndex].paymentterm_default = this.selectsPaymentTerm.PaymentTermSelect;
                    
                    this.$notify({
                        type: 'success',
                        message: 'Default Payment Term has been saved.',
                        icon: 'tim-icons icon-bell-55'
                    });  

                    //// for log users
                    let descriptionLogs = "";
                    const { billingFrequency} = this.prevDefaultRetailPrice;
                    
                    const updates = [
                        { label: "Billing Frequency", prev: billingFrequency, new: this.selectsPaymentTerm.PaymentTermSelect },
                    ];

                    updates.forEach(({ label, prev, new: newValue }) => {
                        if (prev !== newValue) {
                            descriptionLogs += `${label} : Update values from ${prev} to ${newValue} `;
                        } else {
                            descriptionLogs += `${label} : No changes, value remains ${prev}`;
                        }
                    });

                    this.$store.dispatch('onSaveUserLogs', {
                        desc: descriptionLogs,
                        action: "Billing Frequency Client Change",
                        target_id: this.activeClientID,
                    });

                    Object.assign(this.prevDefaultRetailPrice, {
                        billingFrequency: this.selectsPaymentTerm.PaymentTermSelect,
                    })

                    
                }
            },error => {
                        
            });

        },
        
        sortcolumn: function(a,b) {
            return a.value - b.value;
        },
        sortdate: function(a,b) {
            return new Date(b.created_at) - new Date(a.created_at);
        },
         sortnumber: function(a,b) {
             return a - b;
        },
        checkLeadsType() {
            if (this.selectsAppModule.LeadsLimitSelect == 'Max') {
                this.LeadspeekMaxDateVisible = true;
            }else{
                this.LeadspeekMaxDateVisible = false;
            }
        },
        checkLeadsPerDay(){
            const fields = [
                'LeadspeekLeadsPerday',
                'LocatorLeadsPerday',
                'EnhanceLeadsPerday',
                'B2bLeadsPerday'
            ]

            return fields.some(field => this[field] == '0' || this[field] == '')
        },
        save_default_price() {
            const isValidationLeadsPerDay = this.checkLeadsPerDay();
            if(isValidationLeadsPerDay){
                this.$notify({
                    type: 'primary',
                    message: 'Please check each module: contacts per day must be at least 1',
                    icon: 'fas fa-exclamation-triangle'
                })
                
                return
            }

            this.$store.dispatch('updateGeneralSetting', {
                companyID: this.activeClientCompanyID,
                actionType: 'customsmtpmodule',
                comsetname: 'clientdefaultprice',
                comsetval: this.costagency,
            }).then(response => {
                if (response.result == "success") {
                    this.modals.pricesetup = false;
                    this.selectsAppModule.AppModuleSelect = 'LeadsPeek';
                    this.$notify({
                        type: 'success',
                        message: 'Default Prices has been saved.',
                        icon: 'tim-icons icon-bell-55'
                    });  

                    //// for log users
                    let descriptionLogs = "";
                    const {  
                            billingFrequency,
                            setupFeeLocal, 
                            campaignFeeLocal, 
                            costPerLeadLocal, 
                            costPerLeadAdvancedLocal, 
                            leadPerDayLocal,
                            setupFeeLocator, 
                            campaignFeeLocator, 
                            costPerLeadLocator, 
                            leadPerDayLocator,
                            setupFeeEnhance, 
                            campaignFeeEnhance, 
                            costPerLeadEnhance,
                            leadPerDayEnhance,
                            setupFeeB2B,
                            campaignFeeB2B,
                            costPerLeadB2B,
                            leadPerDayB2B,
                        } 
                        = this.prevDefaultRetailPrice;
                    
                    const updates = [
                        { label: "Billing Frequency", prev: billingFrequency, new: this.selectsPaymentTerm.PaymentTermSelect },
                        { label: "Local One Time Setup Fee", prev: setupFeeLocal, new: this.LeadspeekPlatformFee },
                        { label: "Local Campaign Fee", prev: campaignFeeLocal, new: this.LeadspeekMinCostMonth },
                        { label: "Local Basic Cost", prev: costPerLeadLocal, new: this.LeadspeekCostperlead },
                        { label: "Local Advanced Cost", prev: costPerLeadAdvancedLocal, new: this.LeadspeekCostperleadAdvanced },
                        { label: "Local Lead Per Day", prev: leadPerDayLocal, new: this.LeadspeekLeadsPerday },

                        { label: "Locator One Time Setup Fee", prev: setupFeeLocator, new: this.LocatorPlatformFee },
                        { label: "Locator Campaign Fee", prev: campaignFeeLocator, new: this.LocatorMinCostMonth },
                        { label: "Locator Basic Cost", prev: costPerLeadLocator, new: this.LocatorCostperlead },
                        { label: "Locator Lead Per Day", prev: leadPerDayLocator, new: this.LocatorLeadsPerday },

                        { label: "Enhance One Time Setup Fee", prev: setupFeeEnhance, new: this.EnhancePlatformFee },
                        { label: "Enhance Campaign Fee", prev: campaignFeeEnhance, new: this.EnhanceMinCostMonth },
                        { label: "Enhance Basic Cost", prev: costPerLeadEnhance, new: this.EnhanceCostperlead },
                        { label: "Enhance Lead Per Day", prev: leadPerDayEnhance, new: this.EnhanceLeadsPerday },

                        { label: "B2B One Time Setup Fee", prev: setupFeeB2B, new: this.B2bPlatformFee },
                        { label: "B2B Campaign Fee", prev: campaignFeeB2B, new: this.B2bMinCostMonth },
                        { label: "B2B Basic Cost", prev: costPerLeadB2B, new: this.B2bCostperlead },
                        { label: "B2B Lead Per Day", prev: leadPerDayB2B, new: this.B2bLeadsPerday },
                    ];

                    updates.forEach(({ label, prev, new: newValue }) => {
                        if (prev !== newValue) {
                            if ( prev == undefined && (label == "Local Lead Per Day" || label == "Locator Lead Per Day" || label == "Enhance Lead Per Day" || label == "B2B Lead Per Day") ) {
                                descriptionLogs += `${label} : First set values to ${newValue} | `;
                            } else {
                                descriptionLogs += `${label} : Update values from ${prev} to ${newValue} | `;
                            }
                        } else {
                            if (label == 'Billing Frequency') {
                                descriptionLogs += `${label} : No changes, value remains ${prev} | `;
                            }
                        }
                    });

                    this.$store.dispatch('onSaveUserLogs', {
                        desc: descriptionLogs,
                        action: "Update Campaign Pricing Client",
                        target_id: this.activeClientID,
                    })

                    this.GetClientList();
                }
            },error => {
                        
            });
        },
        
        rowClicked(row) {
            // console.log('rowClicked', {'selected_side_bar': row.selected_side_bar})
            if (this.isProcessingExpandRow) {
                return;
            }

            this.isProcessingExpandRow = true;

            if (this.expandedRow === row) {
                // Closing expand

                this.$refs.tableData.toggleRowExpansion(row, false);
                this.expandedRow = null;
            } else {
                // Closing all row expand 
                this.tableData.forEach(item => {
                    this.$refs.tableData.toggleRowExpansion(item, false);
                });

                // Exapand new row
                this.$refs.tableData.toggleRowExpansion(row, true);
                this.expandedRow = row;
            }

            this.rowCheckboxes.phoneenabled = false;
            if (row.enabled_phone_number == 'T') {
                this.rowCheckboxes.phoneenabled = true;
            }

            this.isProcessingExpandRow = false;
            
           this.clientRowPhoneNumber.number = row.phonenum
           this.clientRowPhoneNumber.countryCode = row.phone_country_code
           this.clientRowPhoneNumber.countryCallingCode = row.phone_country_calling_code
           this.prevSelectedModules = row.selected_side_bar

            let responseSideBar = row.selected_side_bar

            let result = {}
            if(responseSideBar != undefined || responseSideBar != null){
                responseSideBar.forEach(item => {
                result[item.type] = item.status;
            });
            }
            this.selectedModules = result
            // console.log({'selectedModules': this.selectedModules})

        },
        tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
                return 'clickable-rows ClientRow' + rowIndex;
        },
        ClearClientForm() {
            this.ClientCompanyName = '';
            this.ClientFullName = '';
            this.ClientEmail = '';
            this.ClientPhone = '';
            this.checkboxes.phoneenabled = false;
            this.selects.ghlv2SubAccount = '';
        },

        AddEditClient(id) {
            this.clientPhoneNumber={
                number:'',
                countryCode:'US',
                countryCallingCode:'+1'
            },
            $('#showAddEditClient' + id).collapse('show');
        },
        CancelAddEditClient(id) {
            if(id == '') {
              this.ClearClientForm();
              $('#showAddEditClient' + id).collapse('hide');
            }else{
                this.$refs.tableData.toggleRowExpansion(id);
                this.GetClientList(this.currSortBy,this.currOrderBy);
            }
            
        },
        ResendInvitation(id) {
            if(id.id != '') {
                $('#btnResend' + id.id).attr('disabled',true);
                $('#btnResend' + id.id).html('Sending...');   

                /** RESEND THE INVITATION */
                this.$store.dispatch('ResendInvitation', {
                    ClientID: id.id,
                }).then(response => {
                    //console.log(response[0]);
                    this.$refs.tableData.toggleRowExpansion(id);
                    $('#btnResend' + id.id).attr('disabled',false);
                    $('#btnResend' + id.id).html('Resend Invitation'); 

                    this.$notify({
                        type: 'success',
                        message: 'Invitation has been sent!',
                        icon: 'far fa-save'
                    });  

                },error => {
                    $('#btnResend' + id.id).attr('disabled',false);
                    $('#btnResend' + id.id).html('Resend Invitation'); 

                    this.$notify({
                        type: 'primary',
                        message: 'Sorry there is something wrong, pleast try again later',
                        icon: 'fas fa-bug'
                    }); 
                });
                /** RESEND THE INVITATION */
            }
        },
        openPhoneConfirmationModal(checkbox, id){
            if (this[checkbox].phoneenabled) {
                this[checkbox].phoneenabled = false;

                return;
            }
            swal.fire({
                  title: "<span style='font-size:21px;'>Phone numbers are provided without warranty or guarantee. The end-user is responsible for verifying the Do-Not-Call status of each number and ensuring compliance with all applicable laws. The end-user must obtain all necessary permissions before making calls or sending messages<span>",
                  text: '',
                  icon: '',
                  showCancelButton: true,
                  customClass: {
                  confirmButton: 'btn btn-fill mr-3',
                  cancelButton: 'btn btn-danger btn-fill'
                  },
                  confirmButtonText: "I Agree",
                  buttonsStyling: false
          }).then(result => {
            this[checkbox].phoneenabled = result.isConfirmed ? true : false
          });
        },

        onLogsUser(id, checkbox){
            let action = '';
            let desc = '';
            if(checkbox){
                action = 'enabled phone number on client management';
                desc = `Agreed with pop up information (enabled phone number) on client id ${id}`;
            } else {
                action = 'disabled phone number on client management';
                desc = `User disable phone number on client id ${id}`;
            }

            const userData = this.$store.getters.userData;
            // let data = {
            //     userID: userData.id,
            //     action,
            //     desc,
            //     userIP: this.$store.getters.userData.ip_login,
            // }
            // const userViewMode = userData.isViewMode ? userData.isViewMode : false;
            // if(userViewMode){
            //     const userRoot = decryptData(localStorage.getItem('userDataOri'))
            //     data.userID = userRoot.id;
            // }
            
            // this.userLogSaved({ data});
            this.$store.dispatch('onSaveUserLogs', {
                desc: desc,
                action: action,
                target_id: id,
            })
        },
        async ProcessAddEditClient(id) {
            this.$refs.frmAddDownline.validate().then(async res => {
                if(!res) {
                    return false
                } 
            })
            if(this.ClientFullName != '' && this.ClientEmail != '' && id == '') {
                /** PROCESS ADD / EDIT ORGANIZATION */
                if(id == '') {
                    $('#btnSave' + id).attr('disabled',true);
                    $('#btnSave' + id).html('Processing...');   
                    
                    var _disabledreceivedemail = 'F';
                    var _disabledaddcampaign = 'F';
                    var _seteditor = 'F';
                    var _enablephonenumber = 'F';

                    if (this.disabledreceiveemail) {
                        _disabledreceivedemail = 'T';
                    }

                    if (this.disabledaddcampaign) {
                        _disabledaddcampaign = 'T';
                    }

                    if (this.seteditor) {
                        _seteditor = 'T';
                    }

                    if (this.checkboxes.phoneenabled) {
                        _enablephonenumber = 'T';
                    }

                    Object.entries(this.customsidebarleadmenu).forEach(([key, sidebar]) => {
                        if (!(key in this.selectedModulesCreate)) {
                            this.$set(this.selectedModulesCreate, key, false);
                        }
                    });
                    let selectedModulesCreateArray = [];
                    for (let key in this.selectedModulesCreate) {
                        selectedModulesCreateArray.push({
                            type: key,
                            status: this.selectedModulesCreate[key]
                        });
                    }

                    const regex = /^\s*$/;

                    if (regex.test(this.ClientCompanyName)) {
                        this.$notify({
                            type: 'danger',
                            message: 'Client Name invalid',
                            icon: 'fas fa-exclamation'
                        });
                        $('#btnSave' + id).attr('disabled',false);
                        $('#btnSave' + id).html('Save'); 
                        return; 
                    }

                    if (regex.test(this.ClientFullName)) {
                        this.$notify({
                            type: 'danger',
                            message: 'Contact Name invalid',
                            icon: 'fas fa-exclamation'
                        });
                        $('#btnSave' + id).attr('disabled',false);
                        $('#btnSave' + id).html('Save'); 
                        return; 
                    }

                    if (!emailPattern.test(this.ClientEmail)) {
                        this.$notify({
                            type: 'danger',
                            message: `Email invalid`,
                            icon: 'fas fa-exclamation-circle'
                        })

                        $('#btnSave' + id).attr('disabled',false);
                        $('#btnSave' + id).html('Save');
                        return
                    }

                    // name custom menu for client
                    let custom_menu_name = "";
                    if(this.ghlV2AgencyConnected === true && this.selects.ghlv2SubAccount != '') {
                        try {
                            $('#btnSave' + id).attr('disabled',false);
                            $('#btnSave' + id).html('Save');
                            const { value } = await MessageBox.prompt('Enter the text that you want to display as your single sign on custom menu link. (30 Characters Max)', 'Enter Your Custom Menu Link Text.', {
                                confirmButtonText: 'OK',
                                cancelButtonText: 'Cancel',
                                inputPattern: /^$|^[a-zA-Z0-9\s]{1,30}$/,
                                inputErrorMessage: 'Only letters, numbers, and spaces, max 30 characters',
                                inputPlaceholder: '[Client-Name]',
                                inputValue: this.ClientCompanyName,
                                customClass: 'message-general-ghl'
                            })
                            custom_menu_name = value;
                            $('#btnSave' + id).attr('disabled',true);
                            $('#btnSave' + id).html('Processing...');   
                        } catch (err) {
                            $('#btnSave' + id).attr('disabled',false);
                            $('#btnSave' + id).html('Save'); 
                            return;
                        }
                    }
                    // name custom menu for client

                    /** CREATE CLIENT */
                    this.$store.dispatch('CreateClient', {
                        companyID: this.companyID,
                        idsys: this.$global.idsys,
                        userType:'client',
                        ClientCompanyName: this.ClientCompanyName,
                        ClientFullName: this.ClientFullName,
                        ClientEmail: this.ClientEmail,
                        ClientPhone: this.clientPhoneNumber.number,
                        ClientPhoneCountryCode: this.clientPhoneNumber.countryCode,
                        ClientPhoneCountryCallingCode: this.clientPhoneNumber.countryCallingCode,
                        ClientDomain: this.ClientDomain,
                        disabledreceivedemail: _disabledreceivedemail,
                        disabledaddcampaign: _disabledaddcampaign,
                        editorspreadsheet: _seteditor,
                        enablephonenumber: _enablephonenumber,
                        selectedmodules: selectedModulesCreateArray,
                        location_id: this.selects.ghlv2SubAccount,
                        custom_menu_name: custom_menu_name,
                        ip_login: this.$store.getters.userData.ip_login,
                    }).then(response => {
                        //console.log(response);
                        if (response.result == 'success') {
                            this.tableData.push(response.data[0]);
                            this.initialSearchFuse();
                            this.onLogsUser(response.data[0].id, _enablephonenumber == 'T' ? true : false)
                            this.ClearClientForm();
                            $('#showAddEditClient' + id).collapse('hide');
                            $('#btnSave' + id).attr('disabled',false);
                            $('#btnSave' + id).html('Save');
                            this.GetClientList(this.currSortBy, this.currOrderBy);
                            this.ghlv2ResetListSubAccounts();
                            this.ghlv2GetListSubAccounts();

                            const isCreateIframeClientGHLV2 = typeof(response.isCreateIframeClientGHLV2) != 'undefined' ? response.isCreateIframeClientGHLV2 : false;
                            const isSuccessCreateIframeClientGHLV2 = typeof(response.isSuccessCreateIframeClientGHLV2) != 'undefined' ? response.isSuccessCreateIframeClientGHLV2 : false;
                            
                            let message = "Client has been added successfully";
                            if(isCreateIframeClientGHLV2 === true && isSuccessCreateIframeClientGHLV2 === false) {
                                message += ", But create iframe gohighlevel failed";
                            }
                            this.$notify({
                                type: 'success',
                                message: message,
                                icon: 'far fa-save'
                            });
                        }else{
                            $('#btnSave' + id).attr('disabled',false);
                            $('#btnSave' + id).html('Save'); 

                            this.$notify({
                                type: 'primary',
                                message: response.message,
                                icon: 'fas fa-bug'
                            }); 
                        }
                    },error => {
                        $('#btnSave' + id).attr('disabled',false);
                        $('#btnSave' + id).html('Save'); 

                        this.$notify({
                            type: 'primary',
                            message: 'Server might be busy please try again later',
                            icon: 'fas fa-bug'
                        }); 
                    });
                    /** CREATE CLIENT */
                }
                /** PROCESS ADD / EDIT ORGANIZATION */
            }else{
                var frmName = 'frmuser' + id.id;
                const isValid = await this.$refs[frmName].validate();

                if (!isValid) {
                    return false;
                }

                if ((id.name != '' && id.email != '') && (typeof id.name != 'undefined' && typeof id.email != 'undefined')) {
                    $('#btnSave' + id.id).attr('disabled',true);
                    $('#btnSave' + id.id).html('Processing...'); 

                    Object.entries(this.customsidebarleadmenu).forEach(([key, sidebar]) => {
                        if (!(key in this.selectedModules)) {
                            this.$set(this.selectedModules, key, false);
                        }
                    });
                    let selectedModulesArray = [];
                    for (let key in this.selectedModules) {
                        selectedModulesArray.push({
                            type: key,
                            status: this.selectedModules[key]
                        });
                    }

                    const prevSelectedModules = this.prevSelectedModules
                    const selectModules = selectedModulesArray
                    const checkModuleChanges = this.checkModuleChanges(prevSelectedModules, selectModules)
                    this.localActiveCampaignId = []
                    this.locatorActiveCampaignId = []
                    this.enhanceActiveCampaignId = []
                    this.b2bActiveCampaignId = []
                    this.simplifiActiveCampaignId = [];

                    if(checkModuleChanges.length > 0){
                        const promises = checkModuleChanges.map(item => {
                            return this.$store.dispatch('checkCampaignActive', {
                                company_id: id.company_parent,
                                leadspeek_type: item.type,
                                user_type: 'client',
                                user_id: id.id
                            }).then((response) => {
                                if(item.type == 'local'){
                                    this.localActiveCampaignId = response.active_campaign_id
                                }

                                if(item.type == 'locator'){
                                    this.locatorActiveCampaignId = response.active_campaign_id
                                }

                                if(item.type == 'enhance'){
                                    this.enhanceActiveCampaignId = response.active_campaign_id
                                }

                                if(item.type == 'b2b') {
                                    this.b2bActiveCampaignId = response.active_campaign_id
                                }

                                if(item.type == 'simplifi') {
                                    this.simplifiActiveCampaignId = response.active_campaign_id
                                }

                            }, error => {
                                this.$notify({
                                    type: 'primary',
                                    message: 'Server might be busy please try again later',
                                    icon: 'fas fa-bug'
                                });
                            }).catch(error => {
                                this.$notify({
                                    type: 'primary',
                                    message: 'Server might be busy please try again later',
                                    icon: 'fas fa-bug'
                                }); 
                            })
                        })

                        await Promise.all(promises);

                        const htmlLocal = `<div style="font-weight: 600">${this.customsidebarleadmenu.local && this.customsidebarleadmenu.local.name} with campaign id : ${this.localActiveCampaignId.join(', ')}</div>`
                        const htmlLocator = `<div style="font-weight: 600">${this.customsidebarleadmenu.locator && this.customsidebarleadmenu.locator.name} with campaign id : ${this.locatorActiveCampaignId.join(', ')}</div>`
                        const htmlEnhance = `<div style="font-weight: 600">${this.customsidebarleadmenu.enhance && this.customsidebarleadmenu.enhance.name} with campaign id : ${this.enhanceActiveCampaignId.join(', ')}</div>`
                        const htmlB2b = `<div style="font-weight: 600">${this.customsidebarleadmenu.b2b && this.customsidebarleadmenu.b2b.name} with campaign id : ${this.b2bActiveCampaignId.join(', ')}</div>`
                        const htmlSimplifi = `<div style="font-weight: 600">${this.customsidebarleadmenu.simplifi && this.customsidebarleadmenu.simplifi.name} with campaign id : ${this.simplifiActiveCampaignId.join(', ')}</div>`
                        
                        if(this.localActiveCampaignId.length > 0 || this.locatorActiveCampaignId.length > 0 || this.enhanceActiveCampaignId.length > 0 || this.b2bActiveCampaignId.length > 0 || this.simplifiActiveCampaignId.length > 0){
                            swal.fire({
                                html: `<div style="display: flex; flex-direction: column;">
                                        <div style="font-size: 100px; color: #f8bb86;">
                                        <i class="el-icon-warning"></i> 
                                        </div>
                                        <div style="margin-bottom: 16px;">
                                        Unable to disable the product due to active campaigns. Please manually stop the campaigns before disabling the product.
                                        </div>
                                        ${this.localActiveCampaignId.length > 0 ? htmlLocal : ""}
                                        ${this.locatorActiveCampaignId.length > 0 ? htmlLocator : ""}
                                        ${this.enhanceActiveCampaignId.length > 0 ? htmlEnhance : ""}
                                        ${this.b2bActiveCampaignId.length > 0 ? htmlB2b : ""}
                                        ${this.simplifiActiveCampaignId.length > 0 ? htmlSimplifi : ""}
                                    </div>`,
                                confirmButtonClass: 'btn btn-fill',
                                buttonsStyling: false
                            });
                            $('#btnSave' + id.id).attr('disabled',false);
                            $('#btnSave' + id.id).html('Save');
                            return;
                        }
                    }

                    var _enablephonenumber;
                    if (this.rowCheckboxes.phoneenabled) {
                        _enablephonenumber = 'T';
                    } else {
                        _enablephonenumber = 'F';
                    }

                    /** UPDATE CLIENT */
                    this.$store.dispatch('UpdateClient', {
                        companyID: id.company_id,
                        idsys: this.$global.idsys,
                        ClientID: id.id,
                        ClientCompanyName: id.company_name,
                        ClientFullName: id.name,
                        ClientEmail: id.email,
                        ClientPhone: id.phonenum,
                        ClientPhone: this.clientRowPhoneNumber.number,
                        ClientPhoneCountryCode: this.clientRowPhoneNumber.countryCode,
                        ClientPhoneCountryCallingCode: this.clientRowPhoneNumber.countryCallingCode,
                        ClientDomain: id.domain,
                        ClientPass: id.newpassword,
                        disabledreceivedemail: id.disabled_receive_email,
                        disabledaddcampaign: id.disable_client_add_campaign,
                        editorspreadsheet: id.editor_spreadsheet,
                        enablephonenumber: _enablephonenumber,
                        selectedmodules: selectedModulesArray,
                        action: 'client',
                    }).then(response => {
                        //console.log(response[0]);
                        this.$refs.tableData.toggleRowExpansion(id);
                        $('#btnSave' + id.id).attr('disabled',false);
                        $('#btnSave' + id.id).html('Save'); 
                        id.newpassword = '';
                        this.onLogsUser(id.id, _enablephonenumber == 'T' ? true : false)
                        this.GetClientList(this.currSortBy, this.currOrderBy);
                        this.$notify({
                            type: 'success',
                            message: 'Data has been updated successfully',
                            icon: 'far fa-save'
                        });  
                    },error => {
                        $('#btnSave' + id.id).attr('disabled',false);
                        $('#btnSave' + id.id).html('Save'); 

                        if(error.status === 422){
                            this.$notify({
                                type: 'primary',
                                message: error.data.message,
                                icon: 'fas fa-bug'
                            });

                            return;
                        }

                        this.$notify({
                            type: 'primary',
                            message: 'Server might be busy please try again later',
                            icon: 'fas fa-bug'
                        }); 
                    });
                    /** UPDATE CLIENT */
                }
            }
        },
        sortdynamic(column,prop,order) { 
            this.currSortBy = column.prop;
            this.currOrderBy = column.order;
            this.GetClientList(column.prop,column.order);
        },
        searchKeyWord() {
            this.pagination.currentPage = 1;
            this.GetClientList(this.currSortBy,this.currOrderBy);
        },
        GetClientList(sortby,order) {
            var _sortby = '';
            var _order = '';
            var _searchkey = '';

            if (typeof(sortby) != 'undefined') {
                _sortby = sortby;
            }
            if (typeof(order) != 'undefined') {
                _order = order;
            }

            if (this.searchQuery != '') {
                _searchkey = this.searchQuery;
            }
           
            /** GET CLIENT LIST */
            this.tableData = [];
            $('.el-table__empty-text').html('<i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...');
            this.$store.dispatch('GetClientList', {
                companyID: this.companyID,
                idsys: this.$global.idsys,
                userType:'client',
                sortby: _sortby,
                order: _order,
                searchkey: _searchkey,
                page:this.pagination.currentPage,
                cardStatus: this.filters.cardStatus,
                campaignStatus: this.filters.campaignStatus,
            }).then(response => {
                this.pagination.currentPage = response.current_page? response.current_page : 1
                this.pagination.total = response.total ?response.total : 0
                this.pagination.lastPage = response.last_page ? response.last_page : 0
                this.pagination.from = response.from ? response.from : 0
                this.pagination.to = response.to ? response.to : 0
                
                if (response.data.length == 0) {
                    $('.el-table__empty-text').html('No Data');
                }
                
                for(let i=0;i<response.data.length;i++) {
                    if (response.data[i].phonenum == '') {
                        response.data[i].phonenum = '000-000-0000';
                    }
                }
                this.tableData = response.data
                this.initialSearchFuse()
                if (response.data.length == 0) {
                    $('.el-table__empty-text').html('No Data');
                }
            },error => {
                
            });
            /** GET CLIENT LIST */
        },

        initialSearchFuse() {
            // Fuse search initialization.
            // this.fuseSearch = new Fuse(this.tableData, {
            //     keys: ['company_name','name','email','phonenum','created_at'],
            //     threshold: 0.1
            // });
        },

        handleLike(index, row) {
            swal.fire({
                title: `You liked ${row.name}`,
                buttonsStyling: false,
                icon: 'success',
                customClass: {
                confirmButton: 'btn btn-success btn-fill'
                }
            });
        },
        handleCardSet(index,row) {
            this.cleanCCform();
            this.ClientActiveID = row.id;
            this.LeadspeekCompany = row.company_name;
            this.clientPaymentFailed = false;
            if (row.payment_status == 'failed' && row.failed_campaignid != '' && row.failed_campaignid !== null) {
                this.clientPaymentFailed = true;
                this.failedCampaignNumber = row.failed_campaignid.split('|');
                this.failedInvoiceAmount = row.failed_total_amount.split('|');
            }
            this.termhost = row.company_id;
            this.getCardInfo(row.id);
        },
        resetClientCost() {
            this.selectsAppModule.AppModuleSelect = 'LeadsPeek';
            this.LeadspeekPlatformFee = '0';
            this.LeadspeekCostperlead = '0';
            this.LeadspeekCostperleadAdvanced = '0';
            this.LeadspeekMinCostMonth = '0';

            this.LocatorPlatformFee = '0';
            this.LocatorCostperlead = '0';
            this.LocatorMinCostMonth = '0';
            
            this.EnhancePlatformFee = '0';
            this.EnhanceCostperlead = '0';
            this.EnhanceMinCostMonth = '0';
            
            this.lead_FirstName_LastName = '0';
            this.lead_FirstName_LastName_MailingAddress = '0';
            this.lead_FirstName_LastName_MailingAddress_Phone = '0';

            this.costagency.local.Weekly.LeadspeekPlatformFee = '0';
            this.costagency.local.Weekly.LeadspeekCostperlead = '0';
            this.costagency.local.Weekly.LeadspeekCostperleadAdvanced = '0';
            this.costagency.local.Weekly.LeadspeekMinCostMonth = '0';
            this.costagency.local.Weekly.LeadspeekLeadsPerday = '0';

            this.costagency.local.Monthly.LeadspeekPlatformFee = '0';
            this.costagency.local.Monthly.LeadspeekCostperlead = '0';
            this.costagency.local.Monthly.LeadspeekMinCostMonth = '0';
            this.costagency.local.Monthly.LeadspeekLeadsPerday = '0';

            this.costagency.local.OneTime.LeadspeekPlatformFee = '0';
            this.costagency.local.OneTime.LeadspeekCostperlead = '0';
            this.costagency.local.OneTime.LeadspeekMinCostMonth = '0';
            this.costagency.local.OneTime.LeadspeekLeadsPerday = '0';

            this.costagency.locator.Weekly.LocatorPlatformFee = '0';
            this.costagency.locator.Weekly.LocatorCostperlead = '0';
            this.costagency.locator.Weekly.LocatorMinCostMonth = '0';
            this.costagency.locator.Weekly.LeadspeekLeadsPerday = '0';

            this.costagency.locator.Monthly.LocatorPlatformFee = '0';
            this.costagency.locator.Monthly.LocatorCostperlead = '0';
            this.costagency.locator.Monthly.LocatorMinCostMonth = '0';
            this.costagency.locator.Monthly.LeadspeekLeadsPerday = '0';

            this.costagency.locator.OneTime.LocatorPlatformFee = '0';
            this.costagency.locator.OneTime.LocatorCostperlead = '0';
            this.costagency.locator.OneTime.LocatorMinCostMonth = '0';
            this.costagency.locator.OneTime.LeadspeekLeadsPerday = '0';

            this.costagency.enhance.Weekly.enhancePlatformFee = '0';
            this.costagency.enhance.Weekly.enhanceCostperlead = '0';
            this.costagency.enhance.Weekly.enhanceMinCostMonth = '0';
            this.costagency.enhance.Weekly.LeadspeekLeadsPerday = '0';

            this.costagency.enhance.Monthly.enhancePlatformFee = '0';
            this.costagency.enhance.Monthly.enhanceCostperlead = '0';
            this.costagency.enhance.Monthly.enhanceMinCostMonth = '0';
            this.costagency.enhance.Monthly.LeadspeekLeadsPerday = '0';

            this.costagency.enhance.OneTime.enhancePlatformFee = '0';
            this.costagency.enhance.OneTime.enhanceCostperlead = '0';
            this.costagency.enhance.OneTime.enhanceMinCostMonth = '0';
            this.costagency.enhance.OneTime.LeadspeekLeadsPerday = '0';

            this.costagency.locatorlead.FirstName_LastName = '0';
            this.costagency.locatorlead.FirstName_LastName_MailingAddress = '0';
            this.costagency.locatorlead.FirstName_LastName_MailingAddress_Phone = '0';
        },
        handlePriceSet(index, row) {
            //console.log(row);
            this.initial_default_price();
            this.activeClientCompanyID = row.company_id; 
            this.activeClientCompanyIndex = index;
            this.activeClientID = row.id;
            this.LeadspeekCompany = row.company_name;
            this.resetClientCost();
            this.$store.dispatch('getGeneralSetting', {
                companyID: row.company_id,
                settingname: 'clientdefaultprice',
                idSys: this.$global.idsys
            }).then(response => {
                //console.log(response);
                if (response.data != '') {
                    this.costagency = response.data;
                    this.clientMinLeadDayEnhance = response.clientMinLeadDayEnhance;
                    // this.selectsPaymentTerm.PaymentTermSelect = row.paymentterm_default;
                    this.selectsPaymentTerm.PaymentTermSelect = this.tableData[this.activeClientCompanyIndex].paymentterm_default;
                    this.paymentTermStatus();

                    if(this.clientMinLeadDayEnhance != '') {
                        if(Number(this.costagency.enhance.Weekly.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.enhance.Weekly.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.enhance.Monthly.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.enhance.Monthly.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.enhance.OneTime.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.enhance.OneTime.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.enhance.Prepaid.EnhanceLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.enhance.Prepaid.EnhanceLeadsPerday = this.clientMinLeadDayEnhance;
                        }

                        if(Number(this.costagency.b2b.Weekly.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.b2b.Weekly.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.b2b.Monthly.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.b2b.Monthly.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.b2b.OneTime.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.b2b.OneTime.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                        if(Number(this.costagency.b2b.Prepaid.B2bLeadsPerday) < Number(this.clientMinLeadDayEnhance)) {
                            this.costagency.b2b.Prepaid.B2bLeadsPerday = this.clientMinLeadDayEnhance;
                        }
                    }


                    //this.selectsPaymentTerm.PaymentTermSelect = 'Weekly';
                    if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                        this.LeadspeekPlatformFee = this.costagency.local.Weekly.LeadspeekPlatformFee;
                        this.LeadspeekCostperlead = this.costagency.local.Weekly.LeadspeekCostperlead;
                        this.LeadspeekCostperleadAdvanced = this.costagency.local.Weekly.LeadspeekCostperleadAdvanced;
                        this.LeadspeekMinCostMonth = this.costagency.local.Weekly.LeadspeekMinCostMonth;
                        this.LeadspeekLeadsPerday = this.costagency.local.Weekly.LeadspeekLeadsPerday;

                        this.LocatorPlatformFee  = this.costagency.locator.Weekly.LocatorPlatformFee;
                        this.LocatorCostperlead = this.costagency.locator.Weekly.LocatorCostperlead;
                        this.LocatorMinCostMonth = this.costagency.locator.Weekly.LocatorMinCostMonth;
                        this.LocatorLeadsPerday = this.costagency.locator.Weekly.LocatorLeadsPerday;
                        
                        this.EnhancePlatformFee  = this.costagency.enhance.Weekly.EnhancePlatformFee;
                        this.EnhanceCostperlead = this.costagency.enhance.Weekly.EnhanceCostperlead;
                        this.EnhanceMinCostMonth = this.costagency.enhance.Weekly.EnhanceMinCostMonth;
                        this.EnhanceLeadsPerday = this.costagency.enhance.Weekly.EnhanceLeadsPerday;
                        
                        this.B2bPlatformFee  = this.costagency.b2b.Weekly.B2bPlatformFee;
                        this.B2bCostperlead = this.costagency.b2b.Weekly.B2bCostperlead;
                        this.B2bMinCostMonth = this.costagency.b2b.Weekly.B2bMinCostMonth;
                        this.B2bLeadsPerday = this.costagency.b2b.Weekly.B2bLeadsPerday;

                        /* ENABLE MINIMUM LEAD PER DAY */
                        // this.LeadspeekEnableMinimumLeadsPerDay = typeof(this.costagency.local.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.local.EnableMinimumLeadsPerday : false;
                        // this.LocatorEnableMinimumLeadsPerDay = typeof(this.costagency.locator.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.locator.EnableMinimumLeadsPerday : false;
                        // this.EnhanceEnableMinimumLeadsPerDay = typeof(this.costagency.enhance.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.enhance.EnableMinimumLeadsPerday : false;
                        // this.B2bEnableMinimumLeadsPerDay = typeof(this.costagency.b2b.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.b2b.EnableMinimumLeadsPerday : false;
                        this.LeadspeekEnableMinimumLeadsPerDay = false;
                        this.LocatorEnableMinimumLeadsPerDay = false;
                        this.EnhanceEnableMinimumLeadsPerDay = false;
                        this.B2bEnableMinimumLeadsPerDay = false;
                        /* ENABLE MINIMUM LEAD PER DAY */
                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                        this.LeadspeekPlatformFee = this.costagency.local.Monthly.LeadspeekPlatformFee;
                        this.LeadspeekCostperlead = this.costagency.local.Monthly.LeadspeekCostperlead;
                        this.LeadspeekCostperleadAdvanced = this.costagency.local.Monthly.LeadspeekCostperleadAdvanced;
                        this.LeadspeekMinCostMonth = this.costagency.local.Monthly.LeadspeekMinCostMonth;
                        this.LeadspeekLeadsPerday = this.costagency.local.Monthly.LeadspeekLeadsPerday;

                        this.LocatorPlatformFee  = this.costagency.locator.Monthly.LocatorPlatformFee;
                        this.LocatorCostperlead = this.costagency.locator.Monthly.LocatorCostperlead;
                        this.LocatorMinCostMonth = this.costagency.locator.Monthly.LocatorMinCostMonth;
                        this.LocatorLeadsPerday = this.costagency.locator.Monthly.LocatorLeadsPerday;

                        this.EnhancePlatformFee  = this.costagency.enhance.Monthly.EnhancePlatformFee;
                        this.EnhanceCostperlead = this.costagency.enhance.Monthly.EnhanceCostperlead;
                        this.EnhanceMinCostMonth = this.costagency.enhance.Monthly.EnhanceMinCostMonth;
                        this.EnhanceLeadsPerday = this.costagency.enhance.Monthly.EnhanceLeadsPerday;

                        this.B2bPlatformFee  = this.costagency.b2b.Monthly.B2bPlatformFee;
                        this.B2bCostperlead = this.costagency.b2b.Monthly.B2bCostperlead;
                        this.B2bMinCostMonth = this.costagency.b2b.Monthly.B2bMinCostMonth;
                        this.B2bLeadsPerday = this.costagency.b2b.Monthly.B2bLeadsPerday;

                        /* ENABLE MINIMUM LEAD PER DAY */
                        // this.LeadspeekEnableMinimumLeadsPerDay = typeof(this.costagency.local.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.local.EnableMinimumLeadsPerday : false;
                        // this.LocatorEnableMinimumLeadsPerDay = typeof(this.costagency.locator.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.locator.EnableMinimumLeadsPerday : false;
                        // this.EnhanceEnableMinimumLeadsPerDay = typeof(this.costagency.enhance.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.enhance.EnableMinimumLeadsPerday : false;
                        // this.B2bEnableMinimumLeadsPerDay = typeof(this.costagency.b2b.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.b2b.EnableMinimumLeadsPerday : false;
                        this.LeadspeekEnableMinimumLeadsPerDay = false;
                        this.LocatorEnableMinimumLeadsPerDay = false;
                        this.EnhanceEnableMinimumLeadsPerDay = false;
                        this.B2bEnableMinimumLeadsPerDay = false;
                        /* ENABLE MINIMUM LEAD PER DAY */
                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {
                        this.LeadspeekPlatformFee = this.costagency.local.OneTime.LeadspeekPlatformFee;
                        this.LeadspeekCostperlead = this.costagency.local.OneTime.LeadspeekCostperlead;
                        this.LeadspeekCostperleadAdvanced = this.costagency.local.OneTime.LeadspeekCostperleadAdvanced;
                        this.LeadspeekMinCostMonth = this.costagency.local.OneTime.LeadspeekMinCostMonth;
                        this.LeadspeekLeadsPerday = this.costagency.local.OneTime.LeadspeekLeadsPerday;

                        this.LocatorPlatformFee  = this.costagency.locator.OneTime.LocatorPlatformFee;
                        this.LocatorCostperlead = this.costagency.locator.OneTime.LocatorCostperlead;
                        this.LocatorMinCostMonth = this.costagency.locator.OneTime.LocatorMinCostMonth;
                        this.LocatorLeadsPerday = this.costagency.locator.OneTime.LocatorLeadsPerday;
                        
                        this.EnhancePlatformFee  = this.costagency.enhance.OneTime.EnhancePlatformFee;
                        this.EnhanceCostperlead = this.costagency.enhance.OneTime.EnhanceCostperlead;
                        this.EnhanceMinCostMonth = this.costagency.enhance.OneTime.EnhanceMinCostMonth;
                        this.EnhanceLeadsPerday = this.costagency.enhance.OneTime.EnhanceLeadsPerday;

                        this.B2bPlatformFee  = this.costagency.b2b.OneTime.B2bPlatformFee;
                        this.B2bCostperlead = this.costagency.b2b.OneTime.B2bCostperlead;
                        this.B2bMinCostMonth = this.costagency.b2b.OneTime.B2bMinCostMonth;
                        this.B2bLeadsPerday = this.costagency.b2b.OneTime.B2bLeadsPerday;

                        /* ENABLE MINIMUM LEAD PER DAY */
                        // this.LeadspeekEnableMinimumLeadsPerDay = typeof(this.costagency.local.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.local.EnableMinimumLeadsPerday : false;
                        // this.LocatorEnableMinimumLeadsPerDay = typeof(this.costagency.locator.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.locator.EnableMinimumLeadsPerday : false;
                        // this.EnhanceEnableMinimumLeadsPerDay = typeof(this.costagency.enhance.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.enhance.EnableMinimumLeadsPerday : false;
                        // this.B2bEnableMinimumLeadsPerDay = typeof(this.costagency.b2b.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.b2b.EnableMinimumLeadsPerday : false;
                        this.LeadspeekEnableMinimumLeadsPerDay = false;
                        this.LocatorEnableMinimumLeadsPerDay = false;
                        this.EnhanceEnableMinimumLeadsPerDay = false;
                        this.B2bEnableMinimumLeadsPerDay = false;
                        /* ENABLE MINIMUM LEAD PER DAY */
                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {

                        this.LeadspeekPlatformFee = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekPlatformFee:0;
                        this.LeadspeekCostperlead = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekCostperlead:0;
                        this.LeadspeekCostperleadAdvanced = (typeof(this.costagency.local.Prepaid) != 'undefined')?this.costagency.local.Prepaid.LeadspeekCostperleadAdvanced:0;
                        this.LeadspeekMinCostMonth = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekMinCostMonth:0;
                        this.LeadspeekLeadsPerday = (typeof(this.costagency.local.Prepaid) !== 'undefined')?this.costagency.local.Prepaid.LeadspeekLeadsPerday:10;

                        this.LocatorPlatformFee  = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorPlatformFee:0;
                        this.LocatorCostperlead = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorCostperlead:0;
                        this.LocatorMinCostMonth = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorMinCostMonth:0;
                        this.LocatorLeadsPerday = (typeof(this.costagency.locator.Prepaid) !== 'undefined')?this.costagency.locator.Prepaid.LocatorLeadsPerday:10;

                        this.EnhancePlatformFee  = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhancePlatformFee:0;
                        this.EnhanceCostperlead = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhanceCostperlead:0;
                        this.EnhanceMinCostMonth = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhanceMinCostMonth:0;
                        this.EnhanceLeadsPerday = (typeof(this.costagency.enhance.Prepaid) !== 'undefined')?this.costagency.enhance.Prepaid.EnhanceLeadsPerday:10;
                        
                        this.B2bPlatformFee  = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bPlatformFee:0;
                        this.B2bCostperlead = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bCostperlead:0;
                        this.B2bMinCostMonth = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bMinCostMonth:0;
                        this.B2bLeadsPerday = (typeof(this.costagency.b2b.Prepaid) !== 'undefined')?this.costagency.b2b.Prepaid.B2bLeadsPerday:10;

                        /* ENABLE MINIMUM LEAD PER DAY */
                        // this.LeadspeekEnableMinimumLeadsPerDay = typeof(this.costagency.local.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.local.EnableMinimumLeadsPerday : false;
                        // this.LocatorEnableMinimumLeadsPerDay = typeof(this.costagency.locator.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.locator.EnableMinimumLeadsPerday : false;
                        // this.EnhanceEnableMinimumLeadsPerDay = typeof(this.costagency.enhance.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.enhance.EnableMinimumLeadsPerday : false;
                        // this.B2bEnableMinimumLeadsPerDay = typeof(this.costagency.b2b.EnableMinimumLeadsPerday) != 'undefined' ? this.costagency.b2b.EnableMinimumLeadsPerday : false;
                        this.LeadspeekEnableMinimumLeadsPerDay = false;
                        this.LocatorEnableMinimumLeadsPerDay = false;
                        this.EnhanceEnableMinimumLeadsPerDay = false;
                        this.B2bEnableMinimumLeadsPerDay = false;
                        /* ENABLE MINIMUM LEAD PER DAY */
                    }

                    // for Simplifi Settings
                    const prepaidSimplifi = (this.costagency && this.costagency.simplifi && this.costagency.simplifi.Prepaid);
                    this.SimplifiMaxBid = (prepaidSimplifi && typeof(prepaidSimplifi.SimplifiMaxBid) != 'undefined')?prepaidSimplifi.SimplifiMaxBid:0;
                    this.SimplifiDailyBudget = (prepaidSimplifi && typeof(prepaidSimplifi.SimplifiDailyBudget) != 'undefined')?prepaidSimplifi.SimplifiDailyBudget:0;
                    this.SimplifiAgencyMarkup = (prepaidSimplifi && typeof(prepaidSimplifi.SimplifiAgencyMarkup) != 'undefined')?prepaidSimplifi.SimplifiAgencyMarkup:0;
                    // for Simplifi Settings

                    this.lead_FirstName_LastName = this.costagency.locatorlead.FirstName_LastName;
                    this.lead_FirstName_LastName_MailingAddress  = this.costagency.locatorlead.FirstName_LastName_MailingAddress;
                    this.lead_FirstName_LastName_MailingAddress_Phone = this.costagency.locatorlead.FirstName_LastName_MailingAddress_Phone;

                    const updateLogs = {
                        billingFrequency: this.selectsPaymentTerm.PaymentTermSelect,
                        
                        setupFeeLocal: this.LeadspeekPlatformFee,
                        campaignFeeLocal: this.LeadspeekMinCostMonth,
                        costPerLeadLocal: this.LeadspeekCostperlead,
                        costPerLeadAdvancedLocal: this.LeadspeekCostperleadAdvanced,
                        leadPerDayLocal: this.LeadspeekLeadsPerday,

                        setupFeeLocator: this.LocatorPlatformFee,
                        campaignFeeLocator: this.LocatorMinCostMonth,
                        costPerLeadLocator: this.LocatorCostperlead,
                        leadPerDayLocator: this.LocatorLeadsPerday,

                        setupFeeEnhance: this.EnhancePlatformFee,
                        campaignFeeEnhance: this.EnhanceMinCostMonth,
                        costPerLeadEnhance: this.EnhanceCostperlead,
                        leadPerDayEnhance: this.EnhanceLeadsPerday,

                        setupFeeB2B: this.B2bPlatformFee,
                        campaignFeeB2B: this.B2bMinCostMonth,
                        costPerLeadB2B: this.B2bCostperlead,
                        leadPerDayB2B: this.B2bLeadsPerday,
                    }
                    this.$set(this, 'prevDefaultRetailPrice', updateLogs);

                }else{
                    this.selectsPaymentTerm.PaymentTermSelect = response.dpay;
                    this.paymentTermStatus();
                }
                this.modals.pricesetup = true;
            },error => {
                    
            });
            
        },
        initial_default_price() {
            this.resetAgencyCost();

            this.$store.dispatch('getGeneralSetting', {
                companyID: this.companyID,
                settingname: 'agencydefaultprice',
                idSys: this.$global.idsys
            }).then(response => {
                //console.log(response.data);
                if (response.data != '') {
                    // this.costagency = response.data;
                    this.rootCostAgency = response.rootcostagency;

                    if (this.selectsPaymentTerm.PaymentTermSelect == 'Weekly') {
                                                
                        this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekCostperlead:0;
                        this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekCostperleadAdvanced:0;
                        this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorCostperlead:0;
                        this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhanceCostperlead:0;
                        this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bCostperlead:0;

                        this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekPlatformFee:0;
                        this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Weekly) !== 'undefined')?this.rootCostAgency.local.Weekly.LeadspeekMinCostMonth:0;
                        this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorPlatformFee:0;
                        this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Weekly) !== 'undefined')?this.rootCostAgency.locator.Weekly.LocatorMinCostMonth:0;
                        this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhancePlatformFee:0;
                        this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Weekly) !== 'undefined')?this.rootCostAgency.enhance.Weekly.EnhanceMinCostMonth:0;
                        this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bPlatformFee:0;
                        this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Weekly) !== 'undefined')?this.rootCostAgency.b2b.Weekly.B2bMinCostMonth:0;

                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Monthly') {
                        
                        this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekCostperlead:0;
                        this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekCostperleadAdvanced:0;
                        this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorCostperlead:0;
                        this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhanceCostperlead:0;
                        this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bCostperlead:0;

                        this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekPlatformFee:0;
                        this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Monthly) !== 'undefined')?this.rootCostAgency.local.Monthly.LeadspeekMinCostMonth:0;
                        this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorPlatformFee:0;
                        this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Monthly) !== 'undefined')?this.rootCostAgency.locator.Monthly.LocatorMinCostMonth:0;
                        this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhancePlatformFee:0;
                        this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Monthly) !== 'undefined')?this.rootCostAgency.enhance.Monthly.EnhanceMinCostMonth:0;
                        this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bPlatformFee:0;
                        this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Monthly) !== 'undefined')?this.rootCostAgency.b2b.Monthly.B2bMinCostMonth:0;

                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'One Time') {

                        this.m_LeadspeekCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekCostperlead:0;
                        this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekCostperleadAdvanced:0;
                        this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorCostperlead:0;
                        this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhanceCostperlead:0;
                        this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bCostperlead:0;

                        this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekPlatformFee:0;
                        this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.OneTime) !== 'undefined')?this.rootCostAgency.local.OneTime.LeadspeekMinCostMonth:0;
                        this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorPlatformFee:0;
                        this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.OneTime) !== 'undefined')?this.rootCostAgency.locator.OneTime.LocatorMinCostMonth:0;
                        this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhancePlatformFee:0;
                        this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.OneTime) !== 'undefined')?this.rootCostAgency.enhance.OneTime.EnhanceMinCostMonth:0;
                        this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bPlatformFee:0;
                        this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.OneTime) !== 'undefined')?this.rootCostAgency.b2b.OneTime.B2bMinCostMonth:0;

                    }else if (this.selectsPaymentTerm.PaymentTermSelect == 'Prepaid') {

                        this.m_LeadspeekCostPerLead =  (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekCostperlead:0; 
                        this.m_LeadspeekCostPerLeadAdvanced = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekCostperleadAdvanced:0;
                        this.m_LeadspeekLocatorCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorCostperlead:0;
                        this.m_LeadspeekEnhanceCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhanceCostperlead:0;
                        this.m_LeadspeekB2BCostPerLead = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bCostperlead:0;

                        this.m_LeadspeekPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekPlatformFee:0;
                        this.m_LeadspeekMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.local.Prepaid) !== 'undefined')?this.rootCostAgency.local.Prepaid.LeadspeekMinCostMonth:0;
                        this.m_LeadspeekLocatorPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorPlatformFee:0;
                        this.m_LeadspeekLocatorMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined')?this.rootCostAgency.locator.Prepaid.LocatorMinCostMonth:0;
                        this.m_LeadspeekEnhancePlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhancePlatformFee:0;
                        this.m_LeadspeekEnhanceMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined')?this.rootCostAgency.enhance.Prepaid.EnhanceMinCostMonth:0;
                        this.m_LeadspeekB2BPlatformFee = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bPlatformFee:0;
                        this.m_LeadspeekB2BMinCostMonth = (this.rootCostAgency != '' && typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined')?this.rootCostAgency.b2b.Prepaid.B2bMinCostMonth:0;

                    }

                }
                
            },error => {
                    
            });
        },
        resetAgencyCost() {

            this.rootCostAgency.local.Weekly.LeadspeekPlatformFee = '0';
            this.rootCostAgency.local.Weekly.LeadspeekCostperlead = '0';
            this.rootCostAgency.local.Weekly.LeadspeekCostperleadAdvanced = '0';
            this.rootCostAgency.local.Weekly.LeadspeekMinCostMonth = '0';

            this.rootCostAgency.local.Monthly.LeadspeekPlatformFee = '0';
            this.rootCostAgency.local.Monthly.LeadspeekCostperlead = '0';
            this.rootCostAgency.local.Monthly.LeadspeekCostperleadAdvanced = '0';
            this.rootCostAgency.local.Monthly.LeadspeekMinCostMonth = '0';

            this.rootCostAgency.local.OneTime.LeadspeekPlatformFee = '0';
            this.rootCostAgency.local.OneTime.LeadspeekCostperlead = '0';
            this.rootCostAgency.local.OneTime.LeadspeekCostperleadAdvanced = '0';
            this.rootCostAgency.local.OneTime.LeadspeekMinCostMonth = '0';

            if (typeof(this.rootCostAgency.local.Prepaid) !== 'undefined') {
                this.rootCostAgency.local.Prepaid.LeadspeekPlatformFee = '0';
                this.rootCostAgency.local.Prepaid.LeadspeekCostperlead = '0';
                this.rootCostAgency.local.Prepaid.LeadspeekCostperleadAdvanced = '0';
                this.rootCostAgency.local.Prepaid.LeadspeekMinCostMonth = '0';
            }

            this.rootCostAgency.locator.Weekly.LocatorPlatformFee = '0';
            this.rootCostAgency.locator.Weekly.LocatorCostperlead = '0';
            this.rootCostAgency.locator.Weekly.LocatorMinCostMonth = '0';

            this.rootCostAgency.locator.Monthly.LocatorPlatformFee = '0';
            this.rootCostAgency.locator.Monthly.LocatorCostperlead = '0';
            this.rootCostAgency.locator.Monthly.LocatorMinCostMonth = '0';

            this.rootCostAgency.locator.OneTime.LocatorPlatformFee = '0';
            this.rootCostAgency.locator.OneTime.LocatorCostperlead = '0';
            this.rootCostAgency.locator.OneTime.LocatorMinCostMonth = '0';

            if (typeof(this.rootCostAgency.locator.Prepaid) !== 'undefined') {
                this.rootCostAgency.locator.Prepaid.LocatorPlatformFee = '0';
                this.rootCostAgency.locator.Prepaid.LocatorCostperlead = '0';
                this.rootCostAgency.locator.Prepaid.LocatorMinCostMonth = '0';
            }

            this.rootCostAgency.enhance.Weekly.EnhancePlatformFee = '0';
            this.rootCostAgency.enhance.Weekly.EnhanceCostperlead = '0';
            this.rootCostAgency.enhance.Weekly.EnhanceMinCostMonth = '0';

            this.rootCostAgency.enhance.Monthly.EnhancePlatformFee = '0';
            this.rootCostAgency.enhance.Monthly.EnhanceCostperlead = '0';
            this.rootCostAgency.enhance.Monthly.EnhanceMinCostMonth = '0';

            this.rootCostAgency.enhance.OneTime.EnhancePlatformFee = '0';
            this.rootCostAgency.enhance.OneTime.EnhanceCostperlead = '0';
            this.rootCostAgency.enhance.OneTime.EnhanceMinCostMonth = '0';

            if (typeof(this.rootCostAgency.enhance.Prepaid) !== 'undefined') {
                this.rootCostAgency.enhance.Prepaid.EnhancePlatformFee = '0';
                this.rootCostAgency.enhance.Prepaid.EnhanceCostperlead = '0';
                this.rootCostAgency.enhance.Prepaid.EnhanceMinCostMonth = '0';
            }

            this.rootCostAgency.b2b.Weekly.B2bPlatformFee = '0';
            this.rootCostAgency.b2b.Weekly.B2bCostperlead = '0';
            this.rootCostAgency.b2b.Weekly.B2bMinCostMonth = '0';

            this.rootCostAgency.b2b.Monthly.B2bPlatformFee = '0';
            this.rootCostAgency.b2b.Monthly.B2bCostperlead = '0';
            this.rootCostAgency.b2b.Monthly.B2bMinCostMonth = '0';

            this.rootCostAgency.b2b.OneTime.B2bPlatformFee = '0';
            this.rootCostAgency.b2b.OneTime.B2bCostperlead = '0';
            this.rootCostAgency.b2b.OneTime.B2bMinCostMonth = '0';

            if (typeof(this.rootCostAgency.b2b.Prepaid) !== 'undefined') {
                this.rootCostAgency.b2b.Prepaid.B2bPlatformFee = '0';
                this.rootCostAgency.b2b.Prepaid.B2bCostperlead = '0';
                this.rootCostAgency.b2b.Prepaid.B2bMinCostMonth = '0';
            }
        },
        handleDelete(index, row) {
            //console.log('Row: ' + index);
            swal.fire({
                title: 'Are you sure want to delete this?',
                text: `You won't be able to revert this!`,
                icon: '',
                showCancelButton: true,
                customClass: {
                confirmButton: 'btn btn-fill mr-3',
                cancelButton: 'btn btn-danger btn-fill'
                },
                confirmButtonText: 'Yes, delete it!',
                buttonsStyling: false
        }).then(result => {
                if (result.value) {
                    /** REMOVE ORGANIZATION */
                    
                        this.$store.dispatch('RemoveClient', {
                            companyID: row.company_id,
                            userID: row.id,
                        }).then(response => {
                            //console.log(response)
                            if(response.data.result == "success") {
                                this.deleteRow(row);
                                this.ghlv2ResetListSubAccounts();
                                this.ghlv2GetListSubAccounts();
                                swal.fire({
                                    title: 'Deleted!',
                                    text: `You deleted ${row.name}`,
                                    icon: 'success',
                                    confirmButtonClass: 'btn btn-default btn-fill',
                                    buttonsStyling: false
                                });
                            }else{
                                this.$notify({
                                    type: 'primary',
                                    message: response.data.message,
                                    icon: 'fas fa-bug'
                                }); 
                            }
                        },error => {
                            
                        });
                        
                    /** REMOVE ORGANIZATION */    
                }
        });
        },
        deleteRow(row) {
            let indexToDelete = this.tableData.findIndex(
                tableRow => tableRow.id === row.id
            );
            if (indexToDelete >= 0) {
                this.tableData.splice(indexToDelete, 1);
            }
        },
        processRechargeExisting(_act) {
            this.$store.dispatch('processUpdateCard', {
                tokenid: '',
                cardholder: '',
                address: '',
                city: '',
                state: '',
                country: '',
                zip: '',
                usrID: this.ClientActiveID,
                companyParentID: this.companyID,
                action: _act,
                document: DOCUMENTS.DEFAULT_CLIENT,
            }).then(response => {
                this.$refs.formCC.reset(); 

                if(response.result == 'success' && response.msg != '') {
                    $('#btnRetryExistCard').html('Retry charge with existing card');
                    $('#btnRetryExistCard').attr('disabled',false);
                    $('#btnUpdateAndCharge').html('save and charge amount due');
                    $('#btnUpdateAndCharge').attr('disabled', false);
                    this.GetClientList();

                    swal.fire({
                        icon: "success",
                        title: response.title,
                        text: response.msg
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // Refresh the page when the user clicks "OK"
                            // location.reload();
                        }
                    });
                    
                }else{
                    $('#btnRetryExistCard').html('Retry charge with existing card');
                    $('#btnRetryExistCard').attr('disabled',false);
                    $('#btnUpdateAndCharge').html('save and charge amount due');
                    $('#btnUpdateAndCharge').attr('disabled', false);

                    _this.$refs.formCC.reset();  
                    _this.cleanCCform();
                    
                    swal.fire({
                        icon: "error",
                        title: response.title,
                        text: response.msg
                    });
                     
                    // this.modals.cardsetup = false;
                    // this.modals.cardupdate = false;
                    // this.cardretrychargeTitle = response.title;
                    // this.cardretrychargeTxt = response.msg;
                    // this.modals.cardretrycharge = false;
                    
                }
        
            },error => {
                
            });
        },
        validateCC(action) {
            if (action == 'existcard') {
                $('#btnRetryExistCard').html('Processing...')
                $('#btnRetryExistCard').attr('disabled', true);
                $('#btnUpdateAndCharge').attr('disabled', true);

                /** UPDATE THE CARD INFORMATION */
                this.processRechargeExisting(action);
                /** UPDATE THE CARD INFORMATION */
                return false;
            }

            if(this.selects.country === '' || this.selects.state === ''){
                this.showErrorMessage = true
            }
            return this.$refs.formCC.validate().then(res => {
                if(res) {
                    this.agreeTermStat = false;
                    if (this.agreeTerm == false) {
                        this.agreeTermStat = true;
                        return false;
                    }

                    if (this.selects.state != '' && this.selects.country != '') {
                        $('#btnupdcc').attr('disabled',true);
                        $('#btnupdcc').html('Processing...'); 
                        $('#btnUpdateAndCharge').html('Processing...');
                        $('#btnUpdateAndCharge').attr('disabled', true);
                        $('#btnRetryExistCard').attr('disabled', true);
                        /** UPDATE THE CARD INFORMATION */
                        if (this.btncardupdate === true) {
                            this.processUpdateCard(action);
                            // console.log('CC updated!');
                        }else{
                            this.processAddCard(action);
                            // console.log('CC Added!');
                        }
                        /** UPDATE THE CARD INFORMATION */
                    }else{
                        this.showErrorMessage = true
                    }

                }
            });
            
        },
        processAddCard(action) {
            var _store = this.$store;
            var _this = this;
            var _act = action;

            return new Promise((resolve, reject) => {
                _stripe.createToken(_cardElement).then(function(result) {
                    if(result.error) {
                        //console.log(result.error.message);
                        $('#btnupdcc').attr('disabled',false);
                        $('#btnupdcc').html('Update'); 
                        $('#btnUpdateAndCharge').html('save and charge amount due');
                        $('#btnUpdateAndCharge').attr('disabled',false);
                        $('#btnRetryExistCard').html('Retry charge with existing card');
                        $('#btnRetryExistCard').attr('disabled', false);
                        $('#carderror').html('<small style="color:red !important;"><sup>*</sup>' + result.error.message + '</small>');
                        $('.card-border').addClass('error-border');
                        $('#carderror').show();
                    }else{
                        $('#carderror').hide();
                        $('.card-border').removeClass('error-border');
                        _tokenid = result.token.id;
                        _store.dispatch('paymentcustomersetup', {
                            tokenid: _tokenid,
                            cardholder: _this.cardholdername,
                            address: _this.billingaddress,
                            city: _this.city,
                            state: _this.selects.state,
                            country: _this.selects.country,
                            zip: _this.zipcode,
                            usrID: _this.ClientActiveID,
                            action: _act,
                            document_type: DOCUMENTS.DEFAULT_CLIENT,
                            from: 'client-management',
                        }).then(response => {
                            //console.log(response.result)
                            if(response.result == 'success' && response.msg != '') {
                                _this.$refs.formCC.reset();  
                                _this.modals.cardsetup = false;
                                _this.GetClientList();
                                $('#btnupdcc').attr('disabled',false);
                                $('#btnupdcc').html('Update'); 
                                $('#btnRetryExistCard').html('Retry charge with existing card');
                                $('#btnRetryExistCard').attr('disabled',false);
                                $('#btnUpdateAndCharge').html('save and charge amount due');
                                $('#btnUpdateAndCharge').attr('disabled', false);
                                swal.fire({
                                    icon: "success",
                                    title: response.title,
                                    text: response.msg
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        // Refresh the page when the user clicks "OK"
                                        // location.reload();
                                    }
                                });
                                // _this.modals.cardupdate = true;
                                // _this.modals.cardretrycharge = false;
                                // $('#btnupdcc').attr('disabled',false);
                                // $('#btnupdcc').html('Update'); 
                            }else{
                                _this.$refs.formCC.reset();  
                                //_this.modals.cardsetup = false;
                                // _this.modals.cardupdate = false;
                                // _this.cardretrychargeTitle = response.title;
                                // _this.cardretrychargeTxt = response.msg;
                                // _this.modals.cardretrycharge = true;
                                _this.cleanCCform();
                                $('#btnupdcc').attr('disabled',false);
                                $('#btnupdcc').html('Update'); 
                                swal.fire({
                                    icon: "error",
                                    title: response.title,
                                    text: response.msg
                                });
                            }
                        },error => {
                            
                        });
                    }
                });
            });
        },
        processUpdateCard(action) {
            var _store = this.$store;
            var _this = this;
            var _act = action;

            return new Promise((resolve, reject) => {
              _stripe.createToken(_cardElement).then(function(result) {
                  if(result.error) {
                      //console.log(result.error.message);
                      $('#btnupdcc').html('Update');
                      $('#btnupdcc').attr('disabled',false);
                      $('#btnUpdateAndCharge').html('save and charge amount due');
                      $('#btnUpdateAndCharge').attr('disabled',false);
                      $('#btnRetryExistCard').html('Retry charge with existing card');
                      $('#btnRetryExistCard').attr('disabled', false);
                      $('#carderror').html('<small style="color:red !important;"><sup>*</sup>' + result.error.message + '</small>');
                      $('.card-border').addClass('error-border');
                      $('#carderror').show();
                  }else{
                      $('#carderror').hide();
                      $('.card-border').removeClass('error-border');
                      _tokenid = result.token.id;
                      _store.dispatch('processUpdateCard', {
                          tokenid: _tokenid,
                          cardholder: _this.cardholdername,
                          address: _this.billingaddress,
                          city: _this.city,
                          state: _this.selects.state,
                          country: _this.selects.country,
                          zip: _this.zipcode,
                          usrID: _this.ClientActiveID,
                          companyParentID: _this.companyID,
                          action: _act,
                          document_type: DOCUMENTS.DEFAULT_CLIENT,
                      }).then(response => {
                          //console.log(response.result)
                          if(response.result == 'success' && response.msg != '') {
                            _this.$refs.formCC.reset();  
                            _this.modals.cardsetup = false;
                            _this.GetClientList();
                            $('#btnupdcc').attr('disabled',false);
                            $('#btnupdcc').html('Update'); 
                            $('#btnRetryExistCard').html('Retry charge with existing card');
                            $('#btnRetryExistCard').attr('disabled',false);
                            $('#btnUpdateAndCharge').html('save and charge amount due');
                            $('#btnUpdateAndCharge').attr('disabled', false);
                            swal.fire({
                                icon: "success",
                                title: response.title,
                                text: response.msg
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    // Refresh the page when the user clicks "OK"
                                    // location.reload();
                                }
                            });
                            // _this.modals.cardupdate = true;
                            // _this.modals.cardretrycharge = false;
                            // $('#btnupdcc').attr('disabled',false);
                            // $('#btnupdcc').html('Update'); 
                          }else {
                            _this.$refs.formCC.reset();  
                            //_this.modals.cardsetup = false;
                            // _this.modals.cardupdate = false;
                            // _this.cardretrychargeTitle = response.title;
                            // _this.cardretrychargeTxt = response.msg;
                            // _this.modals.cardretrycharge = true;
                            _this.cleanCCform();
                            $('#btnupdcc').attr('disabled',false);
                            $('#btnupdcc').html('Update'); 
                            $('#btnRetryExistCard').html('Retry charge with existing card');
                            $('#btnRetryExistCard').attr('disabled',false);
                            $('#btnUpdateAndCharge').html('save and charge amount due');
                            $('#btnUpdateAndCharge').attr('disabled', false);
                            swal.fire({
                              icon: "error",
                              title: response.title,
                              text: response.msg
                            });
                          }
                      },error => {
                          
                      });
                  }
              });
            });
        },
        initstripelib() {
            var chkload = this.$global.stripescriptload;
            if (chkload === false) {
                this.$global.initStripeScriptLoad(true);
                $.getScript( "https://js.stripe.com/v3/" )
                .done(function( script, textStatus ) {
                    initcreditcard();
                })
                .fail(function( jqxhr, settings, exception ) {
                    //$( "div.log" ).text( "Triggered ajaxError handler." );
                });
            }else{
                initcreditcard();
            }
        
        },
        cleanCCform() {
          this.cardholdername = '';
          this.billingaddress = '';
          this.city = '';
          this.selects.state = '';
          this.zipcode = '';
          this.agreeTerm = false;
          this.$refs.formCC.reset();  
        //   this.currCardHolder = '';
        //   this.currCardlastdigit = '';
        //   this.currCardType = '';
          if (typeof(_cardElement) == "undefined") {
            this.cardfailetoload = true;
          }else{
            _cardElement.clear();
          }
        },
        getStateList() {
            this.$store.dispatch('getStateList').then(response => {
                this.selects.statelist = response.params
            },error => {
                
            });
        },

        getCardInfo(_usrID) {
            this.$store.dispatch('getCardInfo', {
                    usrID: _usrID,
            }).then(response => {
               //console.log(response.params);
               this.btncardupdate = false;
               if (response.params != '') {
                    this.currCardHolder = (response.params.name != null)?response.params.name:''
                    this.currCardlastdigit = (response.params.last4 != null)?response.params.last4:''
                    this.currCardType = (response.params.brand != null)?response.params.brand:''
                    this.btncardupdate = true;
               } else {
                    this.currCardHolder = ''
                    this.currCardlastdigit =''
                    this.currCardType = ''
               }
               this.modals.cardsetup = true;
            },error => {
                
            });
        },
        onExpandClick(row){
            this.rowClicked(row);
        },
        checkModuleChanges(prevModules, currentModules){
            const changedModules = currentModules.reduce((acc, current) => {
                const prev = prevModules.find(prev => prev.type === current.type);

                if (prev && prev.status === true && current.status === false) {
                acc.push({ type: current.type });
                }

                return acc;
            }, []);

            return changedModules;
        },
        handleFormatCurrency(type, field){
            const validInput = /^[0-9]*(\.[0-9]*)?$/;
            const isLeadsPerDay = field == 'LeadspeekLeadsPerday' || field == 'LocatorLeadsPerday' || field == 'EnhanceLeadsPerday' || field == 'B2bLeadsPerday'

            if(!validInput.test(this[field])){
                this[field] = 0
            }

            if(isLeadsPerDay){
                if(this[field] == '0' || this[field] == ""){
                    this[field] = 1
                }
            }

            if(field == 'EnhanceLeadsPerday' || field == 'B2bLeadsPerday'){
                this.validateMinLead(field)
            }

            if(type == 'simplifi'){
                if(field == 'SimplifiMaxBid'){
                    this.validateMinimumInput('blur', 'maxBid')
                }else if(field == "SimplifiDailyBudget"){
                    this.validateMinimumInput('blur', 'dailyBudget')
                }
            }

            const formatNumber = formatCurrencyUSD(this[field])
            this[field] = formatNumber
            this.set_fee(type, field)
        },
        restrictInput(event) {
            const input = event.target.value;
            const char = event.key;

            if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) {
                return; 
            }

            if (!char.match(/[0-9]/) && char !== '.') {
                event.preventDefault();
            }

            // Allow only one period
            if (char === '.' && input.includes('.')) {
                event.preventDefault();
            }
        },
        exportDataClient(){
            const userData = this.$store.getters.userData;
            let search = ''
            let orderBy = ''
            let sortBy = ''

            if(this.currSortBy){
                sortBy = '/' + this.currSortBy
            }
            if(this.currOrderBy){
                orderBy = '/' + this.currOrderBy
            }
            if(this.searchQuery){
                search = '/' + this.searchQuery
            }

            const url = `${process.env.VUE_APP_DATASERVER_URL}/configuration/clients-report/download/${userData.company_id}${sortBy}${orderBy}${search}?CardStatus=${encodeURIComponent(JSON.stringify(this.filters.cardStatus))}&CampaignStatus=${encodeURIComponent(JSON.stringify(this.filters.campaignStatus))}`;

            downloadFileInBackground(url, 'clients.csv')
        },
        validateClickFunnelsFields(_slug) {
            const { subdomain, workspaceId } = this.clickfunnels;
            const apiKey = this.userApiKey[_slug];

            let missingFields = [];

            if (apiKey.trim() === "") missingFields.push("API Key");
            if (subdomain.trim() === "") missingFields.push("Subdomain");
            if (workspaceId.trim() === "") missingFields.push("Workspace ID");

            if (missingFields.length > 0) {
                this.$notify({
                    type: 'primary',
                    message: `Please fill in the following fields: ${missingFields.join(', ')}`,
                    icon: 'fas fa-exclamation-circle'
                });

                $('#btnSaveIntegration').attr('disabled', false);
                $('#btnSaveIntegration').html('Save');

                return true;
            }

            return false;
        },
         handleCheckItemCustomFields(type, name, module){
            const handleModule = () => {
                switch (module) {
                    case 'b2b':
                    return 'b2b';
                    case 'advance':
                    return 'advance'
                    default:
                    return ''
                }
            }

            const listValueIntegration = this[`listValueFieldsIntegration${type}${handleModule()}`];
            const isChecked = listValueIntegration.includes(name);

            const listAll = this.customFieldsBySlug[type.toLowerCase()].filter(item => item.type == module).map(item => item.name)
            
            MessageBox.confirm(
                isChecked 
                    ? `Unchecking "${name}" will stop sending this data to your CRM. Are you sure?` 
                    : `Checking "${name}" will create this custom field in your CRM, and start sending this data. Are your sure?`,
                'Warning',
                {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }
            ).then(() => {
                const capitalizedModule = module.charAt(0).toUpperCase() + module.slice(1);
        
                if (isChecked) {
                    this[`listValueFieldsIntegration${type}${handleModule()}`] = listValueIntegration.filter(item => item !== name);
                    this[`isCheckAllIntegration${capitalizedModule}`] = false;
                } else {
                    this[`listValueFieldsIntegration${type}${handleModule()}`].push(name);

                    if(this[`listValueFieldsIntegration${type}${handleModule()}`].length == listAll.length){
                        this[`isCheckAllIntegration${capitalizedModule}`] = true;
                    }
                }
            }).catch(() => {
                return;
            });
        },
        hasChangedArray(prevData, currentData){

            if(prevData == undefined || currentData == undefined){
                return true;
            }

            if (prevData.length !== currentData.length) {
                return true;
            }

            // Check each element in the array
            for (let i = 0; i < prevData.length; i++) {
                if (prevData[i] !== currentData[i]) {
                    return true; // Return true if any element is different
                }
            }

            // Return false if all elements are the same
            return false;
        },
        getCustomFieldsByType(type, fields, filteredList) {
            const listCustomFields = fields
                .filter(item => item.type === type)
                .map(item => item.name);

            return filteredList.filter(item => listCustomFields.includes(item));
        },
        handleDefaultLogsCustomFields(name) {
            this[`prevListValueFieldsIntegration${name}`] = [];
            this[`prevListValueFieldsIntegration${name}b2b`] = [];
            this[`prevListValueFieldsIntegration${name}advance`] = [];

            const listDisabledCustomFields = (this.customFieldsBySlug[name.toLowerCase()] || []).filter(item => item.disabled).map(item => item.name);
            const filteredListGeneral = (this[`listValueFieldsIntegration${name}`] || []).filter(item => !listDisabledCustomFields.includes(item));
            const filteredListB2b = (this[`listValueFieldsIntegration${name}b2b`] || []).filter(item => !listDisabledCustomFields.includes(item));
            const filteredListAdvance = (this[`listValueFieldsIntegration${name}advance`] || []).filter(item => !listDisabledCustomFields.includes(item));

            this[`prevListValueFieldsIntegration${name}`] = filteredListGeneral;
            this[`prevListValueFieldsIntegration${name}b2b`] = filteredListB2b;
            this[`prevListValueFieldsIntegration${name}advance`] = filteredListAdvance;
        },
        handleCustomFieldsEmpty(integrations, name) {
            const integrationsItem = integrations.data.find(item => item.integration_slug === name.toLowerCase());

            if(!integrationsItem){
                const listCustomFieldsGeneral = (this.customFieldsBySlug[name.toLowerCase()] || []).filter(field => field.type === 'general').map(item => item.name)
                const listCustomFieldsB2b = (this.customFieldsBySlug[name.toLowerCase()] || []).filter(field => field.type === 'b2b').map(item => item.name)
                const listCustomFieldsAdvance = (this.customFieldsBySlug[name.toLowerCase()] || []).filter(field => field.type === 'advance').map(item => item.name)

                this[`listValueFieldsIntegration${name}`] = listCustomFieldsGeneral
                this[`listValueFieldsIntegration${name}b2b`] = listCustomFieldsB2b
                this[`listValueFieldsIntegration${name}advance`] = listCustomFieldsAdvance
            }
        },
        handleFilterListCustomFields(name) {
            const listDisabledCustomFields = this.customFieldsBySlug[name.toLowerCase()].filter(item => item.disabled).map(item => item.name)
            const filteredListGeneral = this[`listValueFieldsIntegration${name}`].filter(item => !listDisabledCustomFields.includes(item));
            const filteredListB2b = this[`listValueFieldsIntegration${name}b2b`].filter(item => !listDisabledCustomFields.includes(item));
            const filteredListAdvance = this[`listValueFieldsIntegration${name}advance`].filter(item => !listDisabledCustomFields.includes(item));

            return { filteredListGeneral, filteredListB2b, filteredListAdvance }
        },
        updateWindowWidth() {
            this.windowWidth = window.innerWidth;
        },
        async handleCheckAllCustomFields(value, slug, type){
            const handleType = () => {
                switch (type) {
                    case 'general':
                        return 'General';
                    case 'b2b':
                        return 'B2b';
                    case 'advance':
                        return 'Advance';
                    default:
                        return '';
                }
            }

            const listAll = this.customFieldsBySlug[slug.toLowerCase()].filter(item => item.type == type).map(item => item.name)
            const stillChecked = this.customFieldsBySlug[slug.toLowerCase()]
            .filter(item => item.disabled && item.type == type)
            .map(item => item.name);

           await MessageBox.confirm(
                !value 
                    ? `Unchecking "all" will stop sending this data to your CRM. Are you sure?` 
                    : `Checking "all" will create this custom field in your CRM, and start sending this data. Are your sure?`,
                'Warning',
                {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }
            ).then(() => {
                const typeRewrite = handleType() == 'General' ? '' : handleType().toLowerCase();

                if (value) {
                    this[`listValueFieldsIntegration${slug}${typeRewrite}`] = listAll;
                    this[`isCheckAllIntegration${handleType()}`] = true;
                } else {
                    this[`listValueFieldsIntegration${slug}${typeRewrite}`] = stillChecked;
                    this[`isCheckAllIntegration${handleType()}`] = false;
                }
            }).catch(() => {
                return;
            });
        },
        handleDefaultCheckAllCustomFields(type, slug){
            if (this.customFieldsBySlug[slug.toLowerCase()] !== null && this.customFieldsBySlug[slug.toLowerCase()] !== '') {
                const stillChecked = this.customFieldsBySlug[slug.toLowerCase()]
                .filter(item => item.type == type.toLowerCase())
                .map(item => item.name);

                const rewriteType = type.toLowerCase() == 'general' ? '' : type.toLowerCase();

                if(stillChecked.length == this[`listValueFieldsIntegration${slug}${rewriteType}`].length){
                    this[`isCheckAllIntegration${type}`] = true;
                } else {
                    this[`isCheckAllIntegration${type}`] = false;
                }
            }
        },
        onInput(input, field) {
            if (input == "0") {
               this[field] = 1
            }
        },
        validateConfiguration(data) {
            // console.log('validateConfiguration', { data });
            const notifyError = (message) => {
                this.$notify({
                    type: 'primary',
                    icon: 'fas fa-exclamation-circle',
                    message
                });
            };

            const rules = {
                sendgrid: () => {
                    if (!data.api_key || data.api_key.trim() === '') {
                        notifyError('API Key is required');
                        return false;
                    }
                    return true;
                },
                gohighlevel: () => {
                    const version = this.integrationVersion.gohighlevel;
                    if (version == 1) {
                        if (!data.api_key || data.api_key.trim() === '') {
                            notifyError('API Key is required');
                            return false;
                        }
                    } else {
                        if (!this.ghlV2Connected) {
                            notifyError('Please connect account first');
                            return false;
                        }
                    }
                    return true;
                },
                zapier: () => {
                    if (
                        !Array.isArray(data.api_key) ||
                        data.api_key.length === 0 ||
                        data.api_key.some(key => !key || key.trim() === '')
                    ) {
                        notifyError('Url is required');
                        return false;
                    }
                    return true;
                },
                mailboxpower: () => {
                    if (!data.api_key || data.api_key.trim() === '') {
                        notifyError('API Key is required');
                        return false;
                    }
                    return true;
                },
                kartra: () => {
                    if (!data.api_key || data.api_key.trim() === '') {
                        notifyError('API Key is required');
                        return false;
                    }
                    if (!this.kartraApiPassword || this.kartraApiPassword.trim() === '') {
                        notifyError('Password is required');
                        return false;
                    }
                    return true;
                },
                agencyzoom: () => {
                    if (
                        !Array.isArray(data.api_key) ||
                        data.api_key.length === 0 ||
                        data.api_key.some(key => !key || key.trim() === '')
                    ) {
                        notifyError('Url is required');
                        return false;
                    }
                    return true;
                },
            };

            if (rules[data.integration_slug]) {
                return rules[data.integration_slug]();
            }

            return true;
        }

    },

    mounted() {
        const userData = this.$store.getters.userData;
        this.companyID = userData.company_id;
         _sppubkey = this.$global.sppubkey;
         _this = this;
        this.selectsPaymentTerm.PaymentTerm = this.$global.rootpaymentterm;

        const protectAccessMenu = () => {
            if(!this.$global.stripeaccountconnected) {
                this.$router.push({ name: 'General Setting' });
                return;
            }
        }
        protectAccessMenu();
        
        if(this.$global.idsys == this.$global.masteridsys) {
            this.getMinimumValueSimplifi();
        }

        this.GetClientList();
        this.cardfailetoload = false;
        this.moduleAgency = this.$global.agencyfilteredmodules

        this.customsidebarleadmenu = this.$global.agencyfilteredmodules;
        // console.log({'customsidebarleadmenu': this.customsidebarleadmenu});
        

        this.selectedModulesCreate = this.initializeSelectedModules




        if (typeof(_sppubkey) == "undefined" || _sppubkey == "") {
            this.cardfailetoload = true;
        }else{
            this.initstripelib();
        }
        this.getStateList();
        this.reset();
        
        $('.phonenum input').usPhoneFormat({
            format: 'xxx-xxx-xxxx',
        });

        const sidebarAgency = this.$global.agency_side_menu && this.$global.agency_side_menu.find(menu => menu.type == 'b2b')
        if((this.$global.globalModulNameLink.b2b.name == null && this.$global.globalModulNameLink.b2b.url == null) || (sidebarAgency && !sidebarAgency.status)){            
            this.isHideB2b = true;
        }

        const sidebarAgencyAdvance = this.$global.agency_side_menu && this.$global.agency_side_menu.find(menu => menu.type == 'enhance')
        if((this.$global.globalModulNameLink.enhance.name == null && this.$global.globalModulNameLink.enhance.url == null) || (sidebarAgencyAdvance && !sidebarAgencyAdvance.status)){
            this.isHideAdvance = true;
        }

        this.getCustomIntegrations();
        this.ghlv2GetListSubAccounts();

        window.addEventListener("resize", this.updateWindowWidth);
    },

    watch: {
        'modals.integrations': function(newValue) {
            this.selects.ghlv2SubAccount = '';
        },
        'modals.whitelist': function(newValue) {
            if(!newValue) {
                this.supressionProgress = [];
                clearTimeout(this.supressionTimeout);
                clearInterval(this.supressionInterval);
            }
        },
        'modals.pricesetup': function(newValue) {
            if(newValue){
                this.$nextTick(() => {
                    if (this.moduleAgency.local != undefined) {
                        this.selectsAppModule.AppModuleSelect = 'LeadsPeek';
                    } else if (this.moduleAgency.locator != undefined) {
                        this.selectsAppModule.AppModuleSelect = 'locator';
                    } else if (this.moduleAgency.enhance != undefined) {
                        this.selectsAppModule.AppModuleSelect = 'enhance';
                    } else if(this.moduleAgency.b2b != undefined) {
                        this.selectsAppModule.AppModuleSelect = 'b2b';
                    } else if(this.moduleAgency.simplifi != undefined) {
                        this.selectsAppModule.AppModuleSelect = 'simplifi';
                    }
                });
            }
        },
        
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        // searchQuery(value) {
        //     let result = this.tableData;
        //     var temp = Array();
        //     if (value !== '') {
        //         result = this.fuseSearch.search(this.searchQuery);
        //         for(let i=0;i<result.length;i++) {
        //             temp.push(result[i].item);
        //             //console.log(result[i].item);
        //         }

        //         if (result.length == 0) {
        //             if (this.tableData.length > 0) {
        //                 this.tableDataOri = [];
        //                 this.tableDataOri = this.tableData;
        //             }
        //             this.tableData = [];
        //         }
                
        //     }else{
        //         this.tableData = this.tableDataOri;
        //     }
        //     this.searchedData = temp;
        // }
    },
    
    beforeDestroy() {
        window.removeEventListener("resize", this.updateWindowWidth);
        
        // hapus event scroll dari select sub account ghl 
        const dropdownAdd = this.$refs.selectGhlV2SubAccountAdd.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
        const dropdownEdit = this.$refs.selectGhlV2SubAccountEdit.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
        if (dropdownAdd) {
            dropdownAdd.removeEventListener('scroll', this.handleScrollGhlV2SubAccount);
        }
        if (dropdownEdit) {
            dropdownEdit.removeEventListener('scroll', this.handleScrollGhlV2SubAccount);
        }
    }
}

function initcreditcard() {
  if (!$('#card-element').length) {
    return
  }
	_stripe = Stripe(_sppubkey);
	/** ATTACHED CARD ELEMENTS */
   _elements = _stripe.elements();
    _cardElement = _elements.create('card', {
    hidePostalCode: true,    
    style: {
        base: {
                color: 'rgba(82, 95, 127, 0.8)',
                fontSize: '16px',
                fontFamily: '"Open Sans", sans-serif',
                fontSmoothing: 'antialiased',
                '::placeholder': {
                  color: 'rgba(82, 95, 127, 0.3)',
                },
            },
            invalid: {
                color: '#e5424d',
                ':focus': {
                  color: 'rgba(82, 95, 127, 0.3)',
                },
            },
        },
    });

    _this.cardfailetoload = false;
    
    if (typeof(_cardElement) == "undefined") {
      _this.cardfailetoload = true;
    }
    //var cardElement = elements.create('card');
    _cardElement.mount('#card-element');
    /** ATTACHED CARD ELEMENTS */

    /** CARD ELEMENT VALIDATION */
    _cardElement.on('change', function(event) {
        if (event.error) {
          console.log('Card Error :' + event.error.message);
          $('#carderror').html('<small style="color:red !important;"><sup>*</sup>' + event.error.message + '</small>');
          $('#carderror').show();
          $('.card-border').addClass('error-border');
        } else {
          $('#carderror').hide();
            $('.card-border').removeClass('error-border');
        }
    });

	
}

</script>

<style scoped>
/* FOR DIVIDER IN GHL VERSION 2 */
.divider-ghl2 {
    border-top: 1px solid #dcdfe6;
    padding-top: 1rem;
    margin-top: 1rem;
    margin-left: 0px;
    border-left: none;
}
@media (min-width: 768px) {
    .divider-ghl2 {
        border-left: 1px solid #dcdfe6;
        border-top: none;
        padding-top: 0;
        margin-top: 0;
        margin-left: -2px;
    }
}
/* FOR DIVIDER IN GHL VERSION 2 */

/* FOR INPUT COST PER LEAD AND INPUT LEADS PER DAY */
@media (min-width: 768px) {
    .inputCostPerContact {
        margin-top: 23px;
    }
    .checkboxEnableMinimumLeadsPerDay {
        margin-top: -5px;
    }
}
/* FOR INPUT COST PER LEAD AND INPUT LEADS PER DAY */
</style>
<style>
.sj-quicksend-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
}
.sj-quicksend-item {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  transition: all .15s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.sj-quicksend-item img { width: 100%; height: 100px; object-fit: cover; }
.sj-quicksend-item .sj-quicksend-name { padding: 6px; font-size: 12px; text-align: center; width: 100%; }
.sj-quicksend-item.selected { border-color: #409EFF; box-shadow: 0 0 0 2px rgba(64,158,255,.2); }
.sj-quicksend-empty { color: #6b7280; font-size: 12px; }
.error-input-price-simplifi {
  border: 1px solid #942434 !important;
}

.error-message-price-simplifi {
  color:#942434;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 4px;
  display: flex;
  word-wrap: break-word; 
  white-space: normal; 
  text-align: left;
}

#modalSetCard .select-primary.el-select .el-input input {
     color: rgba(82, 95, 127, 0.8);
}

#modalSetCard .form-control {
    color: rgba(82, 95, 127, 0.8);
    border: 1px solid #525f7f;
}

#modalSetCard {
    /*top:-10%;*/
}

#modalSetCard .card-border {
  width: 95% !important;
  left: 15px;
  line-height: 1.5;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #525f7f;
  border-radius:4px;
  padding: 8px 12px 6px 12px;
  margin:8px 0px 4px -1px;
  height:36px;
  box-sizing: border-box;
  transform: translateZ(0);
  -webkit-user-select:text;
}

.card-border.error-border {
    border: 1px solid red !important;
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.5);
}

#modalSetPrice input:read-only {
    background-color: white;
}

#modalSetPrice .el-input__prefix, #modalSetPrice .el-input__suffix {
    color: #525f7f;
}

#modalSetPrice .leadlimitdate {
    width: auto !important;
}

#modalSetPrice .el-input__inner {
    background-color: transparent;
    border-width: 1px;
    border-color: #2b3553;
    color: #942434;
}

.frmSetCost .input-group .input-group-prepend .input-group-text i {
    color: #525f7f;
}

.frmSetCost .input-group input[type=text], .frmSetCost input[type=text],.frmSetCost .input-group .input-group-prepend .input-group-text {
    color: #525f7f;
    border-color: #525f7f;
}
.black-center input[type=text] {
    color: #525f7f;
    text-align: center;
}
.clickable-rows td {
    cursor: pointer;
}
/* .clickable-rows .el-table, .el-table__expanded-cell {
    background-color:#1e1e2f;
} */
.clickable-rows tr .el-table__expanded-cell {
    cursor: default;
}

/* .iconcampaign {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    margin-right: 5px;
} */

/* .iconcampaign {
    padding-inline: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    border-radius: 8px;
} */

/* .iconcampaign + .iconcampaign {
  margin-left: 5px;
} */

.cmpActive {
    background-color: green; /* You can change the background color as needed */
}

.cmpPauseStop {
    background-color: #646769; /* You can change the background color as needed */
}

.icons-container {
    display: inline-flex;
    gap: 5px;
    line-height: normal;
}
.integratios-list-wrapper{
    gap:8px;
}
.integrations__modal-item-wrapper {
    min-height: 100px;
    max-height: 100px;
    border-radius: 8px;
    cursor: pointer;
    box-sizing: border-box;
    padding:16px;
}
.integrations__modal-item{
    width:96px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
}
/* .integrations__modal-item.--active{
    
} */
.integrations__modal-item-wrapper:hover{
    background-color: #5e72e4 !important;
    color: #f4f5f7 !important;
}
.integrarion-brand-name{
    font-size:12px;
    line-height:16px;
    font-weight:400px;
}
.integrations-modal-footer-wrapper{
    padding:12px 24px;
    width: 100%;
}
.integrations-modal-footer-wrapper .d-flex{
    gap:16px;
}
.financial-modules-wrapper .financial-modules-item{
    font-size: 1.2rem;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s ease;
}
.client-payment-modal-form-label{
    color:#222a42 !important;
    font-size:16px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 8px;
    display: block;
}
.client-payment-modal-form-helper-text{
    color:#6b7280 !important;
    font-size:12px;
    font-weight: 400;
    line-height: 12px;
    margin-top: 4px;
    display: block;
}
.client-payment-setup-form-wrapper{
    display: flex;
    flex-direction: column;
    gap: 0px;
}

.campaign-cost-input.form-group .form-control:not(.has-danger){
    border: none !important;
}
.campaign-cost-input.el-date-editor .el-input__inner{
    border-color: black;
}
.campaign-cost-input.el-date-editor .el-input__inner:hover{
    border-color:var(--red);
}
.campaign-cost-input.form-group{
       border:1px solid black;
        color: #525f7f;
        border-radius: 4px;
  
}
.campaign-cost-input.form-group:hover{
      border-color:var(--red);
  
}
.campaign-cost-input .input-group .input-group-text{
    border: none;
        color: #525f7f;

}
.campaign-cost-input{
    border: none;
}

.dropdown-hidden {
  display: none !important;
}

.menu__prices {
  padding: 8px 16px;
  border-radius: 4px;
  color: gray;
  cursor: pointer;
  font-weight: 600;
  font-size: 18px;
  border: 1px solid transparent;
  transition: border 300ms ease;
}

.active__menu__prices {
  color: black;
  border: 1px solid #222a42;
}

.country-region-select-wrapper {
    margin-bottom: 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.country-region-select-wrapper .country-label {
    font-size: .80143rem;
    margin-bottom: 5px;
    display: block;
}

.country-region-select-wrapper .country-region-select {
    background: transparent;
    width: 100%;
    border: none;
    padding: 10px 18px;
    border-radius: 6px;
    border: 1px solid var(--input-border-color);
    outline: none !important;
    color: var(--primary-input-text-color);
}

.country-region-select-wrapper .country-region-select option{
    padding: 10px 18px;
    color: black !important;
}

.input__client__management .el-input__inner {
    padding-left: 30px;
    padding-right: 30px;
}

.client__management__card__credit {
    width: 50%;
    margin: 0 auto;
}

.add-webhook-url{
    height: 40px;
    width: 40px;
    background: gray;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    color: white;
}
.webhook-url-wrapper{
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;
}

.checkbox-field-integration {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.error-banner {
    padding: 8px 16px;
    background-color: #ffe6e6; /* Light red background for error */
    border-radius: 4px;
    border-left: 5px solid #dc3545; /* Red border for error */
    margin: 20px 0;
    font-size: 14px;
    color: #721c24; /* Darker red text for readability */
    line-height: 1.5em;
}

.error-banner p {
    margin: 0;
}

.logo-wrap-client-management {
  height: 36px;
  width: auto;
  max-width: 160px;
  object-fit: contain;
  flex-shrink: 0;
}

.tag__custom {
    padding: 0 6px 16px 6px;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 11px;
    height: 16px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid transparent;
    font-weight: bold;
}

.tooltip-content {
  max-width: 300px;
  white-space: normal;
  word-break: break-word;
}



@media (max-width: 992px) {
    .client__management__card__credit {
        width: 75%;
    }
}

@media (max-width: 768px) {
  .checkbox-field-integration {
    grid-template-columns: repeat(2, 1fr);
  }
}


@media (max-width: 576px) {
    .client__management__card__credit {
        width: 100%;
    }
}

@media (max-width: 469px) {
    .integratios-list-wrapper {
        justify-content: center;
    }
    .checkbox-field-integration {
        grid-template-columns: repeat(1, 1fr); 
    }
}
</style>